import { defineComponent as Oa, computed as b, watch as le, h as ur, inject as pe, onMounted as He, onUpdated as js, onBeforeUnmount as Ia, reactive as _n, readonly as kn, resolveComponent as L, openBlock as _, createElementBlock as M, createVNode as E, withCtx as P, createTextVNode as ge, toDisplayString as K, normalizeClass as be, createElementVNode as $, renderSlot as Ne, createBlock as W, createSlots as Mo, withDirectives as Zt, normalizeStyle as je, vShow as Ea, createStaticVNode as xa, Fragment as ke, createCommentVNode as q, renderList as ot, getCurrentScope as ka, onScopeDispose as Da, toRef as Ma, customRef as Us, ref as U, toValue as Le, watchEffect as Hs, getCurrentInstance as Po, resolveDynamicComponent as yn, unref as H, effectScope as Vs, nextTick as Pe, shallowRef as pr, toRaw as Fs, markRaw as zs, defineAsyncComponent as G, Suspense as Ws, useCssVars as Pa, withModifiers as oo, toRefs as Lo, isRef as Gs, provide as vn, onUnmounted as La, withKeys as hr } from "vue";
import fr from "axios";
import Ys, { useVuelidate as Ra } from "@vuelidate/core";
import Ba from "vuedraggable";
const ja = Symbol("wormhole");
function Ua() {
  const e = pe(ja);
  if (!e)
    throw new Error(`
    [portal-vue]: Necessary Injection not found. Make sur you installed the plugin properly.`);
  return e;
}
const Ha = typeof window < "u";
function Zs(e, t) {
  return e.map((n, o) => [o, n]).sort(function(n, o) {
    return t(n[1], o[1]) || n[0] - o[0];
  }).map((n) => n[1]);
}
function Xs(e, t) {
  const n = Ua();
  function o() {
    if (!Ha)
      return;
    const { to: r, name: i, order: s } = e;
    t.default ? n.open({
      to: r,
      from: i,
      order: s,
      content: t.default
    }) : a();
  }
  function a(r) {
    n.close({
      to: r ?? e.to,
      from: e.name
    });
  }
  He(() => {
    e.disabled || o();
  }), js(() => {
    e.disabled ? a() : o();
  }), Ia(() => {
    a();
  }), le(
    () => e.to,
    (r, i) => {
      e.disabled || (i && i !== r && a(i), o());
    }
  );
}
const Ks = Oa({
  compatConfig: { MODE: 3 },
  name: "portal",
  props: {
    disabled: { type: Boolean },
    name: { type: [String, Symbol], default: () => Symbol() },
    order: { type: Number },
    slotProps: { type: Object, default: () => ({}) },
    to: {
      type: String,
      default: () => String(Math.round(Math.random() * 1e7))
    }
  },
  setup(e, { slots: t }) {
    return Xs(e, t), () => e.disabled && t.default ? t.default(e.slotProps) : null;
  }
}), qs = (e, { slots: t }) => {
  var n;
  return (n = t.default) == null ? void 0 : n.call(t);
}, ro = Oa({
  compatConfig: { MODE: 3 },
  name: "portalTarget",
  props: {
    multiple: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    slotProps: { type: Object, default: () => ({}) }
  },
  emits: ["change"],
  setup(e, { emit: t, slots: n }) {
    const o = Ua(), a = b(
      () => {
        const r = o.getContentForTarget(
          e.name,
          e.multiple
        ), i = n.wrapper, s = r.map((c) => c.content(e.slotProps)), l = i ? s.flatMap(
          (c) => c.length ? i(c) : []
        ) : s.flat(1);
        return {
          vnodes: l,
          vnodesFn: () => l
        };
      }
    );
    return le(
      a,
      ({ vnodes: r }) => {
        const i = r.length > 0, s = o.transports.get(e.name), l = s ? [...s.keys()] : [];
        t("change", { hasContent: i, sources: l });
      },
      { flush: "post" }
    ), () => {
      var r;
      return a.value.vnodes.length ? [
        ur("div", {
          style: "display: none",
          key: "__portal-vue-hacky-scoped-slot-repair__"
        }),
        ur(qs, a.value.vnodesFn)
      ] : (r = n.default) == null ? void 0 : r.call(n);
    };
  }
});
function Qs(e = !0) {
  const t = _n(/* @__PURE__ */ new Map());
  function n(i) {
    if (!Ha)
      return;
    const { to: s, from: l, content: c, order: u = 1 / 0 } = i;
    if (!s || !l || !c)
      return;
    t.has(s) || t.set(s, /* @__PURE__ */ new Map());
    const d = t.get(s), p = {
      to: s,
      from: l,
      content: c,
      order: u
    };
    d.set(l, p);
  }
  function o(i) {
    const { to: s, from: l } = i;
    if (!s || !l)
      return;
    const c = t.get(s);
    !c || (c.delete(l), c.size || t.delete(s));
  }
  function a(i, s) {
    const l = t.get(i);
    if (!l)
      return [];
    const c = Array.from((l == null ? void 0 : l.values()) || []);
    return s ? Zs(
      c,
      (u, d) => u.order - d.order
    ) : [c.pop()];
  }
  const r = {
    open: n,
    close: o,
    transports: t,
    getContentForTarget: a
  };
  return e ? kn(r) : r;
}
const Js = Qs();
function el(e, t = {}) {
  t.portalName !== !1 && e.component(t.portalName || "Portal", Ks), t.portalTargetName !== !1 && e.component(t.portalTargetName || "PortalTarget", ro);
  const n = t.wormhole ?? Js;
  e.provide(ja, n);
}
const ve = "BASE_COLUMN", Xt = "LAYOUT_NODE_SINGLE_COLUMN", Kt = "LAYOUT_NODE_DOUBLE_COLUMN", qt = "LAYOUT_NODE_TRIPLE_COLUMN", Qt = "LAYOUT_NODE_QUADRUPLE_COLUMN", Nt = "LAYOUT_NODE_FULL_WIDTH_COLUMN", Jt = "LAYOUT_NODE_LEFT_SIDEBAR", en = "LAYOUT_NODE_RIGHT_SIDEBAR", Se = "LAYOUT_NODE_SHARED_CONTENT", At = "CONTENT_NODE_TEXT", mn = "CONTENT_NODE_HEADING", Dn = "CONTENT_NODE_IMAGE", ao = "CONTENT_NODE_CODE", io = "CONTENT_NODE_SPACER", Cn = "CONTENT_NODE_GALLERY", so = "CONTENT_NODE_VIDEO", lo = "CONTENT_NODE_SEPARATOR", co = "CONTENT_NODE_BUTTON", uo = "CONTENT_NODE_FORM", po = "CONTENT_NODE_QUOTE", wn = "CONTENT_NODE_SLIDER", $n = "CONTENT_NODE_CARD", ho = "CONTENT_NODE_TABLE", Ze = "CONTENT_NODE_ACCORDION", Re = "CONTENT_NODE_PANEL", Sn = "CONTENT_NODE_LIST", Nn = "CONTENT_NODE_NAVIGATION", tn = "CONTENT_NODE_SHARED_CONTENT_ERROR", dt = "layout", ut = "content", Ro = "sub_content", gr = "default", LS = "light", RS = "dark", Bo = [
  {
    name: "One Column",
    icon: "OneColumnIcon",
    type: Xt
  },
  {
    name: "Two Columns",
    icon: "TwoColumnsIcon",
    type: Kt
  },
  {
    name: "Three Columns",
    icon: "ThreeColumnsIcon",
    type: qt
  },
  {
    name: "Four Columns",
    icon: "FourColumnsIcon",
    type: Qt
  },
  {
    name: "Left Sidebar",
    icon: "LeftSidebarIcon",
    type: Jt
  },
  {
    name: "Right Sidebar",
    icon: "RightSidebarIcon",
    type: en
  },
  {
    name: "Full Width",
    icon: "FullWidthIcon",
    type: Nt
  }
].map((e) => ({ ...e, group: dt })), Mn = [
  {
    name: "Heading",
    icon: "HeadingIcon",
    type: mn
  },
  {
    name: "Text",
    icon: "TextIcon",
    type: At
  },
  {
    name: "Image",
    icon: "ImageIcon",
    type: Dn
  },
  {
    name: "Gallery",
    icon: "GalleryIcon",
    type: Cn
  },
  {
    name: "Slider",
    icon: "SliderIcon",
    type: wn
  },
  {
    name: "Code",
    icon: "EmbedIcon",
    type: ao
  },
  {
    name: "Video",
    icon: "VideoIcon",
    type: so
  },
  {
    name: "Accordion",
    icon: "AccordionIcon",
    type: Ze
  },
  {
    name: "Spacer",
    icon: "SpacerIcon",
    type: io
  },
  {
    name: "Separator",
    icon: "SeparatorIcon",
    type: lo
  },
  {
    name: "Card",
    icon: "CardIcon",
    type: $n
  },
  {
    name: "Table",
    icon: "TableIcon",
    type: ho
  },
  {
    name: "Quote",
    icon: "QuoteIcon",
    type: po
  },
  {
    name: "Form",
    icon: "FormIcon",
    type: uo
  },
  {
    name: "Button",
    icon: "ButtonIcon",
    type: co
  },
  {
    name: "List",
    type: Sn
  },
  {
    name: "Navigation",
    icon: "NavigationIcon",
    type: Nn
  },
  {
    name: "SharedContentError",
    icon: "",
    type: tn
  }
].map((e) => ({ ...e, group: ut, component: `${e.name}Node` })), Va = [
  {
    name: "Accordion Panel",
    component: "AccordionPanelNode",
    type: Re
  }
].map((e) => ({ ...e, group: Ro })), tl = [
  Sn
], nl = [
  tn
], Gt = {
  BLACK: "#000000",
  WHITE: "#ffffff",
  DARK: "#333333"
};
var pn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ol() {
  this.__data__ = [], this.size = 0;
}
var rl = ol;
function al(e, t) {
  return e === t || e !== e && t !== t;
}
var Pn = al, il = Pn;
function sl(e, t) {
  for (var n = e.length; n--; )
    if (il(e[n][0], t))
      return n;
  return -1;
}
var Ln = sl, ll = Ln, cl = Array.prototype, dl = cl.splice;
function ul(e) {
  var t = this.__data__, n = ll(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : dl.call(t, n, 1), --this.size, !0;
}
var pl = ul, hl = Ln;
function fl(e) {
  var t = this.__data__, n = hl(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var gl = fl, vl = Ln;
function ml(e) {
  return vl(this.__data__, e) > -1;
}
var bl = ml, _l = Ln;
function yl(e, t) {
  var n = this.__data__, o = _l(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var Cl = yl, wl = rl, $l = pl, Sl = gl, Nl = bl, Al = Cl;
function kt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
kt.prototype.clear = wl;
kt.prototype.delete = $l;
kt.prototype.get = Sl;
kt.prototype.has = Nl;
kt.prototype.set = Al;
var Rn = kt, Tl = Rn;
function Ol() {
  this.__data__ = new Tl(), this.size = 0;
}
var Il = Ol;
function El(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var xl = El;
function kl(e) {
  return this.__data__.get(e);
}
var Dl = kl;
function Ml(e) {
  return this.__data__.has(e);
}
var Pl = Ml, Ll = typeof pn == "object" && pn && pn.Object === Object && pn, Fa = Ll, Rl = Fa, Bl = typeof self == "object" && self && self.Object === Object && self, jl = Rl || Bl || Function("return this")(), Ve = jl, Ul = Ve, Hl = Ul.Symbol, Bn = Hl, vr = Bn, za = Object.prototype, Vl = za.hasOwnProperty, Fl = za.toString, Ht = vr ? vr.toStringTag : void 0;
function zl(e) {
  var t = Vl.call(e, Ht), n = e[Ht];
  try {
    e[Ht] = void 0;
    var o = !0;
  } catch {
  }
  var a = Fl.call(e);
  return o && (t ? e[Ht] = n : delete e[Ht]), a;
}
var Wl = zl, Gl = Object.prototype, Yl = Gl.toString;
function Zl(e) {
  return Yl.call(e);
}
var Xl = Zl, mr = Bn, Kl = Wl, ql = Xl, Ql = "[object Null]", Jl = "[object Undefined]", br = mr ? mr.toStringTag : void 0;
function ec(e) {
  return e == null ? e === void 0 ? Jl : Ql : br && br in Object(e) ? Kl(e) : ql(e);
}
var Dt = ec;
function tc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ke = tc;
const jn = /* @__PURE__ */ Xe(Ke);
var nc = Dt, oc = Ke, rc = "[object AsyncFunction]", ac = "[object Function]", ic = "[object GeneratorFunction]", sc = "[object Proxy]";
function lc(e) {
  if (!oc(e))
    return !1;
  var t = nc(e);
  return t == ac || t == ic || t == rc || t == sc;
}
var jo = lc, cc = Ve, dc = cc["__core-js_shared__"], uc = dc, qn = uc, _r = function() {
  var e = /[^.]+$/.exec(qn && qn.keys && qn.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function pc(e) {
  return !!_r && _r in e;
}
var hc = pc, fc = Function.prototype, gc = fc.toString;
function vc(e) {
  if (e != null) {
    try {
      return gc.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Wa = vc, mc = jo, bc = hc, _c = Ke, yc = Wa, Cc = /[\\^$.*+?()[\]{}|]/g, wc = /^\[object .+?Constructor\]$/, $c = Function.prototype, Sc = Object.prototype, Nc = $c.toString, Ac = Sc.hasOwnProperty, Tc = RegExp(
  "^" + Nc.call(Ac).replace(Cc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Oc(e) {
  if (!_c(e) || bc(e))
    return !1;
  var t = mc(e) ? Tc : wc;
  return t.test(yc(e));
}
var Ic = Oc;
function Ec(e, t) {
  return e == null ? void 0 : e[t];
}
var xc = Ec, kc = Ic, Dc = xc;
function Mc(e, t) {
  var n = Dc(e, t);
  return kc(n) ? n : void 0;
}
var mt = Mc, Pc = mt, Lc = Ve, Rc = Pc(Lc, "Map"), Uo = Rc, Bc = mt, jc = Bc(Object, "create"), Un = jc, yr = Un;
function Uc() {
  this.__data__ = yr ? yr(null) : {}, this.size = 0;
}
var Hc = Uc;
function Vc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Fc = Vc, zc = Un, Wc = "__lodash_hash_undefined__", Gc = Object.prototype, Yc = Gc.hasOwnProperty;
function Zc(e) {
  var t = this.__data__;
  if (zc) {
    var n = t[e];
    return n === Wc ? void 0 : n;
  }
  return Yc.call(t, e) ? t[e] : void 0;
}
var Xc = Zc, Kc = Un, qc = Object.prototype, Qc = qc.hasOwnProperty;
function Jc(e) {
  var t = this.__data__;
  return Kc ? t[e] !== void 0 : Qc.call(t, e);
}
var ed = Jc, td = Un, nd = "__lodash_hash_undefined__";
function od(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = td && t === void 0 ? nd : t, this;
}
var rd = od, ad = Hc, id = Fc, sd = Xc, ld = ed, cd = rd;
function Mt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Mt.prototype.clear = ad;
Mt.prototype.delete = id;
Mt.prototype.get = sd;
Mt.prototype.has = ld;
Mt.prototype.set = cd;
var dd = Mt, Cr = dd, ud = Rn, pd = Uo;
function hd() {
  this.size = 0, this.__data__ = {
    hash: new Cr(),
    map: new (pd || ud)(),
    string: new Cr()
  };
}
var fd = hd;
function gd(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var vd = gd, md = vd;
function bd(e, t) {
  var n = e.__data__;
  return md(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Hn = bd, _d = Hn;
function yd(e) {
  var t = _d(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Cd = yd, wd = Hn;
function $d(e) {
  return wd(this, e).get(e);
}
var Sd = $d, Nd = Hn;
function Ad(e) {
  return Nd(this, e).has(e);
}
var Td = Ad, Od = Hn;
function Id(e, t) {
  var n = Od(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var Ed = Id, xd = fd, kd = Cd, Dd = Sd, Md = Td, Pd = Ed;
function Pt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Pt.prototype.clear = xd;
Pt.prototype.delete = kd;
Pt.prototype.get = Dd;
Pt.prototype.has = Md;
Pt.prototype.set = Pd;
var Ho = Pt, Ld = Rn, Rd = Uo, Bd = Ho, jd = 200;
function Ud(e, t) {
  var n = this.__data__;
  if (n instanceof Ld) {
    var o = n.__data__;
    if (!Rd || o.length < jd - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Bd(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Hd = Ud, Vd = Rn, Fd = Il, zd = xl, Wd = Dl, Gd = Pl, Yd = Hd;
function Lt(e) {
  var t = this.__data__ = new Vd(e);
  this.size = t.size;
}
Lt.prototype.clear = Fd;
Lt.prototype.delete = zd;
Lt.prototype.get = Wd;
Lt.prototype.has = Gd;
Lt.prototype.set = Yd;
var Ga = Lt, Zd = mt, Xd = function() {
  try {
    var e = Zd(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Ya = Xd, wr = Ya;
function Kd(e, t, n) {
  t == "__proto__" && wr ? wr(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Vo = Kd, qd = Vo, Qd = Pn;
function Jd(e, t, n) {
  (n !== void 0 && !Qd(e[t], n) || n === void 0 && !(t in e)) && qd(e, t, n);
}
var Za = Jd;
function eu(e) {
  return function(t, n, o) {
    for (var a = -1, r = Object(t), i = o(t), s = i.length; s--; ) {
      var l = i[e ? s : ++a];
      if (n(r[l], l, r) === !1)
        break;
    }
    return t;
  };
}
var tu = eu, nu = tu, ou = nu(), Xa = ou, An = { exports: {} };
An.exports;
(function(e, t) {
  var n = Ve, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, r = a && a.exports === o, i = r ? n.Buffer : void 0, s = i ? i.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, p = s ? s(d) : new c.constructor(d);
    return c.copy(p), p;
  }
  e.exports = l;
})(An, An.exports);
var Ka = An.exports, ru = Ve, au = ru.Uint8Array, iu = au, $r = iu;
function su(e) {
  var t = new e.constructor(e.byteLength);
  return new $r(t).set(new $r(e)), t;
}
var Fo = su, lu = Fo;
function cu(e, t) {
  var n = t ? lu(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var qa = cu;
function du(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var Qa = du, uu = Ke, Sr = Object.create, pu = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!uu(t))
      return {};
    if (Sr)
      return Sr(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), hu = pu;
function fu(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Ja = fu, gu = Ja, vu = gu(Object.getPrototypeOf, Object), zo = vu, mu = Object.prototype;
function bu(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || mu;
  return e === n;
}
var Vn = bu, _u = hu, yu = zo, Cu = Vn;
function wu(e) {
  return typeof e.constructor == "function" && !Cu(e) ? _u(yu(e)) : {};
}
var ei = wu;
function $u(e) {
  return e != null && typeof e == "object";
}
var at = $u, Su = Dt, Nu = at, Au = "[object Arguments]";
function Tu(e) {
  return Nu(e) && Su(e) == Au;
}
var Ou = Tu, Nr = Ou, Iu = at, ti = Object.prototype, Eu = ti.hasOwnProperty, xu = ti.propertyIsEnumerable, ku = Nr(/* @__PURE__ */ function() {
  return arguments;
}()) ? Nr : function(e) {
  return Iu(e) && Eu.call(e, "callee") && !xu.call(e, "callee");
}, Wo = ku, Du = Array.isArray, it = Du, Mu = 9007199254740991;
function Pu(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Mu;
}
var ni = Pu, Lu = jo, Ru = ni;
function Bu(e) {
  return e != null && Ru(e.length) && !Lu(e);
}
var an = Bu, ju = an, Uu = at;
function Hu(e) {
  return Uu(e) && ju(e);
}
var Vu = Hu, Tn = { exports: {} };
function Fu() {
  return !1;
}
var zu = Fu;
Tn.exports;
(function(e, t) {
  var n = Ve, o = zu, a = t && !t.nodeType && t, r = a && !0 && e && !e.nodeType && e, i = r && r.exports === a, s = i ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || o;
  e.exports = c;
})(Tn, Tn.exports);
var Fn = Tn.exports, Wu = Dt, Gu = zo, Yu = at, Zu = "[object Object]", Xu = Function.prototype, Ku = Object.prototype, oi = Xu.toString, qu = Ku.hasOwnProperty, Qu = oi.call(Object);
function Ju(e) {
  if (!Yu(e) || Wu(e) != Zu)
    return !1;
  var t = Gu(e);
  if (t === null)
    return !0;
  var n = qu.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && oi.call(n) == Qu;
}
var ep = Ju, tp = Dt, np = ni, op = at, rp = "[object Arguments]", ap = "[object Array]", ip = "[object Boolean]", sp = "[object Date]", lp = "[object Error]", cp = "[object Function]", dp = "[object Map]", up = "[object Number]", pp = "[object Object]", hp = "[object RegExp]", fp = "[object Set]", gp = "[object String]", vp = "[object WeakMap]", mp = "[object ArrayBuffer]", bp = "[object DataView]", _p = "[object Float32Array]", yp = "[object Float64Array]", Cp = "[object Int8Array]", wp = "[object Int16Array]", $p = "[object Int32Array]", Sp = "[object Uint8Array]", Np = "[object Uint8ClampedArray]", Ap = "[object Uint16Array]", Tp = "[object Uint32Array]", ae = {};
ae[_p] = ae[yp] = ae[Cp] = ae[wp] = ae[$p] = ae[Sp] = ae[Np] = ae[Ap] = ae[Tp] = !0;
ae[rp] = ae[ap] = ae[mp] = ae[ip] = ae[bp] = ae[sp] = ae[lp] = ae[cp] = ae[dp] = ae[up] = ae[pp] = ae[hp] = ae[fp] = ae[gp] = ae[vp] = !1;
function Op(e) {
  return op(e) && np(e.length) && !!ae[tp(e)];
}
var Ip = Op;
function Ep(e) {
  return function(t) {
    return e(t);
  };
}
var Go = Ep, On = { exports: {} };
On.exports;
(function(e, t) {
  var n = Fa, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, r = a && a.exports === o, i = r && n.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(On, On.exports);
var Yo = On.exports, xp = Ip, kp = Go, Ar = Yo, Tr = Ar && Ar.isTypedArray, Dp = Tr ? kp(Tr) : xp, Zo = Dp;
function Mp(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var ri = Mp, Pp = Vo, Lp = Pn, Rp = Object.prototype, Bp = Rp.hasOwnProperty;
function jp(e, t, n) {
  var o = e[t];
  (!(Bp.call(e, t) && Lp(o, n)) || n === void 0 && !(t in e)) && Pp(e, t, n);
}
var ai = jp, Up = ai, Hp = Vo;
function Vp(e, t, n, o) {
  var a = !n;
  n || (n = {});
  for (var r = -1, i = t.length; ++r < i; ) {
    var s = t[r], l = o ? o(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), a ? Hp(n, s, l) : Up(n, s, l);
  }
  return n;
}
var sn = Vp;
function Fp(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var zp = Fp, Wp = 9007199254740991, Gp = /^(?:0|[1-9]\d*)$/;
function Yp(e, t) {
  var n = typeof e;
  return t = t ?? Wp, !!t && (n == "number" || n != "symbol" && Gp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ii = Yp, Zp = zp, Xp = Wo, Kp = it, qp = Fn, Qp = ii, Jp = Zo, eh = Object.prototype, th = eh.hasOwnProperty;
function nh(e, t) {
  var n = Kp(e), o = !n && Xp(e), a = !n && !o && qp(e), r = !n && !o && !a && Jp(e), i = n || o || a || r, s = i ? Zp(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || th.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Qp(c, l))) && s.push(c);
  return s;
}
var si = nh;
function oh(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var rh = oh, ah = Ke, ih = Vn, sh = rh, lh = Object.prototype, ch = lh.hasOwnProperty;
function dh(e) {
  if (!ah(e))
    return sh(e);
  var t = ih(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !ch.call(e, o)) || n.push(o);
  return n;
}
var uh = dh, ph = si, hh = uh, fh = an;
function gh(e) {
  return fh(e) ? ph(e, !0) : hh(e);
}
var ln = gh, vh = sn, mh = ln;
function bh(e) {
  return vh(e, mh(e));
}
var _h = bh, Or = Za, yh = Ka, Ch = qa, wh = Qa, $h = ei, Ir = Wo, Er = it, Sh = Vu, Nh = Fn, Ah = jo, Th = Ke, Oh = ep, Ih = Zo, xr = ri, Eh = _h;
function xh(e, t, n, o, a, r, i) {
  var s = xr(e, n), l = xr(t, n), c = i.get(l);
  if (c) {
    Or(e, n, c);
    return;
  }
  var u = r ? r(s, l, n + "", e, t, i) : void 0, d = u === void 0;
  if (d) {
    var p = Er(l), f = !p && Nh(l), C = !p && !f && Ih(l);
    u = l, p || f || C ? Er(s) ? u = s : Sh(s) ? u = wh(s) : f ? (d = !1, u = yh(l, !0)) : C ? (d = !1, u = Ch(l, !0)) : u = [] : Oh(l) || Ir(l) ? (u = s, Ir(s) ? u = Eh(s) : (!Th(s) || Ah(s)) && (u = $h(l))) : d = !1;
  }
  d && (i.set(l, u), a(u, l, o, r, i), i.delete(l)), Or(e, n, u);
}
var kh = xh, Dh = Ga, Mh = Za, Ph = Xa, Lh = kh, Rh = Ke, Bh = ln, jh = ri;
function li(e, t, n, o, a) {
  e !== t && Ph(t, function(r, i) {
    if (a || (a = new Dh()), Rh(r))
      Lh(e, t, i, n, li, o, a);
    else {
      var s = o ? o(jh(e, i), r, i + "", e, t, a) : void 0;
      s === void 0 && (s = r), Mh(e, i, s);
    }
  }, Bh);
}
var Uh = li;
function Hh(e) {
  return e;
}
var Xo = Hh;
function Vh(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Fh = Vh, zh = Fh, kr = Math.max;
function Wh(e, t, n) {
  return t = kr(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, a = -1, r = kr(o.length - t, 0), i = Array(r); ++a < r; )
      i[a] = o[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = o[a];
    return s[t] = n(i), zh(e, this, s);
  };
}
var Gh = Wh;
function Yh(e) {
  return function() {
    return e;
  };
}
var Zh = Yh, Xh = Zh, Dr = Ya, Kh = Xo, qh = Dr ? function(e, t) {
  return Dr(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Xh(t),
    writable: !0
  });
} : Kh, Qh = qh, Jh = 800, ef = 16, tf = Date.now;
function nf(e) {
  var t = 0, n = 0;
  return function() {
    var o = tf(), a = ef - (o - n);
    if (n = o, a > 0) {
      if (++t >= Jh)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var of = nf, rf = Qh, af = of, sf = af(rf), lf = sf, cf = Xo, df = Gh, uf = lf;
function pf(e, t) {
  return uf(df(e, t, cf), e + "");
}
var hf = pf, ff = Pn, gf = an, vf = ii, mf = Ke;
function bf(e, t, n) {
  if (!mf(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? gf(n) && vf(t, n.length) : o == "string" && t in n) ? ff(n[t], e) : !1;
}
var _f = bf, yf = hf, Cf = _f;
function wf(e) {
  return yf(function(t, n) {
    var o = -1, a = n.length, r = a > 1 ? n[a - 1] : void 0, i = a > 2 ? n[2] : void 0;
    for (r = e.length > 3 && typeof r == "function" ? (a--, r) : void 0, i && Cf(n[0], n[1], i) && (r = a < 3 ? void 0 : r, a = 1), t = Object(t); ++o < a; ) {
      var s = n[o];
      s && e(t, s, o, r);
    }
    return t;
  });
}
var $f = wf, Sf = Uh, Nf = $f, Af = Nf(function(e, t, n) {
  Sf(e, t, n);
}), Tf = Af;
const ci = /* @__PURE__ */ Xe(Tf), Of = (e) => Bo.reduce((t, n) => (t[n.type] = {
  marginAllowed: !!(e != null && e.marginAllowed),
  paddingAllowed: !!(e != null && e.paddingAllowed),
  backgroundColorAllowed: !!(e != null && e.backgroundColorAllowed),
  backgroundImageAllowed: !!(e != null && e.backgroundImageAllowed)
}, t), {}), _t = () => ({
  editor: void 0,
  colorPalette: void 0,
  enabledOptions: void 0,
  extensions: void 0,
  removeExtensions: void 0,
  addExtensions: void 0,
  allowLinks: !0,
  disableFontSizeEditing: !1
});
class Mr {
  constructor(t = {}) {
    var a, r, i, s, l, c, u;
    const n = {
      locale: "en",
      id: null,
      api: {
        localUploader: !0,
        images: "/v1/assets",
        forms: "",
        secondaryOrgId: null,
        // This is a hack to get around different API responses while FAAS is implemented
        projectParent: "cms"
      },
      customProperties: {
        nodesIncluded: [],
        nodesExcluded: [],
        experimentalFeatures: {
          roundedLayouts: !0
        },
        global: {
          customAttributesAllowed: !0,
          backgroundColorAllowed: !0,
          backgroundImageAllowed: !0,
          marginAllowed: !0,
          paddingAllowed: !0,
          confirmOnDeleteDialogAllowed: !0,
          focusNewNodeOnCreate: !0,
          maxNestingLevelsAllowed: 4,
          rootElementsWidth: "85%",
          rootElementsMaxWidth: "1920px",
          sharedContentAllowed: !1,
          showConfirmOnDeleteDialog: !1,
          headerSlotOptional: !1,
          footerSlotOptional: !1,
          showHeaderSlot: !1,
          showFooterSlot: !1,
          undoLimit: 100
        },
        RTEBar: {
          disabled: !1,
          fontSizes: void 0,
          removeDefaultActions: void 0,
          removeOptions: void 0,
          linkModalOptions: { allowRelative: !0 }
        },
        ...Of((a = t == null ? void 0 : t.customProperties) == null ? void 0 : a.global),
        CONTENT_NODE_HEADING: _t(),
        CONTENT_NODE_TEXT: _t(),
        CONTENT_NODE_TABLE: _t(),
        CONTENT_NODE_CARD: {
          decorativeImageAllowed: !0,
          heading: _t(),
          text: _t(),
          uploadLimitMb: 10
        },
        CONTENT_NODE_IMAGE: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          lightboxAllowed: !0,
          resizableImageAllowed: !0
        },
        CONTENT_NODE_CODE: {
          allowScripts: !0
        },
        CONTENT_NODE_SPACER: {
          minHeight: 20,
          maxHeight: 1e3
        },
        CONTENT_NODE_GALLERY: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          focalPointAllowed: !0,
          lightboxAllowed: !0,
          minColumnsAllowed: 1,
          maxColumnsAllowed: 10,
          maxImagesAllowed: 20,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_VIDEO: {},
        CONTENT_NODE_SEPARATOR: {
          maxThickness: 10
        },
        CONTENT_NODE_BUTTON: {
          icons: {
            global_icons: [],
            custom_icons: []
          },
          textareaMaxLength: 40
        },
        CONTENT_NODE_FORM: {},
        CONTENT_NODE_QUOTE: {},
        CONTENT_NODE_SLIDER: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          decorativeImageAllowed: !0,
          maxImagesAllowed: 30,
          transitionSpeedMin: 3,
          transitionSpeedMax: 6,
          uploadLimitMb: 10
        },
        CONTENT_NODE_ACCORDION: {},
        CONTENT_NODE_PANEL: {},
        CONTENT_NODE_LIST: {
          legacyListOptions: {
            ..._t(),
            enabledOptions: ["bold", "italic", "strike", "color", "add-link"]
          }
        },
        CONTENT_NODE_NAVIGATION: {
          siteMenu: []
        }
      },
      sharedContent: {
        content: {},
        createSharedContentAllowed: !0,
        editSharedContentAllowed: !0,
        detachSharedContentAllowed: !0,
        onContentCreated: ((r = t.sharedContent) == null ? void 0 : r.onContentCreated) || null,
        onSaveContentEdited: ((i = t.sharedContent) == null ? void 0 : i.onSaveContentEdited) || null,
        onCancelContentEdited: ((s = t.sharedContent) == null ? void 0 : s.onCancelContentEdited) || null,
        onContentDetached: ((l = t.sharedContent) == null ? void 0 : l.onContentDetached) || null,
        onOpenSettings: ((c = t.sharedContent) == null ? void 0 : c.onOpenSettings) || null,
        onSharedContentDeleted: ((u = t.sharedContent) == null ? void 0 : u.onSharedContentDeleted) || null
      },
      legacyAdapters: {
        pageToBuilder: null
      },
      assets: {},
      theme: {
        headingColor: null,
        linkColor: null,
        mainColor: null,
        primaryColor: null,
        secondaryColor: null
      },
      structure: {
        id: "root",
        name: "Root",
        type: ve,
        properties: {
          backgroundColor: {
            toggle: !1,
            value: ""
          },
          backgroundImage: {
            toggle: !1,
            image: null
          },
          margin: {
            value: 0
          },
          padding: {
            value: 0
          },
          borderRadius: {
            value: 0
          }
        },
        nodes: []
      }
    }, o = ci({}, n, t);
    Object.keys(o).forEach((d) => {
      this[`_${d}`] = o[d];
    });
  }
  get assets() {
    return this._assets;
  }
  set assets(t) {
    this._assets = t;
  }
  get id() {
    return this._id;
  }
  get structure() {
    return this._structure;
  }
  get api() {
    return this._api;
  }
  get sharedContent() {
    return this._sharedContent;
  }
  set sharedContent(t) {
    this._sharedContent = t;
  }
  get theme() {
    return this._theme;
  }
  set theme(t) {
    this._theme = t;
  }
  get icons() {
    return this._assets.icons;
  }
  get customProperties() {
    return this._customProperties;
  }
  get legacyAdapters() {
    return this._legacyAdapters;
  }
  get locale() {
    return this._locale;
  }
}
const If = (e) => ({
  activeNode: null,
  editingSharedContent: {
    node: null,
    boundingRect: null,
    originalContent: null
  },
  builder: null,
  editor: null,
  isLinkModalOpen: !1,
  isCodeModalOpen: !1,
  nodeDragging: null,
  showCustomAttributesSidebar: !1,
  userAgent: "windows",
  addAsset(t) {
    this.builder.assets = {
      ...this.builder.assets,
      ...t
    };
  },
  setActiveNode(t) {
    this.showCustomAttributesSidebar = !1, this.activeNode = t;
  },
  clearActiveNode() {
    this.showCustomAttributesSidebar = !1, this.activeNode = null;
  },
  clearEditor() {
    this.editor = {
      editor: {},
      editorKey: "",
      enabledOptions: [],
      removeOptions: [],
      colorPalette: {}
    };
  },
  removeFavorite({ id: t }) {
    this.builder.favorites = this.builder.favorites.filter((n) => n.id !== t);
  },
  emitToConsumingApp(t, n) {
    e(t, n);
  }
}), Ef = ({ customProperties: e, structure: t, theme: n }) => {
  const o = "#004b8d", a = "#8369cb", r = "#ad98e6", i = "#B1CB69", s = "#0000ee", l = "#2a5a5a", { properties: c } = t, { backgroundColorAllowed: u } = e.global, d = n.mainColor || Gt.DARK, p = n.headingColor || Gt.DARK, f = n.linkColor || s;
  return {
    // THEME VARIABLES
    "--color-favorite": i,
    "--color-heading": p,
    "--color-link": f,
    "--color-main": d,
    "--color-main-10": `${d}10`,
    "--color-main-20": `${d}20`,
    "--color-main-30": `${d}30`,
    "--font-family": "'Neue Haas Grotesk Disp', 'Inter', 'Helvetica Neue', Arial, sans-serif",
    // BUILDER VARIABLES
    "--builder-background-color": u && c.backgroundColor.toggle && c.backgroundColor.value,
    "--color-layout": o,
    "--color-content": a,
    "--color-sub-content": r,
    "--color-shared-content": l,
    // PB CUSTOM COLOR VARIABLES
    "--pb-black": "#000000",
    "--pb-black-10": "#0000001a",
    "--pb-black-20": "#00000033",
    "--pb-grey-35": "#cccccc",
    "--pb-purple-45": "#ab91dd",
    "--pb-transparent": "#ffffff00",
    "--pb-white-10": "#ffffff1a",
    "--pb-white-90": "#ffffffe6",
    "--pb-code-background-color": "#091E4214",
    // LAYOUT VARIABLES
    "--layout-outline": "1px dashed hsla(0, 0%, 49%, 0.5)",
    "--lightbox-background": "rgba(0, 0, 0, .85)",
    // SIDEBAR VARIABLES
    "--sidebar-width": "240px",
    "--block-container-max-height": "800px"
  };
}, X = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, a] of t)
    n[o] = a;
  return n;
}, xf = {
  name: "ColorPicker",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showContrastChecker: {
      type: Boolean,
      default: !1
    }
  },
  inject: ["state"],
  computed: {
    colorValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    themePalette() {
      var t, n, o, a, r, i;
      return [
        void 0,
        (n = (t = this.state) == null ? void 0 : t.builder.theme) == null ? void 0 : n.primaryColor,
        (a = (o = this.state) == null ? void 0 : o.builder.theme) == null ? void 0 : a.secondaryColor,
        (i = (r = this.state) == null ? void 0 : r.builder.theme) == null ? void 0 : i.mainColor
      ].filter(Boolean);
    }
  }
}, kf = { class: "inline-control space-between gap-10" };
function Df(e, t, n, o, a, r) {
  const i = L("a-form-color-input"), s = L("a-button");
  return _(), M("div", kf, [
    E(i, {
      class: "background-color-input",
      "model-value": r.colorValue,
      palette: r.themePalette,
      "no-contrast-checker": !n.showContrastChecker,
      onChange: t[0] || (t[0] = (l) => r.colorValue = l),
      width: "160px"
    }, null, 8, ["model-value", "palette", "no-contrast-checker"]),
    E(s, {
      class: "clear-button",
      variant: "link",
      onClick: t[1] || (t[1] = (l) => e.$emit("clear"))
    }, {
      default: P(() => [
        ge(K(e.$t("builder.clear")), 1)
      ]),
      _: 1
    })
  ]);
}
const Mf = /* @__PURE__ */ X(xf, [["render", Df], ["__scopeId", "data-v-c66c94e6"]]), Pf = {
  name: "NodeControl",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Lf = { class: "control-header" }, Rf = { class: "control-title" }, Bf = { class: "control-content" };
function jf(e, t, n, o, a, r) {
  return _(), M("div", {
    class: be(["node-control", { disabled: n.disabled }])
  }, [
    $("div", Lf, [
      $("div", Rf, [
        Ne(e.$slots, "title", {}, void 0, !0)
      ]),
      Ne(e.$slots, "control", {}, void 0, !0)
    ]),
    $("div", Bf, [
      Ne(e.$slots, "content", {}, void 0, !0)
    ])
  ], 2);
}
const ft = /* @__PURE__ */ X(Pf, [["render", jf], ["__scopeId", "data-v-256bf46a"]]), Uf = {
  name: "BackgroundColorControl",
  components: {
    ColorPicker: Mf,
    NodeControl: ft
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    backgroundColor: {
      get() {
        var e, t, n;
        return ((n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundColor) == null ? void 0 : n.value) || null;
      },
      set(e) {
        this.$emit("update", "value", e);
      }
    },
    toggle: {
      get() {
        var e, t, n;
        return ((n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundColor) == null ? void 0 : n.toggle) || !1;
      },
      set(e) {
        this.$emit("update", "toggle", e);
      }
    }
  }
};
function Hf(e, t, n, o, a, r) {
  const i = L("a-toggle"), s = L("ColorPicker"), l = L("NodeControl");
  return _(), W(l, null, Mo({
    title: P(() => [
      $("h4", null, K(e.$t("builder.backgroundColor.title")), 1)
    ]),
    control: P(() => [
      E(i, {
        id: "background-color-toggle",
        modelValue: r.toggle,
        "onUpdate:modelValue": t[0] || (t[0] = (c) => r.toggle = c)
      }, null, 8, ["modelValue"])
    ]),
    _: 2
  }, [
    r.toggle ? {
      name: "content",
      fn: P(() => [
        E(s, {
          modelValue: r.backgroundColor,
          "onUpdate:modelValue": t[1] || (t[1] = (c) => r.backgroundColor = c),
          "show-contrast-checker": "",
          onClear: t[2] || (t[2] = (c) => r.backgroundColor = null)
        }, null, 8, ["modelValue"])
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const di = /* @__PURE__ */ X(Uf, [["render", Hf]]), Pr = (e) => /* eslint-disable-next-line no-useless-escape */ /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(e), Vf = (e) => {
  if (e !== "" && e !== void 0 && !Pr(e))
    return new Promise((t, n) => {
      const o = new FileReader();
      o.readAsDataURL(e), o.onloadend = (a) => {
        t(o.result);
      }, o.onerror = (a) => {
        n(a);
      };
    });
  if (Pr(e))
    return Promise.resolve(e);
}, ui = (e, t, n = 10) => {
  var i;
  if (!e.size || !e.type)
    return !1;
  const a = e.size / 1e6 > n, r = !((i = e.name) != null && i.includes(".")) || !t.includes(e.type);
  return a || r || e.type === "";
}, Ff = (e) => ({
  [e.content.assetId]: {
    url: e.assetUrl,
    file: e.content.imageFile
  }
}), BS = (e, t) => {
  const n = Object.keys(t)[0];
  return !e.hasOwnProperty(n);
};
function zf(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Wf = zf, Gf = Ja, Yf = Gf(Object.keys, Object), Zf = Yf, Xf = Vn, Kf = Zf, qf = Object.prototype, Qf = qf.hasOwnProperty;
function Jf(e) {
  if (!Xf(e))
    return Kf(e);
  var t = [];
  for (var n in Object(e))
    Qf.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var pi = Jf, eg = si, tg = pi, ng = an;
function og(e) {
  return ng(e) ? eg(e) : tg(e);
}
var zn = og, rg = sn, ag = zn;
function ig(e, t) {
  return e && rg(t, ag(t), e);
}
var sg = ig, lg = sn, cg = ln;
function dg(e, t) {
  return e && lg(t, cg(t), e);
}
var ug = dg;
function pg(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, a = 0, r = []; ++n < o; ) {
    var i = e[n];
    t(i, n, e) && (r[a++] = i);
  }
  return r;
}
var hg = pg;
function fg() {
  return [];
}
var hi = fg, gg = hg, vg = hi, mg = Object.prototype, bg = mg.propertyIsEnumerable, Lr = Object.getOwnPropertySymbols, _g = Lr ? function(e) {
  return e == null ? [] : (e = Object(e), gg(Lr(e), function(t) {
    return bg.call(e, t);
  }));
} : vg, Ko = _g, yg = sn, Cg = Ko;
function wg(e, t) {
  return yg(e, Cg(e), t);
}
var $g = wg;
function Sg(e, t) {
  for (var n = -1, o = t.length, a = e.length; ++n < o; )
    e[a + n] = t[n];
  return e;
}
var fi = Sg, Ng = fi, Ag = zo, Tg = Ko, Og = hi, Ig = Object.getOwnPropertySymbols, Eg = Ig ? function(e) {
  for (var t = []; e; )
    Ng(t, Tg(e)), e = Ag(e);
  return t;
} : Og, gi = Eg, xg = sn, kg = gi;
function Dg(e, t) {
  return xg(e, kg(e), t);
}
var Mg = Dg, Pg = fi, Lg = it;
function Rg(e, t, n) {
  var o = t(e);
  return Lg(e) ? o : Pg(o, n(e));
}
var vi = Rg, Bg = vi, jg = Ko, Ug = zn;
function Hg(e) {
  return Bg(e, Ug, jg);
}
var Vg = Hg, Fg = vi, zg = gi, Wg = ln;
function Gg(e) {
  return Fg(e, Wg, zg);
}
var Yg = Gg, Zg = mt, Xg = Ve, Kg = Zg(Xg, "DataView"), qg = Kg, Qg = mt, Jg = Ve, ev = Qg(Jg, "Promise"), tv = ev, nv = mt, ov = Ve, rv = nv(ov, "Set"), mi = rv, av = mt, iv = Ve, sv = av(iv, "WeakMap"), lv = sv, fo = qg, go = Uo, vo = tv, mo = mi, bo = lv, bi = Dt, Rt = Wa, Rr = "[object Map]", cv = "[object Object]", Br = "[object Promise]", jr = "[object Set]", Ur = "[object WeakMap]", Hr = "[object DataView]", dv = Rt(fo), uv = Rt(go), pv = Rt(vo), hv = Rt(mo), fv = Rt(bo), ct = bi;
(fo && ct(new fo(new ArrayBuffer(1))) != Hr || go && ct(new go()) != Rr || vo && ct(vo.resolve()) != Br || mo && ct(new mo()) != jr || bo && ct(new bo()) != Ur) && (ct = function(e) {
  var t = bi(e), n = t == cv ? e.constructor : void 0, o = n ? Rt(n) : "";
  if (o)
    switch (o) {
      case dv:
        return Hr;
      case uv:
        return Rr;
      case pv:
        return Br;
      case hv:
        return jr;
      case fv:
        return Ur;
    }
  return t;
});
var Wn = ct, gv = Object.prototype, vv = gv.hasOwnProperty;
function mv(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && vv.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var bv = mv, _v = Fo;
function yv(e, t) {
  var n = t ? _v(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Cv = yv, wv = /\w*$/;
function $v(e) {
  var t = new e.constructor(e.source, wv.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Sv = $v, Vr = Bn, Fr = Vr ? Vr.prototype : void 0, zr = Fr ? Fr.valueOf : void 0;
function Nv(e) {
  return zr ? Object(zr.call(e)) : {};
}
var Av = Nv, Tv = Fo, Ov = Cv, Iv = Sv, Ev = Av, xv = qa, kv = "[object Boolean]", Dv = "[object Date]", Mv = "[object Map]", Pv = "[object Number]", Lv = "[object RegExp]", Rv = "[object Set]", Bv = "[object String]", jv = "[object Symbol]", Uv = "[object ArrayBuffer]", Hv = "[object DataView]", Vv = "[object Float32Array]", Fv = "[object Float64Array]", zv = "[object Int8Array]", Wv = "[object Int16Array]", Gv = "[object Int32Array]", Yv = "[object Uint8Array]", Zv = "[object Uint8ClampedArray]", Xv = "[object Uint16Array]", Kv = "[object Uint32Array]";
function qv(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case Uv:
      return Tv(e);
    case kv:
    case Dv:
      return new o(+e);
    case Hv:
      return Ov(e, n);
    case Vv:
    case Fv:
    case zv:
    case Wv:
    case Gv:
    case Yv:
    case Zv:
    case Xv:
    case Kv:
      return xv(e, n);
    case Mv:
      return new o();
    case Pv:
    case Bv:
      return new o(e);
    case Lv:
      return Iv(e);
    case Rv:
      return new o();
    case jv:
      return Ev(e);
  }
}
var Qv = qv, Jv = Wn, em = at, tm = "[object Map]";
function nm(e) {
  return em(e) && Jv(e) == tm;
}
var om = nm, rm = om, am = Go, Wr = Yo, Gr = Wr && Wr.isMap, im = Gr ? am(Gr) : rm, sm = im, lm = Wn, cm = at, dm = "[object Set]";
function um(e) {
  return cm(e) && lm(e) == dm;
}
var pm = um, hm = pm, fm = Go, Yr = Yo, Zr = Yr && Yr.isSet, gm = Zr ? fm(Zr) : hm, vm = gm, mm = Ga, bm = Wf, _m = ai, ym = sg, Cm = ug, wm = Ka, $m = Qa, Sm = $g, Nm = Mg, Am = Vg, Tm = Yg, Om = Wn, Im = bv, Em = Qv, xm = ei, km = it, Dm = Fn, Mm = sm, Pm = Ke, Lm = vm, Rm = zn, Bm = ln, jm = 1, Um = 2, Hm = 4, _i = "[object Arguments]", Vm = "[object Array]", Fm = "[object Boolean]", zm = "[object Date]", Wm = "[object Error]", yi = "[object Function]", Gm = "[object GeneratorFunction]", Ym = "[object Map]", Zm = "[object Number]", Ci = "[object Object]", Xm = "[object RegExp]", Km = "[object Set]", qm = "[object String]", Qm = "[object Symbol]", Jm = "[object WeakMap]", e0 = "[object ArrayBuffer]", t0 = "[object DataView]", n0 = "[object Float32Array]", o0 = "[object Float64Array]", r0 = "[object Int8Array]", a0 = "[object Int16Array]", i0 = "[object Int32Array]", s0 = "[object Uint8Array]", l0 = "[object Uint8ClampedArray]", c0 = "[object Uint16Array]", d0 = "[object Uint32Array]", oe = {};
oe[_i] = oe[Vm] = oe[e0] = oe[t0] = oe[Fm] = oe[zm] = oe[n0] = oe[o0] = oe[r0] = oe[a0] = oe[i0] = oe[Ym] = oe[Zm] = oe[Ci] = oe[Xm] = oe[Km] = oe[qm] = oe[Qm] = oe[s0] = oe[l0] = oe[c0] = oe[d0] = !0;
oe[Wm] = oe[yi] = oe[Jm] = !1;
function bn(e, t, n, o, a, r) {
  var i, s = t & jm, l = t & Um, c = t & Hm;
  if (n && (i = a ? n(e, o, a, r) : n(e)), i !== void 0)
    return i;
  if (!Pm(e))
    return e;
  var u = km(e);
  if (u) {
    if (i = Im(e), !s)
      return $m(e, i);
  } else {
    var d = Om(e), p = d == yi || d == Gm;
    if (Dm(e))
      return wm(e, s);
    if (d == Ci || d == _i || p && !a) {
      if (i = l || p ? {} : xm(e), !s)
        return l ? Nm(e, Cm(i, e)) : Sm(e, ym(i, e));
    } else {
      if (!oe[d])
        return a ? e : {};
      i = Em(e, d, s);
    }
  }
  r || (r = new mm());
  var f = r.get(e);
  if (f)
    return f;
  r.set(e, i), Lm(e) ? e.forEach(function(g) {
    i.add(bn(g, t, n, g, e, r));
  }) : Mm(e) && e.forEach(function(g, y) {
    i.set(y, bn(g, t, n, y, e, r));
  });
  var C = c ? l ? Tm : Am : l ? Bm : Rm, h = u ? void 0 : C(e);
  return bm(h || e, function(g, y) {
    h && (y = g, g = e[y]), _m(i, y, bn(g, t, n, y, e, r));
  }), i;
}
var u0 = bn, p0 = u0, h0 = 1, f0 = 4;
function g0(e) {
  return p0(e, h0 | f0);
}
var v0 = g0;
const gt = /* @__PURE__ */ Xe(v0);
var m0 = Dt, b0 = at, _0 = "[object Symbol]";
function y0(e) {
  return typeof e == "symbol" || b0(e) && m0(e) == _0;
}
var qo = y0, C0 = it, w0 = qo, $0 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, S0 = /^\w*$/;
function N0(e, t) {
  if (C0(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || w0(e) ? !0 : S0.test(e) || !$0.test(e) || t != null && e in Object(t);
}
var A0 = N0, wi = Ho, T0 = "Expected a function";
function Qo(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(T0);
  var n = function() {
    var o = arguments, a = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(a))
      return r.get(a);
    var i = e.apply(this, o);
    return n.cache = r.set(a, i) || r, i;
  };
  return n.cache = new (Qo.Cache || wi)(), n;
}
Qo.Cache = wi;
var O0 = Qo, I0 = O0, E0 = 500;
function x0(e) {
  var t = I0(e, function(o) {
    return n.size === E0 && n.clear(), o;
  }), n = t.cache;
  return t;
}
var k0 = x0, D0 = k0, M0 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, P0 = /\\(\\)?/g, L0 = D0(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(M0, function(n, o, a, r) {
    t.push(a ? r.replace(P0, "$1") : o || n);
  }), t;
}), R0 = L0;
function B0(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, a = Array(o); ++n < o; )
    a[n] = t(e[n], n, e);
  return a;
}
var j0 = B0, Xr = Bn, U0 = j0, H0 = it, V0 = qo, F0 = 1 / 0, Kr = Xr ? Xr.prototype : void 0, qr = Kr ? Kr.toString : void 0;
function $i(e) {
  if (typeof e == "string")
    return e;
  if (H0(e))
    return U0(e, $i) + "";
  if (V0(e))
    return qr ? qr.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -F0 ? "-0" : t;
}
var z0 = $i, W0 = z0;
function G0(e) {
  return e == null ? "" : W0(e);
}
var cn = G0, Y0 = it, Z0 = A0, X0 = R0, K0 = cn;
function q0(e, t) {
  return Y0(e) ? e : Z0(e, t) ? [e] : X0(K0(e));
}
var Q0 = q0, J0 = qo, e1 = 1 / 0;
function t1(e) {
  if (typeof e == "string" || J0(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -e1 ? "-0" : t;
}
var n1 = t1, o1 = Q0, r1 = n1;
function a1(e, t) {
  t = o1(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[r1(t[n++])];
  return n && n == o ? e : void 0;
}
var i1 = a1, s1 = i1;
function l1(e, t, n) {
  var o = e == null ? void 0 : s1(e, t);
  return o === void 0 ? n : o;
}
var c1 = l1;
const Jo = /* @__PURE__ */ Xe(c1);
var d1 = Xa, u1 = zn;
function p1(e, t) {
  return e && d1(e, t, u1);
}
var h1 = p1, f1 = Xo;
function g1(e) {
  return typeof e == "function" ? e : f1;
}
var v1 = g1, m1 = h1, b1 = v1;
function _1(e, t) {
  return e && m1(e, b1(t));
}
var y1 = _1;
const Gn = /* @__PURE__ */ Xe(y1), fe = () => ({
  anchorTag: "",
  customClasses: []
}), Qe = (e = {}) => ({
  ...e.roundedLayouts && {
    borderRadius: {
      value: 0
    }
  },
  backgroundColor: {
    toggle: !1,
    value: null
  },
  backgroundImage: {
    toggle: !1,
    image: null
  },
  margin: {
    linked: !0,
    value: 10,
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  },
  padding: {
    linked: !0,
    value: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  ...fe()
}), C1 = () => ({
  name: "Base Column",
  type: ve,
  nodes: []
}), ne = () => crypto.randomUUID(), ye = (e, t = {}) => {
  if (!e)
    return null;
  switch (e.type) {
    case ve:
      return {
        ...C1()
      };
    case Xt:
      return {
        id: ne(),
        name: "One Column",
        type: Xt,
        properties: { ...Qe(t) },
        nodes: [ye({ type: ve })]
      };
    case Kt:
      return {
        id: ne(),
        name: "Two Columns",
        type: Kt,
        properties: { ...Qe(t) },
        nodes: new Array(2).fill(null).map((n) => ye({ type: ve }))
      };
    case qt:
      return {
        id: ne(),
        name: "Three Columns",
        type: qt,
        properties: { ...Qe(t) },
        nodes: new Array(3).fill(null).map((n) => ye({ type: ve }))
      };
    case Qt:
      return {
        id: ne(),
        name: "Four Columns",
        type: Qt,
        properties: { ...Qe(t) },
        nodes: new Array(4).fill(null).map((n) => ye({ type: ve }))
      };
    case Nt:
      return {
        id: ne(),
        name: "Full Width",
        type: Nt,
        properties: {
          ...Qe(t),
          margin: {
            linked: !1,
            value: 0,
            top: 10,
            bottom: 10,
            left: 0,
            right: 0
          }
        },
        nodes: [ye({ type: ve })]
      };
    case Jt:
      return {
        id: ne(),
        name: "Left Sidebar",
        type: Jt,
        properties: { ...Qe(t) },
        nodes: new Array(2).fill(null).map((n) => ye({ type: ve }))
      };
    case en:
      return {
        id: ne(),
        name: "Right Sidebar",
        type: en,
        properties: { ...Qe(t) },
        nodes: new Array(2).fill(null).map((n) => ye({ type: ve }))
      };
    case Se:
      if (!e.sharedContentId) {
        console.error("Node must have a sharedContentId UUID property");
        return;
      }
      return {
        id: ne(),
        name: "Shared content",
        type: Se,
        properties: {
          ...Qe(t),
          margin: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          padding: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }
        },
        sharedContentId: e.sharedContentId,
        nodes: [ye({ type: ve })]
      };
  }
}, pt = (e, t = {}) => {
  if (!e)
    return null;
  const { id: n, type: o, content: a, parentId: r } = e;
  switch (o) {
    case mn:
      return {
        id: n || ne(),
        name: "Heading",
        type: mn,
        content: {
          html: (a == null ? void 0 : a.html) || ""
        },
        properties: {
          ...fe()
        }
      };
    case At:
      return {
        id: n || ne(),
        name: "Text",
        type: At,
        content: {
          html: (a == null ? void 0 : a.html) || ""
        },
        properties: {
          ...fe()
        }
      };
    case Dn:
      return {
        ...new Ye()
      };
    case Cn:
      return {
        id: ne(),
        name: "Gallery",
        type: Cn,
        content: {
          images: []
        },
        properties: {
          columnsCount: 4,
          isLightbox: !1,
          showCaptions: !1,
          captionsAlignment: "center",
          ...fe()
        }
      };
    case so:
      return {
        id: ne(),
        name: "Video",
        type: so,
        content: {
          embeddableUrl: ""
        },
        properties: {
          columnPercentage: 100,
          isResized: !1,
          videoAlignment: "center",
          ...fe()
        }
      };
    case ao:
      return {
        id: ne(),
        name: "Code",
        type: ao,
        content: {
          html: ""
        },
        properties: {
          hasScriptTag: !1,
          ...fe()
        }
      };
    case io:
      return {
        id: ne(),
        name: "Spacer",
        type: io,
        properties: {
          height: 20,
          isTransparent: !1,
          backgroundColor: Gt.WHITE,
          ...fe()
        }
      };
    case lo:
      return {
        id: ne(),
        name: "Separator",
        type: lo,
        properties: {
          thickness: 1,
          width: 100,
          color: "",
          style: "solid",
          ...fe()
        }
      };
    case po:
      return {
        id: ne(),
        name: "Quote",
        type: po,
        content: {
          quote: "",
          author: "",
          source: ""
        },
        properties: {
          design: "design-1",
          color: t.mainColor || Gt.BLACK,
          ...fe()
        }
      };
    case wn:
      return {
        id: ne(),
        name: "Slider",
        type: wn,
        content: {
          images: []
        },
        properties: {
          showDots: !0,
          dotsPosition: "top",
          showArrows: !0,
          arrowsPosition: "top",
          isAutoplay: !0,
          transitionSpeed: 3,
          ...fe()
        }
      };
    case $n:
      return {
        id: ne(),
        name: "Card",
        type: $n,
        content: {
          heading: pt({ type: mn }),
          text: pt({ type: At }),
          image: new Ye()
        },
        properties: {
          design: "box-shadow",
          showHeadline: !0,
          showImage: !0,
          imagePosition: "left",
          wrapText: !1,
          ...fe()
        }
      };
    case uo:
      return {
        id: ne(),
        name: "Form",
        type: uo,
        content: {
          formId: null
        },
        properties: {
          showOneQuestionAtATime: !1,
          ...fe()
        }
      };
    case co:
      return {
        id: ne(),
        name: "Button",
        type: co,
        content: {
          buttons: [N1()]
        },
        properties: {
          type: "regular",
          theme: "light",
          size: "regular",
          pillShape: !1,
          alignment: "left",
          style: "1",
          hasIcons: !1,
          ...fe()
        }
      };
    case ho:
      return {
        id: ne(),
        name: "Table",
        type: ho,
        content: {
          html: ""
        },
        properties: {
          theme: gr,
          alternatingColors: !0,
          ...fe()
        }
      };
    case Ze:
      const i = {
        id: ne(),
        name: "Accordion",
        type: Ze,
        nodes: [],
        properties: {
          theme: gr,
          iconStyle: "plus",
          allowMultipleOpenPanels: !0,
          ...fe()
        }
      }, s = {
        ...ye({ type: ve }),
        nodes: [
          pt({
            type: Re,
            parentId: i.id
          })
        ]
      };
      return i.nodes.push(s), i;
    case Re:
      return {
        id: ne(),
        name: "Accordion Panel",
        type: Re,
        properties: {
          text: "",
          panelExpanded: !0,
          defaultToExpanded: !1,
          ...fe()
        },
        parentAccordionId: r,
        nodes: [ye({ type: ve })]
      };
    case Sn:
      return {
        id: ne(),
        name: "List",
        type: Sn,
        content: {
          items: [A1()]
        },
        properties: {
          design: "simple",
          format: "disc",
          ...fe()
        }
      };
    case Nn:
      return {
        id: ne(),
        name: "Navigation",
        type: Nn,
        content: {
          selectedPageId: null,
          selectedChildrenIds: []
        },
        properties: {
          design: "style-1",
          color: t.mainColor || Gt.BLACK
        }
      };
    case tn:
      return {
        id: n || ne(),
        name: "Shared Component Error",
        type: tn
      };
  }
}, rt = (e) => !!Bo.find((t) => t.type === e.type), Si = (e) => !!Mn.find((t) => t.type === e.type), Ni = (e) => e.type === ve, jS = (e) => {
  switch (e.type) {
    case Kt:
    case qt:
    case Jt:
    case en:
    case Qt:
      return !0;
    default:
      return !1;
  }
}, w1 = (e) => !!Va.find((t) => t.type === e.type), $1 = (e, t) => t ? e.type === ve && e.nodes.length === 0 : !1, S1 = (e) => rt(e) ? dt : Si(e) ? ut : w1(e) ? Ro : "", nn = (e = {}, t = 0, n = null) => {
  var i;
  if (!((i = e.nodes) != null && i.length))
    return { ...gt(e), id: ne() };
  const o = ne(), a = e.type === Ze ? o : n, r = (e.nodes || []).map((s) => nn(s, t + 1, a)) || [];
  return {
    ...gt(e),
    id: o,
    nodes: r,
    ...e.type === Re && { parentAccordionId: n }
  };
}, US = (e) => pt(e), HS = () => new Ye(), N1 = () => ({
  id: ne(),
  title: "",
  icon: null,
  iconId: null,
  link: "",
  newTab: !1
}), A1 = () => ({
  id: ne(),
  content: pt({ type: At }),
  details: pt({ type: At })
}), T1 = ({ customProperties: e = null }) => e ? Mn.some((t) => {
  var r, i, s, l, c;
  const n = (i = (r = e[t.type]) == null ? void 0 : r.colorPalette) == null ? void 0 : i.enabled, o = (c = (l = (s = e[t.type]) == null ? void 0 : s.colorPalette) == null ? void 0 : l.colors) == null ? void 0 : c.length;
  return e.hasOwnProperty(t.type) && n && !!o;
}) : !1, Ge = (e, t) => {
  if (Jo(e, "id") === t)
    return e;
  let n = null, o = (e == null ? void 0 : e.nodes) || {};
  return Gn(o, (a) => {
    if (jn(a) && (n = Ge(a, t), n))
      return !1;
  }), n;
}, We = (e, t, n = null) => {
  if (e.id === t) {
    const o = n == null ? void 0 : n.nodes.indexOf(e);
    return { parent: n, index: o };
  }
  if (e.nodes && Array.isArray(e.nodes))
    for (let o = 0; o < e.nodes.length; o++) {
      const a = e.nodes[o], r = We(a, t, e);
      if (r)
        return r;
    }
  return null;
}, Ai = (e, t, n = null, o = null, a = -1) => {
  if (e.id === t) {
    const r = (n == null ? void 0 : n.type) === "BASE_COLUMN" ? o : n, i = (n == null ? void 0 : n.type) === "BASE_COLUMN" ? a : n == null ? void 0 : n.nodes.indexOf(e);
    return { parent: r, grandparent: o, index: i };
  }
  if (e.nodes && Array.isArray(e.nodes))
    for (let r = 0; r < e.nodes.length; r++) {
      const i = e.nodes[r], s = Ai(
        i,
        t,
        e,
        n,
        r
      );
      if (s)
        return s;
    }
  return null;
}, Qr = (e) => e.type === Re, Ti = (e) => {
  if (Jo(e, "type") === Ze)
    return !0;
  let t = !1, n = e.nodes || {};
  return Gn(n, (o) => {
    if (jn(o) && (t = Ti(o), t))
      return !1;
  }), t;
}, Oi = (e, t) => {
  if (Jo(e, "type") === t)
    return !0;
  let n = !1, o = e.nodes || {};
  return Gn(o, (a) => {
    if (jn(a) && (n = Oi(a, t), n))
      return !1;
  }), n;
}, O1 = (e = {}) => Object.values(e).some((t) => !!t);
class Ye {
  constructor(t = {}) {
    const n = {
      id: ne(),
      name: "Image",
      type: Dn,
      content: {
        assetId: "",
        altText: "",
        caption: "",
        imageFile: null,
        // We need to remove this at some point since its not being used outside of builder
        link: ""
      },
      properties: {
        actionOnClick: "no-action",
        captionAlignment: "center",
        columnPercentage: 100,
        focalPointPosition: {
          x: 50,
          y: 50
        },
        imageAlignment: "center",
        isDecorative: !1,
        isResized: !1,
        naturalWidth: null,
        naturalHeight: null,
        newTab: !1,
        preferredWidth: null,
        preferredHeight: null,
        resizeMode: "actual-size",
        showCaption: null,
        // Necessary to distinguish from old pages that havent been adapted
        backgroundPosition: "fill",
        tilePercentage: 100,
        rotation: 0,
        // Not used right now, just left overs from an old idea
        anchorTag: "",
        customClasses: [""]
      }
    }, o = ci(n, t);
    Object.assign(this, o);
  }
}
const I1 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='M4%2017.2105V10.2105C4%209.65823%204.44772%209.21051%205%209.21051H7.38197C7.76074%209.21051%208.107%208.99651%208.27639%208.65772L8.72361%207.7633C8.893%207.42451%209.23926%207.21051%209.61803%207.21051H14.382C14.7607%207.21051%2015.107%207.42451%2015.2764%207.7633L15.7236%208.65772C15.893%208.99651%2016.2393%209.21051%2016.618%209.21051H19C19.5523%209.21051%2020%209.65823%2020%2010.2105V17.2105C20%2017.7628%2019.5523%2018.2105%2019%2018.2105H5C4.44772%2018.2105%204%2017.7628%204%2017.2105Z'%20stroke='var(--primary-dark)'%20/%3e%3ccircle%20cx='12'%20cy='13.2105'%20r='3'%20stroke='var(---primary-dark)'%20/%3e%3c/svg%3e";
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function Jr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ii(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jr(Object(n), !0).forEach(function(o) {
      D1(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jr(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function E1(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t || "default");
    if (typeof o != "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ei(e) {
  var t = E1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function x1(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ea(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Ei(o.key), o);
  }
}
function k1(e, t, n) {
  return t && ea(e.prototype, t), n && ea(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function D1(e, t, n) {
  return t = Ei(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function xi(e) {
  return M1(e) || P1(e) || L1(e) || R1();
}
function M1(e) {
  if (Array.isArray(e))
    return yo(e);
}
function P1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function L1(e, t) {
  if (e) {
    if (typeof e == "string")
      return yo(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return yo(e, t);
  }
}
function yo(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function R1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Yn = typeof window < "u" && typeof window.document < "u", Ue = Yn ? window : {}, er = Yn && Ue.document.documentElement ? "ontouchstart" in Ue.document.documentElement : !1, tr = Yn ? "PointerEvent" in Ue : !1, ie = "cropper", nr = "all", ki = "crop", Di = "move", Mi = "zoom", st = "e", lt = "w", yt = "s", Je = "n", Vt = "ne", Ft = "nw", zt = "se", Wt = "sw", Co = "".concat(ie, "-crop"), ta = "".concat(ie, "-disabled"), Ce = "".concat(ie, "-hidden"), na = "".concat(ie, "-hide"), B1 = "".concat(ie, "-invisible"), In = "".concat(ie, "-modal"), wo = "".concat(ie, "-move"), on = "".concat(ie, "Action"), hn = "".concat(ie, "Preview"), or = "crop", Pi = "move", Li = "none", $o = "crop", So = "cropend", No = "cropmove", Ao = "cropstart", oa = "dblclick", j1 = er ? "touchstart" : "mousedown", U1 = er ? "touchmove" : "mousemove", H1 = er ? "touchend touchcancel" : "mouseup", ra = tr ? "pointerdown" : j1, aa = tr ? "pointermove" : U1, ia = tr ? "pointerup pointercancel" : H1, sa = "ready", la = "resize", ca = "wheel", To = "zoom", da = "image/jpeg", V1 = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, F1 = /^data:/, z1 = /^data:image\/jpeg;base64,/, W1 = /^img|canvas$/i, Ri = 200, Bi = 100, ua = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: or,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: Ri,
  minContainerHeight: Bi,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, G1 = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Y1 = Number.isNaN || Ue.isNaN;
function Q(e) {
  return typeof e == "number" && !Y1(e);
}
var pa = function(t) {
  return t > 0 && t < 1 / 0;
};
function Qn(e) {
  return typeof e > "u";
}
function vt(e) {
  return _o(e) === "object" && e !== null;
}
var Z1 = Object.prototype.hasOwnProperty;
function $t(e) {
  if (!vt(e))
    return !1;
  try {
    var t = e.constructor, n = t.prototype;
    return t && n && Z1.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function _e(e) {
  return typeof e == "function";
}
var X1 = Array.prototype.slice;
function ji(e) {
  return Array.from ? Array.from(e) : X1.call(e);
}
function ue(e, t) {
  return e && _e(t) && (Array.isArray(e) || Q(e.length) ? ji(e).forEach(function(n, o) {
    t.call(e, n, o, e);
  }) : vt(e) && Object.keys(e).forEach(function(n) {
    t.call(e, e[n], n, e);
  })), e;
}
var se = Object.assign || function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    o[a - 1] = arguments[a];
  return vt(t) && o.length > 0 && o.forEach(function(r) {
    vt(r) && Object.keys(r).forEach(function(i) {
      t[i] = r[i];
    });
  }), t;
}, K1 = /\.\d*(?:0|9){12}\d*$/;
function Tt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return K1.test(e) ? Math.round(e * t) / t : e;
}
var q1 = /^width|height|left|top|marginLeft|marginTop$/;
function et(e, t) {
  var n = e.style;
  ue(t, function(o, a) {
    q1.test(a) && Q(o) && (o = "".concat(o, "px")), n[a] = o;
  });
}
function Q1(e, t) {
  return e.classList ? e.classList.contains(t) : e.className.indexOf(t) > -1;
}
function he(e, t) {
  if (t) {
    if (Q(e.length)) {
      ue(e, function(o) {
        he(o, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(t);
      return;
    }
    var n = e.className.trim();
    n ? n.indexOf(t) < 0 && (e.className = "".concat(n, " ").concat(t)) : e.className = t;
  }
}
function Be(e, t) {
  if (t) {
    if (Q(e.length)) {
      ue(e, function(n) {
        Be(n, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(t);
      return;
    }
    e.className.indexOf(t) >= 0 && (e.className = e.className.replace(t, ""));
  }
}
function St(e, t, n) {
  if (t) {
    if (Q(e.length)) {
      ue(e, function(o) {
        St(o, t, n);
      });
      return;
    }
    n ? he(e, t) : Be(e, t);
  }
}
var J1 = /([a-z\d])([A-Z])/g;
function rr(e) {
  return e.replace(J1, "$1-$2").toLowerCase();
}
function Oo(e, t) {
  return vt(e[t]) ? e[t] : e.dataset ? e.dataset[t] : e.getAttribute("data-".concat(rr(t)));
}
function rn(e, t, n) {
  vt(n) ? e[t] = n : e.dataset ? e.dataset[t] = n : e.setAttribute("data-".concat(rr(t)), n);
}
function eb(e, t) {
  if (vt(e[t]))
    try {
      delete e[t];
    } catch {
      e[t] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[t];
    } catch {
      e.dataset[t] = void 0;
    }
  else
    e.removeAttribute("data-".concat(rr(t)));
}
var Ui = /\s\s*/, Hi = function() {
  var e = !1;
  if (Yn) {
    var t = !1, n = function() {
    }, o = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, t;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(r) {
        t = r;
      }
    });
    Ue.addEventListener("test", n, o), Ue.removeEventListener("test", n, o);
  }
  return e;
}();
function xe(e, t, n) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(Ui).forEach(function(r) {
    if (!Hi) {
      var i = e.listeners;
      i && i[r] && i[r][n] && (a = i[r][n], delete i[r][n], Object.keys(i[r]).length === 0 && delete i[r], Object.keys(i).length === 0 && delete e.listeners);
    }
    e.removeEventListener(r, a, o);
  });
}
function Oe(e, t, n) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(Ui).forEach(function(r) {
    if (o.once && !Hi) {
      var i = e.listeners, s = i === void 0 ? {} : i;
      a = function() {
        delete s[r][n], e.removeEventListener(r, a, o);
        for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
          u[d] = arguments[d];
        n.apply(e, u);
      }, s[r] || (s[r] = {}), s[r][n] && e.removeEventListener(r, s[r][n], o), s[r][n] = a, e.listeners = s;
    }
    e.addEventListener(r, a, o);
  });
}
function Ot(e, t, n) {
  var o;
  return _e(Event) && _e(CustomEvent) ? o = new CustomEvent(t, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (o = document.createEvent("CustomEvent"), o.initCustomEvent(t, !0, !0, n)), e.dispatchEvent(o);
}
function Vi(e) {
  var t = e.getBoundingClientRect();
  return {
    left: t.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: t.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var Jn = Ue.location, tb = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function ha(e) {
  var t = e.match(tb);
  return t !== null && (t[1] !== Jn.protocol || t[2] !== Jn.hostname || t[3] !== Jn.port);
}
function fa(e) {
  var t = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + t;
}
function Yt(e) {
  var t = e.rotate, n = e.scaleX, o = e.scaleY, a = e.translateX, r = e.translateY, i = [];
  Q(a) && a !== 0 && i.push("translateX(".concat(a, "px)")), Q(r) && r !== 0 && i.push("translateY(".concat(r, "px)")), Q(t) && t !== 0 && i.push("rotate(".concat(t, "deg)")), Q(n) && n !== 1 && i.push("scaleX(".concat(n, ")")), Q(o) && o !== 1 && i.push("scaleY(".concat(o, ")"));
  var s = i.length ? i.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function nb(e) {
  var t = Ii({}, e), n = 0;
  return ue(e, function(o, a) {
    delete t[a], ue(t, function(r) {
      var i = Math.abs(o.startX - r.startX), s = Math.abs(o.startY - r.startY), l = Math.abs(o.endX - r.endX), c = Math.abs(o.endY - r.endY), u = Math.sqrt(i * i + s * s), d = Math.sqrt(l * l + c * c), p = (d - u) / u;
      Math.abs(p) > Math.abs(n) && (n = p);
    });
  }), n;
}
function fn(e, t) {
  var n = e.pageX, o = e.pageY, a = {
    endX: n,
    endY: o
  };
  return t ? a : Ii({
    startX: n,
    startY: o
  }, a);
}
function ob(e) {
  var t = 0, n = 0, o = 0;
  return ue(e, function(a) {
    var r = a.startX, i = a.startY;
    t += r, n += i, o += 1;
  }), t /= o, n /= o, {
    pageX: t,
    pageY: n
  };
}
function tt(e) {
  var t = e.aspectRatio, n = e.height, o = e.width, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", r = pa(o), i = pa(n);
  if (r && i) {
    var s = n * t;
    a === "contain" && s > o || a === "cover" && s < o ? n = o / t : o = n * t;
  } else
    r ? n = o / t : i && (o = n * t);
  return {
    width: o,
    height: n
  };
}
function rb(e) {
  var t = e.width, n = e.height, o = e.degree;
  if (o = Math.abs(o) % 180, o === 90)
    return {
      width: n,
      height: t
    };
  var a = o % 90 * Math.PI / 180, r = Math.sin(a), i = Math.cos(a), s = t * i + n * r, l = t * r + n * i;
  return o > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function ab(e, t, n, o) {
  var a = t.aspectRatio, r = t.naturalWidth, i = t.naturalHeight, s = t.rotate, l = s === void 0 ? 0 : s, c = t.scaleX, u = c === void 0 ? 1 : c, d = t.scaleY, p = d === void 0 ? 1 : d, f = n.aspectRatio, C = n.naturalWidth, h = n.naturalHeight, g = o.fillColor, y = g === void 0 ? "transparent" : g, N = o.imageSmoothingEnabled, m = N === void 0 ? !0 : N, O = o.imageSmoothingQuality, I = O === void 0 ? "low" : O, v = o.maxWidth, A = v === void 0 ? 1 / 0 : v, D = o.maxHeight, j = D === void 0 ? 1 / 0 : D, F = o.minWidth, T = F === void 0 ? 0 : F, S = o.minHeight, x = S === void 0 ? 0 : S, B = document.createElement("canvas"), R = B.getContext("2d"), z = tt({
    aspectRatio: f,
    width: A,
    height: j
  }), J = tt({
    aspectRatio: f,
    width: T,
    height: x
  }, "cover"), re = Math.min(z.width, Math.max(J.width, C)), ce = Math.min(z.height, Math.max(J.height, h)), Ae = tt({
    aspectRatio: a,
    width: A,
    height: j
  }), $e = tt({
    aspectRatio: a,
    width: T,
    height: x
  }, "cover"), Te = Math.min(Ae.width, Math.max($e.width, r)), Me = Math.min(Ae.height, Math.max($e.height, i)), qe = [-Te / 2, -Me / 2, Te, Me];
  return B.width = Tt(re), B.height = Tt(ce), R.fillStyle = y, R.fillRect(0, 0, re, ce), R.save(), R.translate(re / 2, ce / 2), R.rotate(l * Math.PI / 180), R.scale(u, p), R.imageSmoothingEnabled = m, R.imageSmoothingQuality = I, R.drawImage.apply(R, [e].concat(xi(qe.map(function(Ut) {
    return Math.floor(Tt(Ut));
  })))), R.restore(), B;
}
var Fi = String.fromCharCode;
function ib(e, t, n) {
  var o = "";
  n += t;
  for (var a = t; a < n; a += 1)
    o += Fi(e.getUint8(a));
  return o;
}
var sb = /^data:.*,/;
function lb(e) {
  var t = e.replace(sb, ""), n = atob(t), o = new ArrayBuffer(n.length), a = new Uint8Array(o);
  return ue(a, function(r, i) {
    a[i] = n.charCodeAt(i);
  }), o;
}
function cb(e, t) {
  for (var n = [], o = 8192, a = new Uint8Array(e); a.length > 0; )
    n.push(Fi.apply(null, ji(a.subarray(0, o)))), a = a.subarray(o);
  return "data:".concat(t, ";base64,").concat(btoa(n.join("")));
}
function db(e) {
  var t = new DataView(e), n;
  try {
    var o, a, r;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var i = t.byteLength, s = 2; s + 1 < i; ) {
        if (t.getUint8(s) === 255 && t.getUint8(s + 1) === 225) {
          a = s;
          break;
        }
        s += 1;
      }
    if (a) {
      var l = a + 4, c = a + 10;
      if (ib(t, l, 4) === "Exif") {
        var u = t.getUint16(c);
        if (o = u === 18761, (o || u === 19789) && t.getUint16(c + 2, o) === 42) {
          var d = t.getUint32(c + 4, o);
          d >= 8 && (r = c + d);
        }
      }
    }
    if (r) {
      var p = t.getUint16(r, o), f, C;
      for (C = 0; C < p; C += 1)
        if (f = r + C * 12 + 2, t.getUint16(f, o) === 274) {
          f += 8, n = t.getUint16(f, o), t.setUint16(f, 1, o);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function ub(e) {
  var t = 0, n = 1, o = 1;
  switch (e) {
    case 2:
      n = -1;
      break;
    case 3:
      t = -180;
      break;
    case 4:
      o = -1;
      break;
    case 5:
      t = 90, o = -1;
      break;
    case 6:
      t = 90;
      break;
    case 7:
      t = 90, n = -1;
      break;
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: n,
    scaleY: o
  };
}
var pb = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var t = this.element, n = this.options, o = this.container, a = this.cropper, r = Number(n.minContainerWidth), i = Number(n.minContainerHeight);
    he(a, Ce), Be(t, Ce);
    var s = {
      width: Math.max(o.offsetWidth, r >= 0 ? r : Ri),
      height: Math.max(o.offsetHeight, i >= 0 ? i : Bi)
    };
    this.containerData = s, et(a, {
      width: s.width,
      height: s.height
    }), he(t, Ce), Be(a, Ce);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var t = this.containerData, n = this.imageData, o = this.options.viewMode, a = Math.abs(n.rotate) % 180 === 90, r = a ? n.naturalHeight : n.naturalWidth, i = a ? n.naturalWidth : n.naturalHeight, s = r / i, l = t.width, c = t.height;
    t.height * s > t.width ? o === 3 ? l = t.height * s : c = t.width / s : o === 3 ? c = t.width / s : l = t.height * s;
    var u = {
      aspectRatio: s,
      naturalWidth: r,
      naturalHeight: i,
      width: l,
      height: c
    };
    this.canvasData = u, this.limited = o === 1 || o === 2, this.limitCanvas(!0, !0), u.width = Math.min(Math.max(u.width, u.minWidth), u.maxWidth), u.height = Math.min(Math.max(u.height, u.minHeight), u.maxHeight), u.left = (t.width - u.width) / 2, u.top = (t.height - u.height) / 2, u.oldLeft = u.left, u.oldTop = u.top, this.initialCanvasData = se({}, u);
  },
  limitCanvas: function(t, n) {
    var o = this.options, a = this.containerData, r = this.canvasData, i = this.cropBoxData, s = o.viewMode, l = r.aspectRatio, c = this.cropped && i;
    if (t) {
      var u = Number(o.minCanvasWidth) || 0, d = Number(o.minCanvasHeight) || 0;
      s > 1 ? (u = Math.max(u, a.width), d = Math.max(d, a.height), s === 3 && (d * l > u ? u = d * l : d = u / l)) : s > 0 && (u ? u = Math.max(u, c ? i.width : 0) : d ? d = Math.max(d, c ? i.height : 0) : c && (u = i.width, d = i.height, d * l > u ? u = d * l : d = u / l));
      var p = tt({
        aspectRatio: l,
        width: u,
        height: d
      });
      u = p.width, d = p.height, r.minWidth = u, r.minHeight = d, r.maxWidth = 1 / 0, r.maxHeight = 1 / 0;
    }
    if (n)
      if (s > (c ? 0 : 1)) {
        var f = a.width - r.width, C = a.height - r.height;
        r.minLeft = Math.min(0, f), r.minTop = Math.min(0, C), r.maxLeft = Math.max(0, f), r.maxTop = Math.max(0, C), c && this.limited && (r.minLeft = Math.min(i.left, i.left + (i.width - r.width)), r.minTop = Math.min(i.top, i.top + (i.height - r.height)), r.maxLeft = i.left, r.maxTop = i.top, s === 2 && (r.width >= a.width && (r.minLeft = Math.min(0, f), r.maxLeft = Math.max(0, f)), r.height >= a.height && (r.minTop = Math.min(0, C), r.maxTop = Math.max(0, C))));
      } else
        r.minLeft = -r.width, r.minTop = -r.height, r.maxLeft = a.width, r.maxTop = a.height;
  },
  renderCanvas: function(t, n) {
    var o = this.canvasData, a = this.imageData;
    if (n) {
      var r = rb({
        width: a.naturalWidth * Math.abs(a.scaleX || 1),
        height: a.naturalHeight * Math.abs(a.scaleY || 1),
        degree: a.rotate || 0
      }), i = r.width, s = r.height, l = o.width * (i / o.naturalWidth), c = o.height * (s / o.naturalHeight);
      o.left -= (l - o.width) / 2, o.top -= (c - o.height) / 2, o.width = l, o.height = c, o.aspectRatio = i / s, o.naturalWidth = i, o.naturalHeight = s, this.limitCanvas(!0, !1);
    }
    (o.width > o.maxWidth || o.width < o.minWidth) && (o.left = o.oldLeft), (o.height > o.maxHeight || o.height < o.minHeight) && (o.top = o.oldTop), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), this.limitCanvas(!1, !0), o.left = Math.min(Math.max(o.left, o.minLeft), o.maxLeft), o.top = Math.min(Math.max(o.top, o.minTop), o.maxTop), o.oldLeft = o.left, o.oldTop = o.top, et(this.canvas, se({
      width: o.width,
      height: o.height
    }, Yt({
      translateX: o.left,
      translateY: o.top
    }))), this.renderImage(t), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(t) {
    var n = this.canvasData, o = this.imageData, a = o.naturalWidth * (n.width / n.naturalWidth), r = o.naturalHeight * (n.height / n.naturalHeight);
    se(o, {
      width: a,
      height: r,
      left: (n.width - a) / 2,
      top: (n.height - r) / 2
    }), et(this.image, se({
      width: o.width,
      height: o.height
    }, Yt(se({
      translateX: o.left,
      translateY: o.top
    }, o)))), t && this.output();
  },
  initCropBox: function() {
    var t = this.options, n = this.canvasData, o = t.aspectRatio || t.initialAspectRatio, a = Number(t.autoCropArea) || 0.8, r = {
      width: n.width,
      height: n.height
    };
    o && (n.height * o > n.width ? r.height = r.width / o : r.width = r.height * o), this.cropBoxData = r, this.limitCropBox(!0, !0), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), r.width = Math.max(r.minWidth, r.width * a), r.height = Math.max(r.minHeight, r.height * a), r.left = n.left + (n.width - r.width) / 2, r.top = n.top + (n.height - r.height) / 2, r.oldLeft = r.left, r.oldTop = r.top, this.initialCropBoxData = se({}, r);
  },
  limitCropBox: function(t, n) {
    var o = this.options, a = this.containerData, r = this.canvasData, i = this.cropBoxData, s = this.limited, l = o.aspectRatio;
    if (t) {
      var c = Number(o.minCropBoxWidth) || 0, u = Number(o.minCropBoxHeight) || 0, d = s ? Math.min(a.width, r.width, r.width + r.left, a.width - r.left) : a.width, p = s ? Math.min(a.height, r.height, r.height + r.top, a.height - r.top) : a.height;
      c = Math.min(c, a.width), u = Math.min(u, a.height), l && (c && u ? u * l > c ? u = c / l : c = u * l : c ? u = c / l : u && (c = u * l), p * l > d ? p = d / l : d = p * l), i.minWidth = Math.min(c, d), i.minHeight = Math.min(u, p), i.maxWidth = d, i.maxHeight = p;
    }
    n && (s ? (i.minLeft = Math.max(0, r.left), i.minTop = Math.max(0, r.top), i.maxLeft = Math.min(a.width, r.left + r.width) - i.width, i.maxTop = Math.min(a.height, r.top + r.height) - i.height) : (i.minLeft = 0, i.minTop = 0, i.maxLeft = a.width - i.width, i.maxTop = a.height - i.height));
  },
  renderCropBox: function() {
    var t = this.options, n = this.containerData, o = this.cropBoxData;
    (o.width > o.maxWidth || o.width < o.minWidth) && (o.left = o.oldLeft), (o.height > o.maxHeight || o.height < o.minHeight) && (o.top = o.oldTop), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), this.limitCropBox(!1, !0), o.left = Math.min(Math.max(o.left, o.minLeft), o.maxLeft), o.top = Math.min(Math.max(o.top, o.minTop), o.maxTop), o.oldLeft = o.left, o.oldTop = o.top, t.movable && t.cropBoxMovable && rn(this.face, on, o.width >= n.width && o.height >= n.height ? Di : nr), et(this.cropBox, se({
      width: o.width,
      height: o.height
    }, Yt({
      translateX: o.left,
      translateY: o.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), Ot(this.element, $o, this.getData());
  }
}, hb = {
  initPreview: function() {
    var t = this.element, n = this.crossOrigin, o = this.options.preview, a = n ? this.crossOriginUrl : this.url, r = t.alt || "The image to preview", i = document.createElement("img");
    if (n && (i.crossOrigin = n), i.src = a, i.alt = r, this.viewBox.appendChild(i), this.viewBoxImage = i, !!o) {
      var s = o;
      typeof o == "string" ? s = t.ownerDocument.querySelectorAll(o) : o.querySelector && (s = [o]), this.previews = s, ue(s, function(l) {
        var c = document.createElement("img");
        rn(l, hn, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), n && (c.crossOrigin = n), c.src = a, c.alt = r, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    ue(this.previews, function(t) {
      var n = Oo(t, hn);
      et(t, {
        width: n.width,
        height: n.height
      }), t.innerHTML = n.html, eb(t, hn);
    });
  },
  preview: function() {
    var t = this.imageData, n = this.canvasData, o = this.cropBoxData, a = o.width, r = o.height, i = t.width, s = t.height, l = o.left - n.left - t.left, c = o.top - n.top - t.top;
    !this.cropped || this.disabled || (et(this.viewBoxImage, se({
      width: i,
      height: s
    }, Yt(se({
      translateX: -l,
      translateY: -c
    }, t)))), ue(this.previews, function(u) {
      var d = Oo(u, hn), p = d.width, f = d.height, C = p, h = f, g = 1;
      a && (g = p / a, h = r * g), r && h > f && (g = f / r, C = a * g, h = f), et(u, {
        width: C,
        height: h
      }), et(u.getElementsByTagName("img")[0], se({
        width: i * g,
        height: s * g
      }, Yt(se({
        translateX: -l * g,
        translateY: -c * g
      }, t))));
    }));
  }
}, fb = {
  bind: function() {
    var t = this.element, n = this.options, o = this.cropper;
    _e(n.cropstart) && Oe(t, Ao, n.cropstart), _e(n.cropmove) && Oe(t, No, n.cropmove), _e(n.cropend) && Oe(t, So, n.cropend), _e(n.crop) && Oe(t, $o, n.crop), _e(n.zoom) && Oe(t, To, n.zoom), Oe(o, ra, this.onCropStart = this.cropStart.bind(this)), n.zoomable && n.zoomOnWheel && Oe(o, ca, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && Oe(o, oa, this.onDblclick = this.dblclick.bind(this)), Oe(t.ownerDocument, aa, this.onCropMove = this.cropMove.bind(this)), Oe(t.ownerDocument, ia, this.onCropEnd = this.cropEnd.bind(this)), n.responsive && Oe(window, la, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var t = this.element, n = this.options, o = this.cropper;
    _e(n.cropstart) && xe(t, Ao, n.cropstart), _e(n.cropmove) && xe(t, No, n.cropmove), _e(n.cropend) && xe(t, So, n.cropend), _e(n.crop) && xe(t, $o, n.crop), _e(n.zoom) && xe(t, To, n.zoom), xe(o, ra, this.onCropStart), n.zoomable && n.zoomOnWheel && xe(o, ca, this.onWheel, {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && xe(o, oa, this.onDblclick), xe(t.ownerDocument, aa, this.onCropMove), xe(t.ownerDocument, ia, this.onCropEnd), n.responsive && xe(window, la, this.onResize);
  }
}, gb = {
  resize: function() {
    if (!this.disabled) {
      var t = this.options, n = this.container, o = this.containerData, a = n.offsetWidth / o.width, r = n.offsetHeight / o.height, i = Math.abs(a - 1) > Math.abs(r - 1) ? a : r;
      if (i !== 1) {
        var s, l;
        t.restore && (s = this.getCanvasData(), l = this.getCropBoxData()), this.render(), t.restore && (this.setCanvasData(ue(s, function(c, u) {
          s[u] = c * i;
        })), this.setCropBoxData(ue(l, function(c, u) {
          l[u] = c * i;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === Li || this.setDragMode(Q1(this.dragBox, Co) ? Pi : or);
  },
  wheel: function(t) {
    var n = this, o = Number(this.options.wheelZoomRatio) || 0.1, a = 1;
    this.disabled || (t.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      n.wheeling = !1;
    }, 50), t.deltaY ? a = t.deltaY > 0 ? 1 : -1 : t.wheelDelta ? a = -t.wheelDelta / 120 : t.detail && (a = t.detail > 0 ? 1 : -1), this.zoom(-a * o, t)));
  },
  cropStart: function(t) {
    var n = t.buttons, o = t.button;
    if (!(this.disabled || (t.type === "mousedown" || t.type === "pointerdown" && t.pointerType === "mouse") && // No primary button (Usually the left button)
    (Q(n) && n !== 1 || Q(o) && o !== 0 || t.ctrlKey))) {
      var a = this.options, r = this.pointers, i;
      t.changedTouches ? ue(t.changedTouches, function(s) {
        r[s.identifier] = fn(s);
      }) : r[t.pointerId || 0] = fn(t), Object.keys(r).length > 1 && a.zoomable && a.zoomOnTouch ? i = Mi : i = Oo(t.target, on), V1.test(i) && Ot(this.element, Ao, {
        originalEvent: t,
        action: i
      }) !== !1 && (t.preventDefault(), this.action = i, this.cropping = !1, i === ki && (this.cropping = !0, he(this.dragBox, In)));
    }
  },
  cropMove: function(t) {
    var n = this.action;
    if (!(this.disabled || !n)) {
      var o = this.pointers;
      t.preventDefault(), Ot(this.element, No, {
        originalEvent: t,
        action: n
      }) !== !1 && (t.changedTouches ? ue(t.changedTouches, function(a) {
        se(o[a.identifier] || {}, fn(a, !0));
      }) : se(o[t.pointerId || 0] || {}, fn(t, !0)), this.change(t));
    }
  },
  cropEnd: function(t) {
    if (!this.disabled) {
      var n = this.action, o = this.pointers;
      t.changedTouches ? ue(t.changedTouches, function(a) {
        delete o[a.identifier];
      }) : delete o[t.pointerId || 0], n && (t.preventDefault(), Object.keys(o).length || (this.action = ""), this.cropping && (this.cropping = !1, St(this.dragBox, In, this.cropped && this.options.modal)), Ot(this.element, So, {
        originalEvent: t,
        action: n
      }));
    }
  }
}, vb = {
  change: function(t) {
    var n = this.options, o = this.canvasData, a = this.containerData, r = this.cropBoxData, i = this.pointers, s = this.action, l = n.aspectRatio, c = r.left, u = r.top, d = r.width, p = r.height, f = c + d, C = u + p, h = 0, g = 0, y = a.width, N = a.height, m = !0, O;
    !l && t.shiftKey && (l = d && p ? d / p : 1), this.limited && (h = r.minLeft, g = r.minTop, y = h + Math.min(a.width, o.width, o.left + o.width), N = g + Math.min(a.height, o.height, o.top + o.height));
    var I = i[Object.keys(i)[0]], v = {
      x: I.endX - I.startX,
      y: I.endY - I.startY
    }, A = function(j) {
      switch (j) {
        case st:
          f + v.x > y && (v.x = y - f);
          break;
        case lt:
          c + v.x < h && (v.x = h - c);
          break;
        case Je:
          u + v.y < g && (v.y = g - u);
          break;
        case yt:
          C + v.y > N && (v.y = N - C);
          break;
      }
    };
    switch (s) {
      case nr:
        c += v.x, u += v.y;
        break;
      case st:
        if (v.x >= 0 && (f >= y || l && (u <= g || C >= N))) {
          m = !1;
          break;
        }
        A(st), d += v.x, d < 0 && (s = lt, d = -d, c -= d), l && (p = d / l, u += (r.height - p) / 2);
        break;
      case Je:
        if (v.y <= 0 && (u <= g || l && (c <= h || f >= y))) {
          m = !1;
          break;
        }
        A(Je), p -= v.y, u += v.y, p < 0 && (s = yt, p = -p, u -= p), l && (d = p * l, c += (r.width - d) / 2);
        break;
      case lt:
        if (v.x <= 0 && (c <= h || l && (u <= g || C >= N))) {
          m = !1;
          break;
        }
        A(lt), d -= v.x, c += v.x, d < 0 && (s = st, d = -d, c -= d), l && (p = d / l, u += (r.height - p) / 2);
        break;
      case yt:
        if (v.y >= 0 && (C >= N || l && (c <= h || f >= y))) {
          m = !1;
          break;
        }
        A(yt), p += v.y, p < 0 && (s = Je, p = -p, u -= p), l && (d = p * l, c += (r.width - d) / 2);
        break;
      case Vt:
        if (l) {
          if (v.y <= 0 && (u <= g || f >= y)) {
            m = !1;
            break;
          }
          A(Je), p -= v.y, u += v.y, d = p * l;
        } else
          A(Je), A(st), v.x >= 0 ? f < y ? d += v.x : v.y <= 0 && u <= g && (m = !1) : d += v.x, v.y <= 0 ? u > g && (p -= v.y, u += v.y) : (p -= v.y, u += v.y);
        d < 0 && p < 0 ? (s = Wt, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = Ft, d = -d, c -= d) : p < 0 && (s = zt, p = -p, u -= p);
        break;
      case Ft:
        if (l) {
          if (v.y <= 0 && (u <= g || c <= h)) {
            m = !1;
            break;
          }
          A(Je), p -= v.y, u += v.y, d = p * l, c += r.width - d;
        } else
          A(Je), A(lt), v.x <= 0 ? c > h ? (d -= v.x, c += v.x) : v.y <= 0 && u <= g && (m = !1) : (d -= v.x, c += v.x), v.y <= 0 ? u > g && (p -= v.y, u += v.y) : (p -= v.y, u += v.y);
        d < 0 && p < 0 ? (s = zt, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = Vt, d = -d, c -= d) : p < 0 && (s = Wt, p = -p, u -= p);
        break;
      case Wt:
        if (l) {
          if (v.x <= 0 && (c <= h || C >= N)) {
            m = !1;
            break;
          }
          A(lt), d -= v.x, c += v.x, p = d / l;
        } else
          A(yt), A(lt), v.x <= 0 ? c > h ? (d -= v.x, c += v.x) : v.y >= 0 && C >= N && (m = !1) : (d -= v.x, c += v.x), v.y >= 0 ? C < N && (p += v.y) : p += v.y;
        d < 0 && p < 0 ? (s = Vt, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = zt, d = -d, c -= d) : p < 0 && (s = Ft, p = -p, u -= p);
        break;
      case zt:
        if (l) {
          if (v.x >= 0 && (f >= y || C >= N)) {
            m = !1;
            break;
          }
          A(st), d += v.x, p = d / l;
        } else
          A(yt), A(st), v.x >= 0 ? f < y ? d += v.x : v.y >= 0 && C >= N && (m = !1) : d += v.x, v.y >= 0 ? C < N && (p += v.y) : p += v.y;
        d < 0 && p < 0 ? (s = Ft, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = Wt, d = -d, c -= d) : p < 0 && (s = Vt, p = -p, u -= p);
        break;
      case Di:
        this.move(v.x, v.y), m = !1;
        break;
      case Mi:
        this.zoom(nb(i), t), m = !1;
        break;
      case ki:
        if (!v.x || !v.y) {
          m = !1;
          break;
        }
        O = Vi(this.cropper), c = I.startX - O.left, u = I.startY - O.top, d = r.minWidth, p = r.minHeight, v.x > 0 ? s = v.y > 0 ? zt : Vt : v.x < 0 && (c -= d, s = v.y > 0 ? Wt : Ft), v.y < 0 && (u -= p), this.cropped || (Be(this.cropBox, Ce), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    m && (r.width = d, r.height = p, r.left = c, r.top = u, this.action = s, this.renderCropBox()), ue(i, function(D) {
      D.startX = D.endX, D.startY = D.endY;
    });
  }
}, mb = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && he(this.dragBox, In), Be(this.cropBox, Ce), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = se({}, this.initialImageData), this.canvasData = se({}, this.initialCanvasData), this.cropBoxData = se({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (se(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Be(this.dragBox, In), he(this.cropBox, Ce)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && t && (this.isImg && (this.element.src = t), n ? (this.url = t, this.image.src = t, this.ready && (this.viewBoxImage.src = t, ue(this.previews, function(o) {
      o.getElementsByTagName("img")[0].src = t;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(t))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Be(this.cropper, ta)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, he(this.cropper, ta)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var t = this.element;
    return t[ie] ? (t[ie] = void 0, this.isImg && this.replaced && (t.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = this.canvasData, a = o.left, r = o.top;
    return this.moveTo(Qn(t) ? t : a + Number(t), Qn(n) ? n : r + Number(n));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = this.canvasData, a = !1;
    return t = Number(t), n = Number(n), this.ready && !this.disabled && this.options.movable && (Q(t) && (o.left = t, a = !0), Q(n) && (o.top = n, a = !0), a && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(t, n) {
    var o = this.canvasData;
    return t = Number(t), t < 0 ? t = 1 / (1 - t) : t = 1 + t, this.zoomTo(o.width * t / o.naturalWidth, null, n);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(t, n, o) {
    var a = this.options, r = this.canvasData, i = r.width, s = r.height, l = r.naturalWidth, c = r.naturalHeight;
    if (t = Number(t), t >= 0 && this.ready && !this.disabled && a.zoomable) {
      var u = l * t, d = c * t;
      if (Ot(this.element, To, {
        ratio: t,
        oldRatio: i / l,
        originalEvent: o
      }) === !1)
        return this;
      if (o) {
        var p = this.pointers, f = Vi(this.cropper), C = p && Object.keys(p).length ? ob(p) : {
          pageX: o.pageX,
          pageY: o.pageY
        };
        r.left -= (u - i) * ((C.pageX - f.left - r.left) / i), r.top -= (d - s) * ((C.pageY - f.top - r.top) / s);
      } else
        $t(n) && Q(n.x) && Q(n.y) ? (r.left -= (u - i) * ((n.x - r.left) / i), r.top -= (d - s) * ((n.y - r.top) / s)) : (r.left -= (u - i) / 2, r.top -= (d - s) / 2);
      r.width = u, r.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(t) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(t));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(t) {
    return t = Number(t), Q(t) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = t % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(t) {
    var n = this.imageData.scaleY;
    return this.scale(t, Q(n) ? n : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(t) {
    var n = this.imageData.scaleX;
    return this.scale(Q(n) ? n : 1, t);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = this.imageData, a = !1;
    return t = Number(t), n = Number(n), this.ready && !this.disabled && this.options.scalable && (Q(t) && (o.scaleX = t, a = !0), Q(n) && (o.scaleY = n, a = !0), a && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = this.options, o = this.imageData, a = this.canvasData, r = this.cropBoxData, i;
    if (this.ready && this.cropped) {
      i = {
        x: r.left - a.left,
        y: r.top - a.top,
        width: r.width,
        height: r.height
      };
      var s = o.width / o.naturalWidth;
      if (ue(i, function(u, d) {
        i[d] = u / s;
      }), t) {
        var l = Math.round(i.y + i.height), c = Math.round(i.x + i.width);
        i.x = Math.round(i.x), i.y = Math.round(i.y), i.width = c - i.x, i.height = l - i.y;
      }
    } else
      i = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return n.rotatable && (i.rotate = o.rotate || 0), n.scalable && (i.scaleX = o.scaleX || 1, i.scaleY = o.scaleY || 1), i;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(t) {
    var n = this.options, o = this.imageData, a = this.canvasData, r = {};
    if (this.ready && !this.disabled && $t(t)) {
      var i = !1;
      n.rotatable && Q(t.rotate) && t.rotate !== o.rotate && (o.rotate = t.rotate, i = !0), n.scalable && (Q(t.scaleX) && t.scaleX !== o.scaleX && (o.scaleX = t.scaleX, i = !0), Q(t.scaleY) && t.scaleY !== o.scaleY && (o.scaleY = t.scaleY, i = !0)), i && this.renderCanvas(!0, !0);
      var s = o.width / o.naturalWidth;
      Q(t.x) && (r.left = t.x * s + a.left), Q(t.y) && (r.top = t.y * s + a.top), Q(t.width) && (r.width = t.width * s), Q(t.height) && (r.height = t.height * s), this.setCropBoxData(r);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? se({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? se({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var t = this.canvasData, n = {};
    return this.ready && ue(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(o) {
      n[o] = t[o];
    }), n;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(t) {
    var n = this.canvasData, o = n.aspectRatio;
    return this.ready && !this.disabled && $t(t) && (Q(t.left) && (n.left = t.left), Q(t.top) && (n.top = t.top), Q(t.width) ? (n.width = t.width, n.height = t.width / o) : Q(t.height) && (n.height = t.height, n.width = t.height * o), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var t = this.cropBoxData, n;
    return this.ready && this.cropped && (n = {
      left: t.left,
      top: t.top,
      width: t.width,
      height: t.height
    }), n || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(t) {
    var n = this.cropBoxData, o = this.options.aspectRatio, a, r;
    return this.ready && this.cropped && !this.disabled && $t(t) && (Q(t.left) && (n.left = t.left), Q(t.top) && (n.top = t.top), Q(t.width) && t.width !== n.width && (a = !0, n.width = t.width), Q(t.height) && t.height !== n.height && (r = !0, n.height = t.height), o && (a ? n.height = n.width / o : r && (n.width = n.height * o)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var n = this.canvasData, o = ab(this.image, this.imageData, n, t);
    if (!this.cropped)
      return o;
    var a = this.getData(t.rounded), r = a.x, i = a.y, s = a.width, l = a.height, c = o.width / Math.floor(n.naturalWidth);
    c !== 1 && (r *= c, i *= c, s *= c, l *= c);
    var u = s / l, d = tt({
      aspectRatio: u,
      width: t.maxWidth || 1 / 0,
      height: t.maxHeight || 1 / 0
    }), p = tt({
      aspectRatio: u,
      width: t.minWidth || 0,
      height: t.minHeight || 0
    }, "cover"), f = tt({
      aspectRatio: u,
      width: t.width || (c !== 1 ? o.width : s),
      height: t.height || (c !== 1 ? o.height : l)
    }), C = f.width, h = f.height;
    C = Math.min(d.width, Math.max(p.width, C)), h = Math.min(d.height, Math.max(p.height, h));
    var g = document.createElement("canvas"), y = g.getContext("2d");
    g.width = Tt(C), g.height = Tt(h), y.fillStyle = t.fillColor || "transparent", y.fillRect(0, 0, C, h);
    var N = t.imageSmoothingEnabled, m = N === void 0 ? !0 : N, O = t.imageSmoothingQuality;
    y.imageSmoothingEnabled = m, O && (y.imageSmoothingQuality = O);
    var I = o.width, v = o.height, A = r, D = i, j, F, T, S, x, B;
    A <= -s || A > I ? (A = 0, j = 0, T = 0, x = 0) : A <= 0 ? (T = -A, A = 0, j = Math.min(I, s + A), x = j) : A <= I && (T = 0, j = Math.min(s, I - A), x = j), j <= 0 || D <= -l || D > v ? (D = 0, F = 0, S = 0, B = 0) : D <= 0 ? (S = -D, D = 0, F = Math.min(v, l + D), B = F) : D <= v && (S = 0, F = Math.min(l, v - D), B = F);
    var R = [A, D, j, F];
    if (x > 0 && B > 0) {
      var z = C / s;
      R.push(T * z, S * z, x * z, B * z);
    }
    return y.drawImage.apply(y, [o].concat(xi(R.map(function(J) {
      return Math.floor(Tt(J));
    })))), g;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(t) {
    var n = this.options;
    return !this.disabled && !Qn(t) && (n.aspectRatio = Math.max(0, t) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(t) {
    var n = this.options, o = this.dragBox, a = this.face;
    if (this.ready && !this.disabled) {
      var r = t === or, i = n.movable && t === Pi;
      t = r || i ? t : Li, n.dragMode = t, rn(o, on, t), St(o, Co, r), St(o, wo, i), n.cropBoxMovable || (rn(a, on, t), St(a, Co, r), St(a, wo, i));
    }
    return this;
  }
}, bb = Ue.Cropper, zi = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (x1(this, e), !t || !W1.test(t.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = t, this.options = se({}, ua, $t(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return k1(e, [{
    key: "init",
    value: function() {
      var n = this.element, o = n.tagName.toLowerCase(), a;
      if (!n[ie]) {
        if (n[ie] = this, o === "img") {
          if (this.isImg = !0, a = n.getAttribute("src") || "", this.originalUrl = a, !a)
            return;
          a = n.src;
        } else
          o === "canvas" && window.HTMLCanvasElement && (a = n.toDataURL());
        this.load(a);
      }
    }
  }, {
    key: "load",
    value: function(n) {
      var o = this;
      if (n) {
        this.url = n, this.imageData = {};
        var a = this.element, r = this.options;
        if (!r.rotatable && !r.scalable && (r.checkOrientation = !1), !r.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (F1.test(n)) {
          z1.test(n) ? this.read(lb(n)) : this.clone();
          return;
        }
        var i = new XMLHttpRequest(), s = this.clone.bind(this);
        this.reloading = !0, this.xhr = i, i.onabort = s, i.onerror = s, i.ontimeout = s, i.onprogress = function() {
          i.getResponseHeader("content-type") !== da && i.abort();
        }, i.onload = function() {
          o.read(i.response);
        }, i.onloadend = function() {
          o.reloading = !1, o.xhr = null;
        }, r.checkCrossOrigin && ha(n) && a.crossOrigin && (n = fa(n)), i.open("GET", n, !0), i.responseType = "arraybuffer", i.withCredentials = a.crossOrigin === "use-credentials", i.send();
      }
    }
  }, {
    key: "read",
    value: function(n) {
      var o = this.options, a = this.imageData, r = db(n), i = 0, s = 1, l = 1;
      if (r > 1) {
        this.url = cb(n, da);
        var c = ub(r);
        i = c.rotate, s = c.scaleX, l = c.scaleY;
      }
      o.rotatable && (a.rotate = i), o.scalable && (a.scaleX = s, a.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var n = this.element, o = this.url, a = n.crossOrigin, r = o;
      this.options.checkCrossOrigin && ha(o) && (a || (a = "anonymous"), r = fa(o)), this.crossOrigin = a, this.crossOriginUrl = r;
      var i = document.createElement("img");
      a && (i.crossOrigin = a), i.src = r || o, i.alt = n.alt || "The image to crop", this.image = i, i.onload = this.start.bind(this), i.onerror = this.stop.bind(this), he(i, na), n.parentNode.insertBefore(i, n.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var n = this, o = this.image;
      o.onload = null, o.onerror = null, this.sizing = !0;
      var a = Ue.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(Ue.navigator.userAgent), r = function(c, u) {
        se(n.imageData, {
          naturalWidth: c,
          naturalHeight: u,
          aspectRatio: c / u
        }), n.initialImageData = se({}, n.imageData), n.sizing = !1, n.sized = !0, n.build();
      };
      if (o.naturalWidth && !a) {
        r(o.naturalWidth, o.naturalHeight);
        return;
      }
      var i = document.createElement("img"), s = document.body || document.documentElement;
      this.sizingImage = i, i.onload = function() {
        r(i.width, i.height), a || s.removeChild(i);
      }, i.src = o.src, a || (i.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", s.appendChild(i));
    }
  }, {
    key: "stop",
    value: function() {
      var n = this.image;
      n.onload = null, n.onerror = null, n.parentNode.removeChild(n), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var n = this.element, o = this.options, a = this.image, r = n.parentNode, i = document.createElement("div");
        i.innerHTML = G1;
        var s = i.querySelector(".".concat(ie, "-container")), l = s.querySelector(".".concat(ie, "-canvas")), c = s.querySelector(".".concat(ie, "-drag-box")), u = s.querySelector(".".concat(ie, "-crop-box")), d = u.querySelector(".".concat(ie, "-face"));
        this.container = r, this.cropper = s, this.canvas = l, this.dragBox = c, this.cropBox = u, this.viewBox = s.querySelector(".".concat(ie, "-view-box")), this.face = d, l.appendChild(a), he(n, Ce), r.insertBefore(s, n.nextSibling), Be(a, na), this.initPreview(), this.bind(), o.initialAspectRatio = Math.max(0, o.initialAspectRatio) || NaN, o.aspectRatio = Math.max(0, o.aspectRatio) || NaN, o.viewMode = Math.max(0, Math.min(3, Math.round(o.viewMode))) || 0, he(u, Ce), o.guides || he(u.getElementsByClassName("".concat(ie, "-dashed")), Ce), o.center || he(u.getElementsByClassName("".concat(ie, "-center")), Ce), o.background && he(s, "".concat(ie, "-bg")), o.highlight || he(d, B1), o.cropBoxMovable && (he(d, wo), rn(d, on, nr)), o.cropBoxResizable || (he(u.getElementsByClassName("".concat(ie, "-line")), Ce), he(u.getElementsByClassName("".concat(ie, "-point")), Ce)), this.render(), this.ready = !0, this.setDragMode(o.dragMode), o.autoCrop && this.crop(), this.setData(o.data), _e(o.ready) && Oe(n, sa, o.ready, {
          once: !0
        }), Ot(n, sa);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var n = this.cropper.parentNode;
        n && n.removeChild(this.cropper), Be(this.element, Ce);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = bb, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(n) {
      se(ua, $t(n) && n);
    }
  }]);
}();
se(zi.prototype, pb, hb, fb, gb, vb, mb);
const _b = {
  name: "FocalPoint",
  props: {
    modelValue: {
      type: Object,
      // default position to the focal point to start
      default: () => ({
        x: 50,
        y: 50
      })
    },
    src: {
      type: String,
      default: () => ""
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      pin: null,
      // local position for the focal point
      localFocalPoint: {
        x: 50,
        y: 50
      },
      // style for the container based on the loaded image
      focalContainerStyle: {
        height: 0,
        width: 0,
        left: 0,
        top: 0
      },
      pinPositioned: !1,
      isModified: !1
    };
  },
  computed: {
    pinStyle() {
      if (!this.pin)
        return null;
      const { width: e, height: t } = this.pin;
      if (!this.localFocalPoint)
        return {
          left: this.s(50, e),
          top: this.s(50, t)
        };
      const { x: n, y: o } = this.localFocalPoint;
      return {
        left: this.s(n, e),
        top: this.s(o, t)
      };
    }
  },
  watch: {
    modelValue(e) {
      this.localFocalPoint = e;
    }
  },
  mounted() {
    this.pin = this.$refs.pin.getBoundingClientRect(), this.modelValue && (this.localFocalPoint = { ...this.modelValue });
  },
  // Remove event listeners on destroy
  beforeUnmount() {
    window !== "undefined" && (window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp));
  },
  methods: {
    click(e) {
      this.isModified = !0, this.$emit("update:modelValue", this.getPercentage(e));
    },
    // Every position needs to be transformed to percentage
    getPercentage(e) {
      const { offsetX: t, offsetY: n } = e, { width: o, height: a } = this.$refs.focalContainer.getBoundingClientRect();
      return {
        x: this.calculatePercentage(t, o),
        y: this.calculatePercentage(n, a)
      };
    },
    // This helps for the drag event of the focal point
    handleContainerMouseMove(e) {
      this.localFocalPoint = this.getPercentage(e);
    },
    // Calculate mouse position on mouse up
    handlePointerMouseUp(e) {
      typeof window < "u" && (this.$refs.focalContainer.removeEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp), this.$refs.pin.style.pointerEvents = "", this.$emit("input", this.localFocalPoint));
    },
    // Calculate mouse position on mouse down
    handlePointerMouseDown(e) {
      typeof window < "u" && (this.$refs.focalContainer.addEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), this.$refs.pin.style.pointerEvents = "none", window.addEventListener("mouseup", this.handlePointerMouseUp), window.addEventListener("blur", this.handlePointerMouseUp));
    },
    loadVirtualImage() {
      const { height: e, width: t } = this.getRenderedImageSize(this.$refs.image), { clientHeight: n = 0, clientWidth: o = 0 } = this.$refs.image.parentNode;
      this.focalContainerStyle = {
        height: e,
        width: t,
        left: (o - t) / 2,
        top: (n - e) / 2
      }, this.pinPositioned = !0;
    },
    getRenderedImageSize(e) {
      const {
        width: t,
        height: n,
        naturalWidth: o,
        naturalHeight: a
      } = e, r = o / a, i = t / n;
      let s, l;
      return r > i ? (l = t, s = t / r) : (l = n * r, s = n), { height: s, width: l };
    },
    calculatePercentage(e, t) {
      return Math.round(e * 100 / t);
    },
    s(e, t) {
      return `calc(${e}% - ${t / 2}px)`;
    },
    // Allow setting focal point from image cropper
    setFocalPoint(e) {
      e && e.x > -1 && e.y > -1 && (this.localFocalPoint = { ...e }), this.$emit("input", this.localFocalPoint);
    },
    // Allow returning focal point to center position from image cropper
    resetFocalPoint() {
      this.localFocalPoint = { x: 50, y: 50 }, this.$emit("input", this.localFocalPoint);
    }
  }
}, yb = { class: "focal-point" }, Cb = ["src"];
function wb(e, t, n, o, a, r) {
  return _(), M("div", yb, [
    $("img", {
      ref: "image",
      src: n.src,
      name: "image",
      class: "virtual-image",
      onLoad: t[0] || (t[0] = (...i) => r.loadVirtualImage && r.loadVirtualImage(...i))
    }, null, 40, Cb),
    Zt($("div", {
      ref: "focalContainer",
      style: je({
        height: `${a.focalContainerStyle.height}px`,
        width: `${a.focalContainerStyle.width}px`,
        left: `${a.focalContainerStyle.left}px`,
        top: `${a.focalContainerStyle.top}px`,
        position: "absolute"
      }),
      onClick: t[2] || (t[2] = (...i) => r.click && r.click(...i))
    }, [
      $("div", {
        ref: "pin",
        style: je(r.pinStyle),
        class: "focal-point-pin",
        onMousedown: t[1] || (t[1] = (...i) => r.handlePointerMouseDown && r.handlePointerMouseDown(...i))
      }, [
        Ne(e.$slots, "pin")
      ], 36)
    ], 4), [
      [Ea, n.focalPointAllowed]
    ])
  ]);
}
const $b = /* @__PURE__ */ X(_b, [["render", wb]]), Sb = {}, Nb = {
  width: "33",
  height: "34",
  viewBox: "0 0 33 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ab(e, t) {
  return _(), M("svg", Nb, t[0] || (t[0] = [
    xa('<circle cx="16.5" cy="17.2773" r="16" fill="black" fill-opacity="0.5" stroke="white"></circle><rect x="16" y="10.7734" width="1" height="5" rx="0.5" fill="white"></rect><rect x="16" y="18.7773" width="1" height="5" rx="0.5" fill="white"></rect><rect x="23" y="16.7773" width="1" height="5" rx="0.5" transform="rotate(90 23 16.7773)" fill="white"></rect><rect x="15" y="16.7773" width="1" height="5" rx="0.5" transform="rotate(90 15 16.7773)" fill="white"></rect>', 5)
  ]));
}
const Wi = /* @__PURE__ */ X(Sb, [["render", Ab]]), VS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wi
}, Symbol.toStringTag, { value: "Module" })), Tb = {
  components: {
    FocalPoint: $b,
    FocalPointIcon: Wi
  },
  props: {
    image: {
      type: Object,
      required: !0
    },
    isCropping: {
      type: Boolean,
      required: !1
    },
    imgStyle: {
      type: Object,
      default: () => ({})
    },
    containerStyle: {
      type: Object,
      default: () => ({})
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      cropper: null,
      localFocalPoint: { x: 50, y: 50 },
      showFocusImage: !0
    };
  },
  watch: {
    isCropping(e) {
      e ? this.cropper.crop() : this.cropper.clear();
    },
    localFocalPoint(e, t) {
      (e.x !== t.x || e.y !== t.y) && this.$emit("focal-point-changed", e);
    }
  },
  mounted() {
    var e;
    (e = this.image) != null && e.properties.focalPointPosition && (this.localFocalPoint = this.image.properties.focalPointPosition), this.cropper = new zi(this.$refs.img, {
      zoomable: !1,
      viewMode: 1,
      autoCropArea: 1,
      autoCrop: !1,
      background: !1,
      modal: !0,
      ready: () => {
        this.enableEditingIfCropperIsReady();
      },
      ...this.$attrs
    });
  },
  computed: {
    src() {
      return this.image.previewUrl;
    },
    alt() {
      return this.image.alt_text;
    }
  },
  methods: {
    enableEditingIfCropperIsReady() {
      this.$emit("set-natural-size", {
        width: this.cropper.initialImageData.naturalWidth,
        height: this.cropper.initialImageData.naturalHeight
      }), this.$emit("enable-editing", !0);
    },
    fn(e, ...t) {
      return this.cropper[e](...t);
    }
  }
}, Ob = { class: "image-container" }, Ib = { class: "focal-point-container" }, Eb = ["src", "alt"];
function xb(e, t, n, o, a, r) {
  const i = L("FocalPointIcon"), s = L("FocalPoint");
  return _(), M("div", Ob, [
    Zt($("div", Ib, [
      E(s, {
        modelValue: a.localFocalPoint,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => a.localFocalPoint = l),
        "is-selected": n.isSelected,
        src: r.src,
        "focal-point-allowed": n.focalPointAllowed
      }, {
        pin: P(() => [
          E(i)
        ]),
        _: 1
      }, 8, ["modelValue", "is-selected", "src", "focal-point-allowed"])
    ], 512), [
      [Ea, !n.isCropping]
    ]),
    $("img", {
      ref: "img",
      class: "image",
      src: r.src,
      alt: r.alt
    }, null, 8, Eb)
  ]);
}
const kb = /* @__PURE__ */ X(Tb, [["render", xb], ["__scopeId", "data-v-0642fe82"]]), Db = {}, Mb = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Pb(e, t) {
  return _(), M("svg", Mb, t[0] || (t[0] = [
    $("path", {
      d: "M5.5 3.57143V1M5.5 7.42857V14.5H19M1 5.5H14.5V12.5714M14.5 16.4286V19",
      stroke: "var(--purple)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Gi = /* @__PURE__ */ X(Db, [["render", Pb]]), FS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gi
}, Symbol.toStringTag, { value: "Module" })), Lb = {
  name: "ImageEditorControls",
  components: {
    CropIcon: Gi
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    isCropping: Boolean,
    disableResetButton: Boolean
  }
}, Rb = { class: "image-controls" }, Bb = ["accept"];
function jb(e, t, n, o, a, r) {
  const i = L("a-button"), s = L("CropIcon"), l = L("a-icon");
  return _(), M("div", Rb, [
    n.isCropping ? (_(), M(ke, { key: 0 }, [
      E(i, {
        variant: "secondary",
        onClick: t[0] || (t[0] = (c) => e.$emit("confirm-crop"))
      }, {
        default: P(() => [
          ge(K(e.$t("builder.imageUploader.confirmCrop")), 1)
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "cancel-crop",
        onClick: t[1] || (t[1] = (c) => e.$emit("cancel-crop"))
      }, {
        default: P(() => [
          ge(K(e.$t("builder.imageUploader.cancelCrop")), 1)
        ]),
        _: 1
      })
    ], 64)) : (_(), M(ke, { key: 1 }, [
      $("input", {
        ref: "replaceImageInput",
        hidden: "",
        class: "file-input",
        type: "file",
        accept: n.acceptedFileTypes,
        onChange: t[2] || (t[2] = (c) => e.$emit("replace-image", c))
      }, null, 40, Bb),
      E(i, {
        variant: "secondary",
        onClick: t[3] || (t[3] = (c) => e.$refs.replaceImageInput.click())
      }, {
        default: P(() => [
          ge(K(e.$t("builder.imageUploader.replace")), 1)
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "begin-crop",
        size: "small",
        "aria-label": "Crop Image",
        onClick: t[4] || (t[4] = (c) => e.$emit("begin-crop"))
      }, {
        default: P(() => [
          E(s)
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "rotate-left",
        size: "small",
        "aria-label": "Rotate Left",
        onClick: t[5] || (t[5] = (c) => e.$emit("rotate", -90))
      }, {
        default: P(() => [
          E(l, { icon: "24:arrow-counter-clockwise" })
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "rotate-right",
        size: "small",
        "aria-label": "Rotate Right",
        onClick: t[6] || (t[6] = (c) => e.$emit("rotate", 90))
      }, {
        default: P(() => [
          E(l, { icon: "24:arrow-clockwise" })
        ]),
        _: 1
      }),
      E(i, {
        disabled: n.disableResetButton,
        variant: "secondary",
        class: "reset-button",
        onClick: t[7] || (t[7] = (c) => e.$emit("reset-image"))
      }, {
        default: P(() => [
          ge(K(e.$t("builder.imageUploader.reset")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 64))
  ]);
}
const Ub = /* @__PURE__ */ X(Lb, [["render", jb], ["__scopeId", "data-v-a8e27e8f"]]), Hb = {}, Vb = {
  id: "info_icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
};
function Fb(e, t) {
  return _(), M("svg", Vb, t[0] || (t[0] = [
    $("circle", {
      class: "cls-1",
      cx: "7",
      cy: "7",
      r: "7"
    }, null, -1),
    $("path", {
      id: "i",
      class: "cls-2",
      d: "M1277.7,1701.09h1.86l0.99-5.1h-1.86Zm1.3-6.09h1.75l0.19-1.06h-1.86Z",
      transform: "translate(-1272 -1691)"
    }, null, -1)
  ]));
}
const Yi = /* @__PURE__ */ X(Hb, [["render", Fb], ["__scopeId", "data-v-88c4d34d"]]), zS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yi
}, Symbol.toStringTag, { value: "Module" })), zb = {
  setup: (e) => ({
    v$: Ra({
      $registerAs: e.validationName
    })
  }),
  name: "ImageEditor",
  components: {
    InfoIcon: Yi,
    ImageCropper: kb,
    ImageEditorControls: Ub
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    validationName: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    isSelected: Boolean
  },
  validations() {
    return {
      image: {
        content: {
          altText: {
            required: (e) => this.decorativeAllowed && this.image.properties.isDecorative || this.isBg ? !0 : (e == null ? void 0 : e.length) > 0
          }
        }
      }
    };
  },
  data() {
    return {
      isCropping: !1,
      originalImage: null,
      changedImageFile: !1
    };
  },
  mounted() {
    this.originalImage = gt(this.image);
  },
  computed: {
    image: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    showError() {
      return this.v$.$error;
    }
  },
  methods: {
    beginCrop() {
      this.isCropping = !0, this.$emit("begin-crop"), this.$refs.imageCropper.fn("crop");
    },
    async confirmCrop() {
      await this.storeCroppedData(), this.cancelCrop();
    },
    cancelCrop() {
      this.$refs.imageCropper.fn("clear"), this.$emit("end-crop"), this.isCropping = !1;
    },
    focalPointChanged(e) {
      this.changedImageFile = !0, e && (this.image.properties.focalPointPosition = e);
    },
    async storeCroppedData() {
      const { type: e = "image/jpeg", name: t = "croppedImage.jpeg" } = this.image.content.imageFile || {}, n = await new Promise(
        (a) => this.$refs.imageCropper.fn("getCroppedCanvas", { imageSmoothingEnabled: !1 }).toBlob(
          (r) => {
            a(r);
          },
          e,
          1
        )
      ), o = new File([n], t, { type: e });
      this.replaceCurrentImage(o);
    },
    replaceCurrentImage(e) {
      if (this.changedImageFile = !0, ui(e, this.acceptedFileTypes))
        return;
      this.applyNewNaturalSize();
      const t = URL.createObjectURL(e);
      this.$refs.imageCropper.fn("replace", t), URL.revokeObjectURL(this.image.previewUrl), this.image = new Ye({
        ...this.image,
        previewUrl: t,
        imageModified: !0,
        content: {
          ...this.image.content,
          imageFile: e
        },
        properties: {
          ...this.image.properties,
          focalPointPosition: { x: 50, y: 50 }
        }
      });
    },
    applyNewNaturalSize() {
      const e = this.$refs.imageCropper.fn("getCroppedCanvas").width, t = this.$refs.imageCropper.fn("getCroppedCanvas").height;
      this.image.properties.naturalWidth = e, this.image.properties.naturalHeight = t, this.image.properties.preferredWidth = e, this.image.properties.preferredHeight = t;
    },
    resetImage() {
      const { imageFile: e } = this.originalImage.content;
      this.focalPointChanged(this.originalImage.properties.focalPointPosition), this.replaceCurrentImage(e), this.changedImageFile = !1;
    },
    async rotate(e) {
      this.$emit("is-rotating", !0), this.$refs.imageCropper.fn("rotate", e), await this.storeCroppedData(), this.$emit("is-rotating", !1);
    },
    uploadNewImage(e) {
      const t = e.target.files[0];
      e.target.value = "", this.replaceCurrentImage(t);
    },
    setNaturalSize({ width: e, height: t }) {
      this.image.properties.naturalWidth = e, this.image.properties.naturalHeight = t, (this.image.properties.preferredWidth === null || this.image.properties.preferredHeight === null) && (this.image.properties.preferredWidth = e, this.image.properties.preferredHeight = t);
    }
  }
}, Wb = { key: 0 }, Gb = { class: "image-preview" }, Yb = { class: "text-inputs" }, Zb = {
  key: 0,
  class: "alt-text"
}, Xb = {
  key: 0,
  class: "decorative-input"
}, Kb = {
  key: 1,
  class: "caption-text"
};
function qb(e, t, n, o, a, r) {
  const i = L("ImageCropper"), s = L("ImageEditorControls"), l = L("a-form-input"), c = L("a-checkbox"), u = L("InfoIcon"), d = L("a-tooltip");
  return n.isSelected ? (_(), M("div", Wb, [
    $("div", Gb, [
      E(i, {
        ref: "imageCropper",
        image: r.image,
        "is-cropping": a.isCropping,
        "focal-point-allowed": n.focalPointAllowed,
        "is-selected": n.isSelected,
        onSetNaturalSize: r.setNaturalSize,
        onFocalPointChanged: r.focalPointChanged
      }, null, 8, ["image", "is-cropping", "focal-point-allowed", "is-selected", "onSetNaturalSize", "onFocalPointChanged"])
    ]),
    E(s, {
      "is-cropping": a.isCropping,
      "disable-reset-button": !a.changedImageFile,
      onBeginCrop: r.beginCrop,
      onCancelCrop: r.cancelCrop,
      onConfirmCrop: r.confirmCrop,
      onResetImage: r.resetImage,
      onReplaceImage: r.uploadNewImage,
      onRotate: r.rotate
    }, null, 8, ["is-cropping", "disable-reset-button", "onBeginCrop", "onCancelCrop", "onConfirmCrop", "onResetImage", "onReplaceImage", "onRotate"]),
    $("div", Yb, [
      n.isBg ? q("", !0) : (_(), M("div", Zb, [
        E(l, {
          id: "alt-text",
          modelValue: r.image.content.altText,
          "onUpdate:modelValue": t[0] || (t[0] = (p) => r.image.content.altText = p),
          disabled: r.image.properties.isDecorative,
          "show-error": r.showError,
          "error-message": e.$t("builder.imageUploader.altTextRequired"),
          label: e.$t("builder.imageUploader.altText"),
          placeholder: e.$t("builder.imageUploader.imageDescriptionPlaceholder"),
          required: ""
        }, null, 8, ["modelValue", "disabled", "show-error", "error-message", "label", "placeholder"]),
        n.decorativeAllowed ? (_(), M("div", Xb, [
          E(c, {
            checked: r.image.properties.isDecorative,
            "onUpdate:checked": t[1] || (t[1] = ({ checked: p }) => r.image.properties.isDecorative = p)
          }, {
            default: P(() => [
              ge(K(e.$t("builder.imageUploader.decorativeImage")), 1)
            ]),
            _: 1
          }, 8, ["checked"]),
          E(d, {
            label: e.$t("builder.imageUploader.decorativeImageTooltip"),
            position: "right",
            size: "small"
          }, {
            default: P(() => [
              E(u)
            ]),
            _: 1
          }, 8, ["label"])
        ])) : q("", !0)
      ])),
      n.captionsAllowed ? (_(), M("div", Kb, [
        E(l, {
          id: "caption-text",
          modelValue: r.image.content.caption,
          "onUpdate:modelValue": t[2] || (t[2] = (p) => r.image.content.caption = p),
          label: e.$t("builder.imageUploader.caption"),
          placeholder: e.$t("builder.imageUploader.captionPlaceholder")
        }, null, 8, ["modelValue", "label", "placeholder"])
      ])) : q("", !0)
    ])
  ])) : q("", !0);
}
const Qb = /* @__PURE__ */ X(zb, [["render", qb], ["__scopeId", "data-v-e0600bd0"]]), Jb = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, e_ = ["fill"], Zi = {
  __name: "ImageIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", Jb, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M957.988,1395.53c0,0.01-.005.02-0.007,0.04A1.5,1.5,0,0,1,956.5,1397H938.511a1.5,1.5,0,0,1-1.5-1.5v-14a1.5,1.5,0,0,1,1.5-1.5H956.5a1.5,1.5,0,0,1,1.5,1.5v14C958,1395.51,957.989,1395.52,957.988,1395.53Zm-19.977-.03a0.5,0.5,0,0,0,.5.5H956.5a0.5,0.5,0,0,0,.471-0.35l-4.549-5.46-3.619,2.71a0.494,0.494,0,0,1-.653-0.05l-3.662-5.67-6.472,5.55v2.77Zm18.984-14a0.5,0.5,0,0,0-.5-0.5H938.511a0.5,0.5,0,0,0-.5.5v9.91l6.173-5.29a0.5,0.5,0,0,1,.679.03l3.682,5.69,3.652-2.74a0.5,0.5,0,0,1,.684.08l4.114,4.94V1381.5Zm-6,4a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,951,1385.5Zm2,0a0.5,0.5,0,1,0-.5.5A0.5,0.5,0,0,0,953,1385.5Z",
        transform: "translate(-932.5 -1373.5)"
      }, null, 8, e_)
    ]));
  }
}, t_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zi
}, Symbol.toStringTag, { value: "Module" })), n_ = {
  name: "ImageThumbnails",
  components: {
    ImageIcon: Zi
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    images: {
      type: Array,
      required: !0
    },
    currentImageIndex: {
      type: Number,
      default: 0
    },
    maxFilesAllowed: {
      type: Number,
      default: 1
    }
  },
  methods: {
    newImageAdded(e) {
      var n, o, a, r;
      const t = ((n = e.dataTransfer) == null ? void 0 : n.files) || ((o = e.target) == null ? void 0 : o.files);
      !t || ((a = e.dataTransfer) == null ? void 0 : a.files.length) === 0 || ((r = e.dataTransfer) == null ? void 0 : r.files.length) > this.maxFilesAllowed || (this.$emit("images-uploaded", t), this.$refs.newFileInput.value = "");
    }
  }
}, o_ = { class: "all-images" }, r_ = ["accept"], a_ = ["src", "onClick"], i_ = { class: "add-new-image" };
function s_(e, t, n, o, a, r) {
  const i = L("ImageIcon"), s = L("a-button");
  return _(), M("div", o_, [
    $("input", {
      ref: "newFileInput",
      hidden: "",
      type: "file",
      accept: n.acceptedFileTypes,
      onChange: t[0] || (t[0] = (...l) => r.newImageAdded && r.newImageAdded(...l))
    }, null, 40, r_),
    (_(!0), M(ke, null, ot(n.images, (l, c) => (_(), M("div", {
      key: c,
      class: "image-thumbnail-container"
    }, [
      $("img", {
        src: l.previewUrl,
        class: be(["preview-image", {
          selected: n.currentImageIndex === c
        }]),
        onClick: (u) => e.$emit("select-image-index", c)
      }, null, 10, a_)
    ]))), 128)),
    n.images.length < n.maxFilesAllowed ? (_(), W(s, {
      key: 0,
      class: "new-image-button preview-image",
      variant: "none",
      onClick: t[1] || (t[1] = (l) => e.$refs.newFileInput.click())
    }, {
      default: P(() => [
        E(i),
        $("p", i_, K(e.$t("builder.imageUploader.addNewImage")), 1)
      ]),
      _: 1
    })) : q("", !0)
  ]);
}
const l_ = /* @__PURE__ */ X(n_, [["render", s_], ["__scopeId", "data-v-335b6278"]]), c_ = {
  name: "ImageUploaderV3",
  components: {
    ImageEditor: Qb,
    ImageThumbnails: l_
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    images: {
      type: Array,
      required: !0
    },
    maxFiles: {
      type: Number,
      default: 1
    },
    initialImageIndex: {
      type: Number,
      default: 0
    },
    uploadApi: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    localUploader: Boolean,
    // TODO: Delete when implementing FAAS
    projectParent: {
      type: String,
      default: ""
    },
    isEditing: Boolean
  },
  setup: () => ({ v$: Ys() }),
  data() {
    return {
      currentImageIndex: 0,
      isCropping: !1,
      isRotating: !1,
      isUploading: !1,
      workingImages: []
    };
  },
  computed: {
    dialogHeader() {
      return this.isEditing ? this.$t("builder.imageUploader.editImage") : this.$t("builder.imageUploader.uploadImage");
    }
  },
  watch: {
    initialImageIndex(e) {
      this.selectImage(e);
    }
  },
  created() {
    this.workingImages = this.images.map((e) => {
      const t = gt(e);
      return {
        ...t,
        previewUrl: t.assetUrl || URL.createObjectURL(t.content.imageFile),
        imageModified: !1,
        isBg: this.isBg
      };
    }), this.selectImage(this.initialImageIndex);
  },
  methods: {
    addNewImageFile(e) {
      const t = e[0];
      if (this.fileHasValidationError(t))
        return;
      const n = URL.createObjectURL(t);
      this.workingImages.push(
        new Ye({
          imageModified: !1,
          previewUrl: n,
          content: {
            imageFile: t
          }
        })
      ), this.currentImageIndex = this.workingImages.length - 1;
    },
    async createCmsRequest(e) {
      const t = {
        create_px2560: !1,
        create_px1920: !1,
        create_px1600: !1,
        create_px1280: !1,
        create_px960: !1,
        create_px600: !1
      }, n = await Vf(e.content.imageFile);
      return fr.post(this.uploadApi, {
        asset: {
          file_base64: n,
          upload_options: t
        }
      });
    },
    createUploadRequests() {
      return this.workingImages.map((e) => {
        const t = new FormData();
        if (t.append("file", e.content.imageFile), e.content.assetId === "" || e.imageModified)
          switch (this.projectParent) {
            case "cms":
              return this.createCmsRequest(e);
            default:
              return fr.post(this.uploadApi, t, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
          }
        return Promise.resolve({
          data: { id: e.content.assetId },
          status: 201
        });
      });
    },
    fileHasValidationError(e) {
      const t = e.size / 1e6 > this.uploadLimit;
      return this.acceptedFileTypes.includes(e.type) ? t ? (console.error("File size exceeds limit"), !0) : !1 : (console.error("Unsupported File"), !0);
    },
    selectImage(e) {
      this.currentImageIndex = e >= 0 ? e : this.workingImages.length - 1;
    },
    async uploadImages() {
      if (this.v$.$touch(), this.v$.$error) {
        const n = [];
        this.workingImages.forEach((o, a) => {
          var r;
          (r = this.v$.$getResultsForChild(`image-${a}`)) != null && r.$error && n.push(a);
        }), this.currentImageIndex = n[0];
        return;
      }
      this.isUploading = !0;
      let e = null;
      if (!this.localUploader) {
        const n = this.createUploadRequests();
        if (e = await Promise.allSettled(n), e.some((o) => o.status === "rejected")) {
          this.isUploading = !1;
          return;
        }
      }
      const t = this.workingImages.map((n, o) => {
        var r, i;
        URL.revokeObjectURL(n.previewUrl);
        const a = this.localUploader ? URL.createObjectURL(this.workingImages[o].content.imageFile) : this.getImageAssetUrl(e[o]);
        return new Ye({
          ...n,
          assetUrl: a,
          content: {
            ...n.content,
            assetId: this.localUploader ? crypto.randomUUID() : (i = (r = e[o].value) == null ? void 0 : r.data) == null ? void 0 : i.id,
            assetUrl: a
          }
        });
      });
      this.$emit("images-changed", t), this.isUploading = !1;
    },
    // TODO: Delete when implementing FAAS
    getImageAssetUrl(e) {
      var t, n, o, a, r;
      if (this.projectParent === "engage")
        return ((n = (t = e.value) == null ? void 0 : t.data) == null ? void 0 : n.file) || "";
      if (this.projectParent === "cms")
        return ((r = (a = (o = e.value) == null ? void 0 : o.data) == null ? void 0 : a.file) == null ? void 0 : r.url) || "";
    }
  }
};
function d_(e, t, n, o, a, r) {
  const i = L("a-dialog-header"), s = L("ImageThumbnails"), l = L("ImageEditor"), c = L("a-dialog-content"), u = L("a-button"), d = L("a-dialog-footer"), p = L("a-dialog");
  return _(), W(p, {
    show: "",
    "no-close-on-overlay": "",
    size: "l",
    class: "image-editor",
    onClose: t[3] || (t[3] = (f) => e.$emit("close"))
  }, {
    default: P(() => [
      E(i, null, {
        default: P(() => [
          ge(K(r.dialogHeader), 1)
        ]),
        _: 1
      }),
      E(c, { class: "content" }, {
        default: P(() => [
          n.maxFiles > 1 ? (_(), W(s, {
            key: 0,
            "accepted-file-types": n.acceptedFileTypes,
            images: a.workingImages,
            "max-files-allowed": n.maxFiles,
            "current-image-index": a.currentImageIndex,
            onImagesUploaded: r.addNewImageFile,
            onSelectImageIndex: r.selectImage
          }, null, 8, ["accepted-file-types", "images", "max-files-allowed", "current-image-index", "onImagesUploaded", "onSelectImageIndex"])) : q("", !0),
          (_(!0), M(ke, null, ot(a.workingImages, (f, C) => (_(), M("div", { key: C }, [
            E(l, {
              modelValue: a.workingImages[C],
              "onUpdate:modelValue": (h) => a.workingImages[C] = h,
              "is-selected": C === a.currentImageIndex,
              "validation-name": `image-${C}`,
              "accepted-file-types": n.acceptedFileTypes,
              "captions-allowed": n.captionsAllowed,
              "decorative-allowed": n.decorativeAllowed,
              "is-bg": n.isBg,
              "focal-point-allowed": n.focalPointAllowed,
              onBeginCrop: t[0] || (t[0] = (h) => a.isCropping = !0),
              onEndCrop: t[1] || (t[1] = (h) => a.isCropping = !1),
              onIsRotating: t[2] || (t[2] = (h) => a.isRotating = h)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "is-selected", "validation-name", "accepted-file-types", "captions-allowed", "decorative-allowed", "is-bg", "focal-point-allowed"])
          ]))), 128))
        ]),
        _: 1
      }),
      E(d, { class: "footer" }, {
        default: P(() => [
          E(u, {
            variant: "primary",
            disabled: a.isCropping || a.isRotating || a.isUploading,
            onClick: r.uploadImages
          }, {
            default: P(() => [
              ge(K(e.$t("builder.imageUploader.upload")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const u_ = /* @__PURE__ */ X(c_, [["render", d_], ["__scopeId", "data-v-b6eb4401"]]), p_ = {
  name: "BackgroundImageControl",
  components: {
    ImageUploader: u_,
    NodeControl: ft
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    },
    assets: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    uploadApi: {
      type: String,
      required: !0
    }
  },
  inject: ["state"],
  data() {
    return {
      options: [
        {
          label: this.$t("builder.backgroundImage.fill"),
          value: "fill"
        },
        {
          label: this.$t("builder.backgroundImage.tile"),
          value: "tile"
        },
        {
          label: this.$t("builder.backgroundImage.center"),
          value: "center"
        }
      ],
      acceptedFileTypes: "image/png, image/jpg, image/jpeg, image/gif",
      showImageUploader: !1,
      preloadedImage: null
    };
  },
  computed: {
    workingImage() {
      return [this.preloadedImage || this.image];
    },
    image: {
      get() {
        var e, t, n;
        return (n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundImage) == null ? void 0 : n.image;
      },
      set(e) {
        this.$emit("update", "image", e);
      }
    },
    backgroundPosition: {
      get() {
        var e, t;
        return ((t = (e = this.image) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundPosition) || "fill";
      },
      set(e) {
        this.image.properties.backgroundPosition = e;
      }
    },
    tilePercentage: {
      get() {
        var e, t;
        return ((t = (e = this.image) == null ? void 0 : e.properties) == null ? void 0 : t.tilePercentage) || 100;
      },
      set(e) {
        this.image.properties.tilePercentage = e;
      }
    },
    backgroundImage() {
      var e, t;
      return (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundImage;
    },
    imagePreviewStyles() {
      var n, o, a, r, i, s, l, c, u, d, p, f;
      let e = {};
      switch ((o = (n = this.image) == null ? void 0 : n.properties) == null ? void 0 : o.backgroundPosition) {
        case "center":
          e = {
            "background-position": "center",
            "background-repeat": "no-repeat",
            "background-size": "contain"
          };
          break;
        case "fill":
          e = {
            "background-repeat": "no-repeat",
            "background-size": "cover",
            "background-position": `${((i = (r = (a = this.image) == null ? void 0 : a.properties) == null ? void 0 : r.focalPointPosition) == null ? void 0 : i.x) || 50}% ${((c = (l = (s = this.image) == null ? void 0 : s.properties) == null ? void 0 : l.focalPointPosition) == null ? void 0 : c.y) || 50}%`
          };
          break;
        case "tile":
          e = {
            "background-repeat": "repeat",
            "background-size": `${((d = (u = this.image) == null ? void 0 : u.properties) == null ? void 0 : d.tilePercentage) || 100}%`
          };
          break;
      }
      const t = (f = (p = this.image) == null ? void 0 : p.content) != null && f.assetId ? `url(${this.asset.url})` : `url("${I1}")`;
      return {
        ...e,
        backgroundImage: t
      };
    },
    asset() {
      var e, t;
      return this.assets[(t = (e = this.image) == null ? void 0 : e.content) == null ? void 0 : t.assetId] || "";
    },
    imageUploaderLabel() {
      var e, t;
      return (t = (e = this.image) == null ? void 0 : e.content) != null && t.assetId ? this.$t("builder.imageUploader.editImage") : this.$t("builder.imageUploader.uploadImage");
    }
  },
  methods: {
    toggleBackgroundImage(e) {
      this.image === null && (this.image = new Ye()), this.$emit("update", "toggle", e);
    },
    openImageUploader() {
      var e, t;
      (t = (e = this.image) == null ? void 0 : e.content) != null && t.assetId ? this.editImage() : this.$refs.fileInput.click();
    },
    openUploadModal() {
      this.$refs.fileInput && (this.$refs.fileInput.value = ""), this.showImageUploader = !0;
    },
    uploadFile(e) {
      var s, l, c, u;
      const t = ((s = e.dataTransfer) == null ? void 0 : s.files) || ((l = e.target) == null ? void 0 : l.files);
      if (!t || ((c = e.dataTransfer) == null ? void 0 : c.files.length) === 0 || ((u = e.dataTransfer) == null ? void 0 : u.files.length) > 1)
        return;
      const n = Array.from(t), o = n.every((d) => d.name.includes(".")), a = n.some((d) => d.type === ""), r = n.some(
        (d) => ui(d, this.acceptedFileTypes)
      );
      if (!o || a || r)
        return;
      const i = Array.from(n).map(
        (d) => new Ye({
          content: {
            imageFile: d
          },
          properties: {
            isDecorative: !0
          }
        })
      );
      this.preloadedImage = i[0], this.openUploadModal();
    },
    updateImage(e) {
      const t = e[0];
      t.assetUrl && this.$emit("asset-entry", Ff(t)), this.image = t, this.showImageUploader = !1, this.preloadedImage = null;
    },
    editImage() {
      this.showImageUploader = !0;
    },
    removeImage() {
      this.image = new Ye(), this.preloadedImage = null;
    },
    cancelChanges() {
      this.preloadedImage = null, this.showImageUploader = !1;
    }
  }
}, h_ = { class: "inline-control gap-5" }, f_ = ["accept"], g_ = { class: "inline-control position-radio-group" };
function v_(e, t, n, o, a, r) {
  var f;
  const i = L("a-toggle"), s = L("a-button"), l = L("ImageUploader"), c = L("portal"), u = L("a-form-input"), d = L("a-form-radio-group"), p = L("NodeControl");
  return _(), W(p, null, Mo({
    title: P(() => [
      $("h4", null, K(e.$t("builder.backgroundImage.title")), 1)
    ]),
    control: P(() => [
      E(i, {
        "model-value": r.backgroundImage.toggle,
        "onUpdate:modelValue": t[0] || (t[0] = (C) => r.toggleBackgroundImage(C))
      }, null, 8, ["model-value"])
    ]),
    _: 2
  }, [
    (f = r.backgroundImage) != null && f.toggle ? {
      name: "content",
      fn: P(() => {
        var C;
        return [
          $("div", h_, [
            $("input", {
              ref: "fileInput",
              type: "file",
              hidden: "",
              accept: a.acceptedFileTypes,
              onChange: t[1] || (t[1] = (...h) => r.uploadFile && r.uploadFile(...h)),
              onClick: t[2] || (t[2] = (h) => h.target.value = null)
            }, null, 40, f_),
            $("div", {
              class: "image-thumbnail",
              style: je(r.imagePreviewStyles),
              onClick: t[3] || (t[3] = (...h) => r.openImageUploader && r.openImageUploader(...h))
            }, null, 4),
            E(s, {
              variant: "tertiary",
              onClick: r.openImageUploader
            }, {
              default: P(() => [
                ge(K(r.imageUploaderLabel), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            a.showImageUploader ? (_(), W(c, {
              key: 0,
              to: "root-dialog-container"
            }, {
              default: P(() => [
                E(l, {
                  "is-bg": "",
                  "max-files": 1,
                  images: r.workingImage,
                  "local-uploader": r.state.builder.api.localUploader,
                  "upload-api": n.uploadApi,
                  "project-parent": r.state.builder.api.projectParent,
                  onImagesChanged: r.updateImage,
                  onClose: r.cancelChanges
                }, null, 8, ["images", "local-uploader", "upload-api", "project-parent", "onImagesChanged", "onClose"])
              ]),
              _: 1
            })) : q("", !0),
            (C = r.image.content) != null && C.assetId ? (_(), W(s, {
              key: 1,
              class: "clear-button",
              variant: "link",
              onClick: r.removeImage
            }, {
              default: P(() => [
                ge(K(e.$t("builder.clear")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : q("", !0)
          ]),
          $("div", g_, [
            E(d, {
              label: e.$t("builder.backgroundImage.position"),
              options: a.options,
              modelValue: r.backgroundPosition,
              "onUpdate:modelValue": t[5] || (t[5] = (h) => r.backgroundPosition = h)
            }, {
              "content-tile": P(() => [
                $("div", null, [
                  E(u, {
                    modelValue: r.tilePercentage,
                    "onUpdate:modelValue": t[4] || (t[4] = (h) => r.tilePercentage = h),
                    class: "tile-input",
                    type: "number",
                    width: "70px",
                    height: "40px",
                    label: `${e.$t("builder.backgroundImage.tile")} (%)`,
                    min: 1,
                    max: 100
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _: 1
            }, 8, ["label", "options", "modelValue"])
          ])
        ];
      }),
      key: "0"
    } : void 0
  ]), 1024);
}
const Xi = /* @__PURE__ */ X(p_, [["render", v_], ["__scopeId", "data-v-41e5e8fc"]]), m_ = {}, b_ = {
  id: "backButtonIcon",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function __(e, t) {
  return _(), M("svg", b_, t[0] || (t[0] = [
    $("path", {
      id: "background",
      d: "M0 3C0 1.34315 1.34315 0 3 0H29C30.6569 0 32 1.34315 32 3V29C32 30.6569 30.6569 32 29 32H3C1.34315 32 0 30.6569 0 29V3Z",
      fill: "none"
    }, null, -1),
    $("path", {
      id: "arrow",
      d: "M25 17C25.5523 17 26 16.5523 26 16C26 15.4477 25.5523 15 25 15L25 17ZM7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071L13.6569 23.0711C14.0474 23.4616 14.6805 23.4616 15.0711 23.0711C15.4616 22.6805 15.4616 22.0474 15.0711 21.6569L9.41421 16L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L7.29289 15.2929ZM25 15L8 15L8 17L25 17L25 15Z",
      fill: "var(--purple)"
    }, null, -1)
  ]));
}
const Ki = /* @__PURE__ */ X(m_, [["render", __]]), WS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ki
}, Symbol.toStringTag, { value: "Module" })), y_ = {
  name: "SidebarHeader",
  components: {
    BackIcon: Ki
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  }
}, C_ = { class: "header" };
function w_(e, t, n, o, a, r) {
  const i = L("BackIcon");
  return _(), M("div", C_, [
    $("div", {
      class: "sidebar-back-button",
      onClick: t[0] || (t[0] = (s) => e.$emit("close-sidebar"))
    }, [
      E(i)
    ]),
    $("h4", null, K(n.title), 1)
  ]);
}
const ar = /* @__PURE__ */ X(y_, [["render", w_], ["__scopeId", "data-v-fcc5486e"]]), $_ = {
  name: "GlobalSettings",
  components: {
    BackgroundColorControl: di,
    BackgroundImageControl: Xi,
    NodeControl: ft,
    SidebarHeader: ar
  },
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    }
  },
  inject: ["state"],
  computed: {
    globalCustomProperties() {
      var e, t;
      return ((t = (e = this.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.global) || {};
    },
    structure() {
      return this.builder.structure;
    }
  }
};
function S_(e, t, n, o, a, r) {
  const i = L("SidebarHeader"), s = L("a-toggle"), l = L("NodeControl"), c = L("BackgroundColorControl"), u = L("BackgroundImageControl");
  return _(), M(ke, null, [
    E(i, {
      title: e.$t("builder.builderTabs.globalSettings"),
      onCloseSidebar: t[0] || (t[0] = (d) => e.$emit("close-sidebar"))
    }, null, 8, ["title"]),
    r.globalCustomProperties.headerSlotOptional ? (_(), W(l, { key: 0 }, {
      title: P(() => [
        $("h4", null, K(e.$t("builder.header")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.showHeaderSlot,
          "onUpdate:modelValue": t[1] || (t[1] = (d) => r.globalCustomProperties.showHeaderSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : q("", !0),
    r.globalCustomProperties.footerSlotOptional ? (_(), W(l, { key: 1 }, {
      title: P(() => [
        $("h4", null, K(e.$t("builder.footer")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.showFooterSlot,
          "onUpdate:modelValue": t[2] || (t[2] = (d) => r.globalCustomProperties.showFooterSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : q("", !0),
    r.globalCustomProperties.backgroundColorAllowed ? (_(), W(c, {
      key: 2,
      node: r.structure,
      onUpdate: t[3] || (t[3] = (d, p) => r.structure.properties.backgroundColor[d] = p)
    }, null, 8, ["node"])) : q("", !0),
    r.globalCustomProperties.backgroundImageAllowed ? (_(), W(u, {
      key: 3,
      node: r.structure,
      assets: r.state.builder.assets,
      "upload-api": r.state.builder.api.images,
      onUpdate: t[4] || (t[4] = (d, p) => r.structure.properties.backgroundImage[d] = p),
      onAssetEntry: t[5] || (t[5] = (d) => r.state.addAsset(d))
    }, null, 8, ["node", "assets", "upload-api"])) : q("", !0),
    r.globalCustomProperties.confirmOnDeleteDialogAllowed ? (_(), W(l, { key: 4 }, {
      title: P(() => [
        $("h4", null, K(e.$t("builder.controls.global.showConfirmationDialog")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.showConfirmOnDeleteDialog,
          "onUpdate:modelValue": t[6] || (t[6] = (d) => r.globalCustomProperties.showConfirmOnDeleteDialog = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : q("", !0),
    E(l, null, {
      title: P(() => [
        $("h4", null, K(e.$t("builder.controls.global.focusNewNodeOnCreate")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.focusNewNodeOnCreate,
          "onUpdate:modelValue": t[7] || (t[7] = (d) => r.globalCustomProperties.focusNewNodeOnCreate = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64);
}
const N_ = /* @__PURE__ */ X($_, [["render", S_], ["__scopeId", "data-v-c08ba7c5"]]), A_ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T_ = ["fill"], O_ = ["fill"], I_ = ["fill"], E_ = ["fill"], x_ = ["fill"], k_ = ["fill"], D_ = {
  __name: "AccordionIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", A_, [
      $("rect", {
        x: "5",
        y: "9",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: n.value
      }, null, 8, T_),
      $("rect", {
        x: "5",
        y: "21",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: n.value
      }, null, 8, O_),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M21 13H6L6 18H21V13ZM6 12C5.44772 12 5 12.4477 5 13V18C5 18.5523 5.44772 19 6 19H21C21.5523 19 22 18.5523 22 18V13C22 12.4477 21.5523 12 21 12H6Z",
        fill: n.value
      }, null, 8, I_),
      $("rect", {
        x: "24",
        y: "15",
        width: "3",
        height: "1",
        rx: "0.5",
        fill: n.value
      }, null, 8, E_),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 9C26.1791 9 26 8.82091 26 8.6V8.4C26 8.17909 25.8209 8 25.6 8H25.4C25.1791 8 25 8.17909 25 8.4V8.6C25 8.82091 24.8209 9 24.6 9H24.4C24.1791 9 24 9.17909 24 9.4V9.6C24 9.82091 24.1791 10 24.4 10H24.6C24.8209 10 25 10.1791 25 10.4V10.6C25 10.8209 25.1791 11 25.4 11H25.6C25.8209 11 26 10.8209 26 10.6V10.4C26 10.1791 26.1791 10 26.4 10H26.6C26.8209 10 27 9.82091 27 9.6V9.4C27 9.17909 26.8209 9 26.6 9H26.4Z",
        fill: n.value
      }, null, 8, x_),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 21C26.1791 21 26 20.8209 26 20.6V20.4C26 20.1791 25.8209 20 25.6 20H25.4C25.1791 20 25 20.1791 25 20.4V20.6C25 20.8209 24.8209 21 24.6 21H24.4C24.1791 21 24 21.1791 24 21.4V21.6C24 21.8209 24.1791 22 24.4 22H24.6C24.8209 22 25 22.1791 25 22.4V22.6C25 22.8209 25.1791 23 25.4 23H25.6C25.8209 23 26 22.8209 26 22.6V22.4C26 22.1791 26.1791 22 26.4 22H26.6C26.8209 22 27 21.8209 27 21.6V21.4C27 21.1791 26.8209 21 26.6 21H26.4Z",
        fill: n.value
      }, null, 8, k_)
    ]));
  }
}, M_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D_
}, Symbol.toStringTag, { value: "Module" })), P_ = {
  width: "30",
  height: "30",
  viewBox: "0 0 33 10",
  fill: "none"
}, L_ = ["stroke"], R_ = {
  __name: "ButtonIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", P_, [
      $("rect", {
        x: "0.5",
        y: "0.5",
        width: "32",
        height: "9",
        fill: "transparent",
        stroke: n.value
      }, null, 8, L_)
    ]));
  }
}, B_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R_
}, Symbol.toStringTag, { value: "Module" })), j_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, U_ = ["stroke"], H_ = {
  __name: "CardIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", j_, [
      $("path", {
        id: "card",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        "fill-rule": "evenodd",
        d: "M938,1887h20a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2H938a2,2,0,0,1-2-2v-11A2,2,0,0,1,938,1887Z",
        transform: "translate(-933 -1879.5)"
      }, null, 8, U_)
    ]));
  }
}, V_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H_
}, Symbol.toStringTag, { value: "Module" })), F_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, z_ = ["fill"], W_ = {
  __name: "EmbedIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", F_, [
      $("path", {
        id: "embed",
        class: "cls-1",
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M934,1538.82l9.986-5.82v1.34l-9.155,5.17v0.04l9.155,6.13v1.33L934,1540.2v-1.38Zm25,0-9.986-5.82v1.34l9.155,5.17v0.04l-9.155,6.13v1.33L959,1540.2v-1.38Z",
        transform: "translate(-931.5 -1525)"
      }, null, 8, z_)
    ]));
  }
}, G_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W_
}, Symbol.toStringTag, { value: "Module" })), Y_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}, Z_ = ["fill"], X_ = ["fill"], K_ = ["fill"], q_ = ["fill"], Q_ = ["fill"], J_ = ["fill"], ey = {
  __name: "FormIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", Y_, [
      $("path", {
        d: "M10 7.5C10 6.67157 10.6716 6 11.5 6H22.5C23.3284 6 24 6.67157 24 7.5V21.5C24 22.3284 23.3284 23 22.5 23H22V22H22.5C22.7761 22 23 21.7762 23 21.5V7.5C23 7.22385 22.7761 7 22.5 7H11.5C11.2239 7 11 7.22385 11 7.5V8H10V7.5Z",
        fill: n.value
      }, null, 8, Z_),
      $("path", {
        d: "M10 12H18V13H10V12Z",
        fill: n.value
      }, null, 8, X_),
      $("path", {
        d: "M10 15H18V16H10V15Z",
        fill: n.value
      }, null, 8, K_),
      $("path", {
        d: "M18 18H10V19H18V18Z",
        fill: n.value
      }, null, 8, q_),
      $("path", {
        d: "M10 21H18V22H10V21Z",
        fill: n.value
      }, null, 8, Q_),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 10.5C7 9.67157 7.67157 9 8.5 9H19.5C20.3284 9 21 9.67157 21 10.5V24.5C21 25.3284 20.3284 26 19.5 26H8.5C7.67157 26 7 25.3284 7 24.5V10.5ZM8.5 10C8.22385 10 8 10.2238 8 10.5V24.5C8 24.7762 8.22385 25 8.5 25H19.5C19.7761 25 20 24.7762 20 24.5V10.5C20 10.2238 19.7761 10 19.5 10H8.5Z",
        fill: n.value
      }, null, 8, J_)
    ]));
  }
}, ty = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ey
}, Symbol.toStringTag, { value: "Module" })), ny = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "51",
  height: "17",
  viewBox: "0 0 51 17"
}, oy = ["stroke"], ry = ["stroke"], ay = ["stroke"], iy = ["stroke"], sy = {
  __name: "FourColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", ny, [
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, oy),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "13.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ry),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "26.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ay),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "39.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, iy)
    ]));
  }
}, ly = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sy
}, Symbol.toStringTag, { value: "Module" })), cy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "17",
  viewBox: "0 0 56 17"
}, dy = ["stroke"], uy = {
  __name: "FullWidthIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", cy, [
      $("rect", {
        id: "full-width",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "55",
        height: "16"
      }, null, 8, dy)
    ]));
  }
}, py = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uy
}, Symbol.toStringTag, { value: "Module" })), hy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, fy = ["fill"], gy = {
  __name: "GalleryIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", hy, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1052.53,1392a0.5,0.5,0,0,1-.5-0.5v-9.27a0.24,0.24,0,0,0-.23-0.23h-16.53a0.233,0.233,0,0,0-.23.23v0.27a0.5,0.5,0,0,1-.5.5,0.5,0.5,0,0,1-.5-0.5v-0.27a1.229,1.229,0,0,1,1.23-1.23h16.53a1.236,1.236,0,0,1,1.23,1.23v9.27A0.5,0.5,0,0,1,1052.53,1392Zm-1.5-7.74v12.48a1.249,1.249,0,0,1-1.23,1.26h-17.53a1.249,1.249,0,0,1-1.23-1.26v-3.38h0v-9.1a1.249,1.249,0,0,1,1.23-1.26h17.53A1.249,1.249,0,0,1,1051.03,1384.26Zm-18.99,12.48a0.254,0.254,0,0,0,.23.26h17.53a0.254,0.254,0,0,0,.23-0.26v-0.38a0.449,0.449,0,0,1-.13-0.1l-4.39-5.03-2.62,2.62a0.5,0.5,0,0,1-.38.15,0.5,0.5,0,0,1-.36-0.18l-4.65-5.58-5.46,5.34v3.16Zm0-12.48v7.92l5.15-5.04a0.468,0.468,0,0,1,.37-0.14,0.5,0.5,0,0,1,.36.18l4.65,5.58,2.61-2.61a0.463,0.463,0,0,1,.37-0.15,0.494,0.494,0,0,1,.36.17l4.12,4.72v-10.63a0.254,0.254,0,0,0-.23-0.26h-17.53A0.254,0.254,0,0,0,1032.04,1384.26Zm13.43,4.74a1.5,1.5,0,1,1,1.49-1.5A1.5,1.5,0,0,1,1045.47,1389Zm0-2a0.5,0.5,0,0,0-.5.5A0.5,0.5,0,1,0,1045.47,1387Z",
        transform: "translate(-1027.03 -1374.5)"
      }, null, 8, fy)
    ]));
  }
}, vy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gy
}, Symbol.toStringTag, { value: "Module" })), my = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, by = ["fill"], _y = {
  __name: "HeadingIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", my, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M954,1322v-9h-2v-1a2.636,2.636,0,0,0,.546.18,2.124,2.124,0,0,0,.726-0.3,1.913,1.913,0,0,0,.529-0.57,4.728,4.728,0,0,0,.427-1.32H955v11.99Zm-6-6h-7v6l-1-.01v-11.98l1-.01v5h7v-5l0.923,0.01v11.98L948,1322v-6Z",
        transform: "translate(-932.5 -1301)"
      }, null, 8, by)
    ]));
  }
}, yy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _y
}, Symbol.toStringTag, { value: "Module" })), Cy = {
  id: "left_sidebar",
  "data-name": "left sidebar",
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "17",
  viewBox: "0 0 47 17"
}, wy = ["stroke"], $y = ["stroke"], Sy = {
  __name: "LeftSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", Cy, [
      $("rect", {
        id: "Rectangle_2133_copy_21",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, wy),
      $("rect", {
        id: "Rectangle_2133_copy_21-2",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, $y)
    ]));
  }
}, Ny = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sy
}, Symbol.toStringTag, { value: "Module" })), Ay = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ty = ["fill"], Oy = ["fill"], Iy = ["fill"], Ey = ["fill"], xy = ["fill"], ky = ["fill"], Dy = ["fill"], My = ["fill"], Py = ["fill"], Ly = {
  __name: "NavigationIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", Ay, [
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M19 1H5C4.44771 1 4 1.44772 4 2V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V2C20 1.44772 19.5523 1 19 1ZM5 0C3.89543 0 3 0.89543 3 2V22C3 23.1046 3.89543 24 5 24H19C20.1046 24 21 23.1046 21 22V2C21 0.895431 20.1046 0 19 0H5Z",
        fill: n.value
      }, null, 8, Ty),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 4.5C8 4.22386 8.22386 4 8.5 4H16.5C16.7761 4 17 4.22386 17 4.5C17 4.77614 16.7761 5 16.5 5H8.5C8.22386 5 8 4.77614 8 4.5Z",
        fill: n.value
      }, null, 8, Oy),
      $("path", {
        d: "M7 4.5C7 4.77614 6.77614 5 6.5 5C6.22386 5 6 4.77614 6 4.5C6 4.22386 6.22386 4 6.5 4C6.77614 4 7 4.22386 7 4.5Z",
        fill: n.value
      }, null, 8, Iy),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 7.5C8 7.22386 8.22386 7 8.5 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H8.5C8.22386 8 8 7.77614 8 7.5Z",
        fill: n.value
      }, null, 8, Ey),
      $("path", {
        d: "M7 7.5C7 7.77614 6.77614 8 6.5 8C6.22386 8 6 7.77614 6 7.5C6 7.22386 6.22386 7 6.5 7C6.77614 7 7 7.22386 7 7.5Z",
        fill: n.value
      }, null, 8, xy),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 10.5C8 10.2239 8.22386 10 8.5 10H16.5C16.7761 10 17 10.2239 17 10.5C17 10.7761 16.7761 11 16.5 11H8.5C8.22386 11 8 10.7761 8 10.5Z",
        fill: n.value
      }, null, 8, ky),
      $("path", {
        d: "M7 10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 10.2239 7 10.5Z",
        fill: n.value
      }, null, 8, Dy),
      $("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 13.5C8 13.2239 8.22386 13 8.5 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H8.5C8.22386 14 8 13.7761 8 13.5Z",
        fill: n.value
      }, null, 8, My),
      $("path", {
        d: "M7 13.5C7 13.7761 6.77614 14 6.5 14C6.22386 14 6 13.7761 6 13.5C6 13.2239 6.22386 13 6.5 13C6.77614 13 7 13.2239 7 13.5Z",
        fill: n.value
      }, null, 8, Py)
    ]));
  }
}, Ry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ly
}, Symbol.toStringTag, { value: "Module" })), By = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "17",
  viewBox: "0 0 39 17"
}, jy = ["stroke"], Uy = {
  __name: "OneColumnIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", By, [
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "38",
        height: "16"
      }, null, 8, jy)
    ]));
  }
}, Hy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uy
}, Symbol.toStringTag, { value: "Module" })), Vy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, Fy = ["stroke"], zy = {
  __name: "QuoteIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", Vy, [
      $("path", {
        fill: "none",
        stroke: n.value,
        "fill-rule": "evenodd",
        d: "M1042.18,1981s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1051.97,1977.66,1042.18,1981,1042.18,1981Zm-13,0s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1038.97,1977.66,1029.18,1981,1029.18,1981Z",
        transform: "translate(-1025.045 -1956.5)"
      }, null, 8, Fy)
    ]));
  }
}, Wy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zy
}, Symbol.toStringTag, { value: "Module" })), Gy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "17",
  viewBox: "0 0 47 17"
}, Yy = ["stroke"], Zy = ["stroke"], Xy = {
  __name: "RightSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", Gy, [
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, Yy),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, Zy)
    ]));
  }
}, Ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xy
}, Symbol.toStringTag, { value: "Module" })), qy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, Qy = ["fill"], Jy = {
  __name: "SeparatorIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", qy, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1031,1680v-1h26v1h-26Z",
        transform: "translate(-1029 -1664.5)"
      }, null, 8, Qy)
    ]));
  }
}, e2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jy
}, Symbol.toStringTag, { value: "Module" })), t2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, n2 = ["fill"], o2 = {
  __name: "SliderIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", t2, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M959.5,1472a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,959.5,1472Zm-3,1a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,956.5,1473Zm-3,0h-12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,.5-0.5h12a0.5,0.5,0,0,1,.5.5v12A0.5,0.5,0,0,1,953.5,1473Zm-0.5-12H942v11h11v-11Zm-14.5,12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,938.5,1473Zm-3-1a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,935.5,1472Z",
        transform: "translate(-932.5 -1451.5)"
      }, null, 8, n2)
    ]));
  }
}, r2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: o2
}, Symbol.toStringTag, { value: "Module" })), a2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, i2 = ["stroke"], s2 = {
  __name: "SpacerIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", a2, [
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "2",
        y: "7.5",
        width: "26",
        height: "15"
      }, null, 8, i2)
    ]));
  }
}, l2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s2
}, Symbol.toStringTag, { value: "Module" })), c2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, d2 = ["fill"], u2 = {
  __name: "TableIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", c2, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M957,1979H933v-15h25v15h-1Zm-21-14h-2v6h2v-6Zm0,7h-2v6h2v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Z",
        transform: "translate(-930.5 -1956.5)"
      }, null, 8, d2)
    ]));
  }
}, p2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u2
}, Symbol.toStringTag, { value: "Module" })), h2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, f2 = ["fill"], g2 = {
  __name: "TextIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", h2, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1052.13,1313.42a2.093,2.093,0,0,0-1.41-.45,2.323,2.323,0,0,0-1.08.24,2.229,2.229,0,0,0-.78.65,2.777,2.777,0,0,0-.47.96,4.427,4.427,0,0,0-.16,1.18,4.485,4.485,0,0,0,.16,1.18,2.728,2.728,0,0,0,.47.95,2.279,2.279,0,0,0,1.86.88,2.1,2.1,0,0,0,1.48-.5,2.029,2.029,0,0,0,.62-1.39h1.19a3.024,3.024,0,0,1-.98,2.14,3.415,3.415,0,0,1-2.31.75,3.7,3.7,0,0,1-1.55-.32,3.487,3.487,0,0,1-1.17-.86,3.773,3.773,0,0,1-.74-1.28,4.388,4.388,0,0,1-.26-1.55,4.483,4.483,0,0,1,.26-1.56,3.825,3.825,0,0,1,.74-1.27,3.357,3.357,0,0,1,1.17-.86,3.554,3.554,0,0,1,1.55-.32,3.406,3.406,0,0,1,2.23.71,3.113,3.113,0,0,1,1.06,1.94h-1.22A1.957,1.957,0,0,0,1052.13,1313.42Zm-8.02,5.48a3,3,0,0,1-1.05.82,3.338,3.338,0,0,1-1.4.29,3.1,3.1,0,0,1-1.37-.29,2.933,2.933,0,0,1-1.06-.95h-0.03v1.03H1038v-10.81h1.2v4.08h0.03a3.43,3.43,0,0,1,1.03-.95,2.856,2.856,0,0,1,1.45-.35,3.079,3.079,0,0,1,1.33.28,3,3,0,0,1,1.04.8,3.889,3.889,0,0,1,.67,1.3,5.809,5.809,0,0,1,.24,1.74,5.975,5.975,0,0,1-.23,1.7A3.921,3.921,0,0,1,1044.11,1318.9Zm-0.5-4.22a2.971,2.971,0,0,0-.4-0.98,1.891,1.891,0,0,0-.67-0.65,1.812,1.812,0,0,0-.95-0.24,2.289,2.289,0,0,0-1.1.25,2.027,2.027,0,0,0-.76.66,3.1,3.1,0,0,0-.45.99,4.564,4.564,0,0,0-.15,1.19,4.71,4.71,0,0,0,.15,1.23,2.8,2.8,0,0,0,.45.97,2.306,2.306,0,0,0,.77.65,2.439,2.439,0,0,0,1.07.23,1.948,1.948,0,0,0,.96-0.23,2.013,2.013,0,0,0,.68-0.65,2.75,2.75,0,0,0,.4-0.97,5.2,5.2,0,0,0,.14-1.23A5.3,5.3,0,0,0,1043.61,1314.68Zm-8.26,5.12a1.19,1.19,0,0,1-1.29-1.13h-0.02a3.19,3.19,0,0,1-.4.43,2.659,2.659,0,0,1-.54.39,5.528,5.528,0,0,1-.69.35,2.128,2.128,0,0,1-.86.17,3.557,3.557,0,0,1-1-.13,2.2,2.2,0,0,1-.81-0.4,1.781,1.781,0,0,1-.54-0.67,2.193,2.193,0,0,1-.19-0.96,2.3,2.3,0,0,1,.24-1.12,2.01,2.01,0,0,1,.69-0.7,3.312,3.312,0,0,1,1.03-.41c0.41-.1.84-0.18,1.3-0.27,0.27-.03.51-0.08,0.73-0.12a3.2,3.2,0,0,0,.57-0.18,0.941,0.941,0,0,0,.37-0.3,0.845,0.845,0,0,0,.13-0.5,1.213,1.213,0,0,0-.43-1.01,1.919,1.919,0,0,0-1.25-.35,2.048,2.048,0,0,0-1.38.4,1.689,1.689,0,0,0-.49,1.27h-1.13a2.687,2.687,0,0,1,.2-1.02,2.108,2.108,0,0,1,.56-0.82,2.609,2.609,0,0,1,.93-0.53,3.9,3.9,0,0,1,1.3-.2,4.817,4.817,0,0,1,1.1.12,2.464,2.464,0,0,1,.88.41,1.882,1.882,0,0,1,.58.74,2.763,2.763,0,0,1,.21,1.14v3.61a1.172,1.172,0,0,0,.16.69,0.373,0.373,0,0,0,.35.16,1.112,1.112,0,0,0,.29-0.04h0.04v0.86c-0.08.03-.16,0.06-0.26,0.09A1.943,1.943,0,0,1,1035.35,1319.8Zm-1.26-4.04a3.667,3.667,0,0,1-.76.33,8.639,8.639,0,0,1-.95.22c-0.29.06-.57,0.12-0.83,0.18a2.471,2.471,0,0,0-.68.26,1.327,1.327,0,0,0-.45.43,1.292,1.292,0,0,0-.16.68,1.309,1.309,0,0,0,.13.63,1.065,1.065,0,0,0,.36.37,1.308,1.308,0,0,0,.49.18,2.76,2.76,0,0,0,.57.06,2.474,2.474,0,0,0,1.02-.2,2.373,2.373,0,0,0,.71-0.5,1.934,1.934,0,0,0,.41-0.65,1.983,1.983,0,0,0,.14-0.7v-1.29Z",
        transform: "translate(-1026.5 -1299.5)"
      }, null, 8, f2)
    ]));
  }
}, v2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: g2
}, Symbol.toStringTag, { value: "Module" })), m2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "17",
  viewBox: "0 0 47 17"
}, b2 = ["stroke"], _2 = ["stroke"], y2 = ["stroke"], C2 = {
  __name: "ThreeColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", m2, [
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, b2),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, _2),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, y2)
    ]));
  }
}, w2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C2
}, Symbol.toStringTag, { value: "Module" })), $2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "17",
  viewBox: "0 0 43 17"
}, S2 = ["stroke"], N2 = ["stroke"], A2 = {
  __name: "TwoColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (_(), M("svg", $2, [
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, S2),
      $("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "22.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, N2)
    ]));
  }
}, T2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A2
}, Symbol.toStringTag, { value: "Module" })), O2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, I2 = ["fill"], E2 = {
  __name: "VideoIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = b(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (_(), M("svg", O2, [
      $("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1049.98,1474.5a1.5,1.5,0,0,1-1.49,1.5h-12a1.5,1.5,0,0,1-1.5-1.5v-17a1.5,1.5,0,0,1,1.5-1.5h8a0.142,0.142,0,0,1,.06.02,0.2,0.2,0,0,1,.07.01,0.477,0.477,0,0,1,.22.12l5,6a0.464,0.464,0,0,1,.12.23,0.127,0.127,0,0,1,.01.06c0,0.02.01,0.04,0.01,0.06v12Zm-13.99-17v17a0.508,0.508,0,0,0,.5.5h12a0.508,0.508,0,0,0,.5-0.5V1463h-4.5a0.5,0.5,0,0,1-.5-0.5V1457h-7.5A0.508,0.508,0,0,0,1035.99,1457.5Zm9,0.21V1462h3.29Zm0.72,10.24a0.532,0.532,0,0,1,.28.45,0.522,0.522,0,0,1-.27.45l-6,3.09a0.465,0.465,0,0,1-.23.06,0.484,0.484,0,0,1-.26-0.07,0.507,0.507,0,0,1-.24-0.43v-6a0.5,0.5,0,0,1,.23-0.42,0.531,0.531,0,0,1,.49-0.03Zm-5.72,2.73,4.38-2.26-4.38-2.12v4.38Z",
        transform: "translate(-1027.5 -1451)"
      }, null, 8, I2)
    ]));
  }
}, x2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E2
}, Symbol.toStringTag, { value: "Module" }));
function Zn(e) {
  return ka() ? (Da(e), !0) : !1;
}
const qi = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const k2 = (e) => e != null, D2 = Object.prototype.toString, M2 = (e) => D2.call(e) === "[object Object]", It = () => {
}, Io = /* @__PURE__ */ P2();
function P2() {
  var e, t;
  return qi && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Eo(e) {
  return Array.isArray(e) ? e : [e];
}
function L2(...e) {
  if (e.length !== 1)
    return Ma(...e);
  const t = e[0];
  return typeof t == "function" ? kn(Us(() => ({ get: t, set: It }))) : U(t);
}
const Bt = qi ? window : void 0;
function nt(e) {
  var t;
  const n = Le(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function ht(...e) {
  let t, n, o, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, a] = e, t = Bt) : [t, n, o, a] = e, !t)
    return It;
  n = Eo(n), o = Eo(o);
  const r = [], i = () => {
    r.forEach((u) => u()), r.length = 0;
  }, s = (u, d, p, f) => (u.addEventListener(d, p, f), () => u.removeEventListener(d, p, f)), l = le(
    () => [nt(t), Le(a)],
    ([u, d]) => {
      if (i(), !u)
        return;
      const p = M2(d) ? { ...d } : d;
      r.push(
        ...n.flatMap((f) => o.map((C) => s(u, f, C, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), i();
  };
  return Zn(c), c;
}
let ga = !1;
function va(e, t, n = {}) {
  const { window: o = Bt, ignore: a = [], capture: r = !0, detectIframe: i = !1 } = n;
  if (!o)
    return It;
  Io && !ga && (ga = !0, Array.from(o.document.body.children).forEach((h) => h.addEventListener("click", It)), o.document.documentElement.addEventListener("click", It));
  let s = !0;
  const l = (h) => Le(a).some((g) => {
    if (typeof g == "string")
      return Array.from(o.document.querySelectorAll(g)).some((y) => y === h.target || h.composedPath().includes(y));
    {
      const y = nt(g);
      return y && (h.target === y || h.composedPath().includes(y));
    }
  });
  function c(h) {
    const g = Le(h);
    return g && g.$.subTree.shapeFlag === 16;
  }
  function u(h, g) {
    const y = Le(h), N = y.$.subTree && y.$.subTree.children;
    return N == null || !Array.isArray(N) ? !1 : N.some((m) => m.el === g.target || g.composedPath().includes(m.el));
  }
  const d = (h) => {
    const g = nt(e);
    if (h.target != null && !(!(g instanceof Element) && c(e) && u(e, h)) && !(!g || g === h.target || h.composedPath().includes(g))) {
      if (h.detail === 0 && (s = !l(h)), !s) {
        s = !0;
        return;
      }
      t(h);
    }
  };
  let p = !1;
  const f = [
    ht(o, "click", (h) => {
      p || (p = !0, setTimeout(() => {
        p = !1;
      }, 0), d(h));
    }, { passive: !0, capture: r }),
    ht(o, "pointerdown", (h) => {
      const g = nt(e);
      s = !l(h) && !!(g && !h.composedPath().includes(g));
    }, { passive: !0 }),
    i && ht(o, "blur", (h) => {
      setTimeout(() => {
        var g;
        const y = nt(e);
        ((g = o.document.activeElement) == null ? void 0 : g.tagName) === "IFRAME" && !(y != null && y.contains(o.document.activeElement)) && t(h);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean);
  return () => f.forEach((h) => h());
}
const GS = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = va(e, t.value, { capture: n });
    else {
      const [o, a] = t.value;
      e.__onClickOutside_stop = va(e, o, Object.assign({ capture: n }, a));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function R2(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function ma(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: a = Bt,
    eventName: r = "keydown",
    passive: i = !1,
    dedupe: s = !1
  } = o, l = R2(t);
  return ht(a, r, (u) => {
    u.repeat && Le(s) || l(u) && n(u);
  }, i);
}
const YS = {
  mounted(e, t) {
    var n, o;
    const a = (o = (n = t.arg) == null ? void 0 : n.split(",")) != null ? o : !0;
    if (typeof t.value == "function")
      ma(a, t.value, {
        target: e
      });
    else {
      const [r, i] = t.value;
      ma(a, r, {
        target: e,
        ...i
      });
    }
  }
};
function B2() {
  const e = U(!1), t = Po();
  return t && He(() => {
    e.value = !0;
  }, t), e;
}
function j2(e) {
  const t = B2();
  return b(() => (t.value, !!e()));
}
function U2(e, t, n = {}) {
  const { window: o = Bt, ...a } = n;
  let r;
  const i = j2(() => o && "MutationObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = b(() => {
    const p = Le(e), f = Eo(p).map(nt).filter(k2);
    return new Set(f);
  }), c = le(
    () => l.value,
    (p) => {
      s(), i.value && p.size && (r = new MutationObserver(t), p.forEach((f) => r.observe(f, a)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => r == null ? void 0 : r.takeRecords(), d = () => {
    c(), s();
  };
  return Zn(d), {
    isSupported: i,
    stop: d,
    takeRecords: u
  };
}
function H2(e, t, n = {}) {
  const {
    window: o = Bt,
    document: a = o == null ? void 0 : o.document,
    flush: r = "sync"
  } = n;
  if (!o || !a)
    return It;
  let i;
  const s = (u) => {
    i == null || i(), i = u;
  }, l = Hs(() => {
    const u = nt(e);
    if (u) {
      const { stop: d } = U2(
        a,
        (p) => {
          p.map((C) => [...C.removedNodes]).flat().some((C) => C === u || C.contains(u)) && t(p);
        },
        {
          window: o,
          childList: !0,
          subtree: !0
        }
      );
      s(d);
    }
  }, { flush: r }), c = () => {
    l(), s();
  };
  return Zn(c), c;
}
function ba(e, t = {}) {
  const {
    delayEnter: n = 0,
    delayLeave: o = 0,
    triggerOnRemoval: a = !1,
    window: r = Bt
  } = t, i = U(!1);
  let s;
  const l = (c) => {
    const u = c ? n : o;
    s && (clearTimeout(s), s = void 0), u ? s = setTimeout(() => i.value = c, u) : i.value = c;
  };
  return r && (ht(e, "mouseenter", () => l(!0), { passive: !0 }), ht(e, "mouseleave", () => l(!1), { passive: !0 }), a && H2(
    b(() => nt(e)),
    () => l(!1)
  )), i;
}
const xo = {
  mounted(e, t) {
    const n = t.value;
    if (typeof n == "function") {
      const o = ba(e);
      le(o, (a) => n(a));
    } else {
      const [o, a] = n, r = ba(e, a);
      le(r, (i) => o(i));
    }
  }
};
function eo(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function Qi(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : Qi(n);
  }
}
function V2(e) {
  const t = e || window.event, n = t.target;
  return Qi(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const to = /* @__PURE__ */ new WeakMap();
function F2(e, t = !1) {
  const n = U(t);
  let o = null, a = "";
  le(L2(e), (s) => {
    const l = eo(Le(s));
    if (l) {
      const c = l;
      if (to.get(c) || to.set(c, c.style.overflow), c.style.overflow !== "hidden" && (a = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const s = eo(Le(e));
    !s || n.value || (Io && (o = ht(
      s,
      "touchmove",
      (l) => {
        V2(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", n.value = !0);
  }, i = () => {
    const s = eo(Le(e));
    !s || !n.value || (Io && (o == null || o()), s.style.overflow = a, to.delete(s), n.value = !1);
  };
  return Zn(i), b({
    get() {
      return n.value;
    },
    set(s) {
      s ? r() : i();
    }
  });
}
function z2() {
  let e = !1;
  const t = U(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const a = F2(n, o.value);
    le(t, (r) => a.value = r);
  };
}
z2();
function W2(e, t, n) {
  var o = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), n = n > a ? a : n, n < 0 && (n += a), a = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var r = Array(a); ++o < a; )
    r[o] = e[o + t];
  return r;
}
var G2 = W2, Y2 = G2;
function Z2(e, t, n) {
  var o = e.length;
  return n = n === void 0 ? o : n, !t && n >= o ? e : Y2(e, t, n);
}
var X2 = Z2, K2 = "\\ud800-\\udfff", q2 = "\\u0300-\\u036f", Q2 = "\\ufe20-\\ufe2f", J2 = "\\u20d0-\\u20ff", eC = q2 + Q2 + J2, tC = "\\ufe0e\\ufe0f", nC = "\\u200d", oC = RegExp("[" + nC + K2 + eC + tC + "]");
function rC(e) {
  return oC.test(e);
}
var Ji = rC;
function aC(e) {
  return e.split("");
}
var iC = aC, es = "\\ud800-\\udfff", sC = "\\u0300-\\u036f", lC = "\\ufe20-\\ufe2f", cC = "\\u20d0-\\u20ff", dC = sC + lC + cC, uC = "\\ufe0e\\ufe0f", pC = "[" + es + "]", ko = "[" + dC + "]", Do = "\\ud83c[\\udffb-\\udfff]", hC = "(?:" + ko + "|" + Do + ")", ts = "[^" + es + "]", ns = "(?:\\ud83c[\\udde6-\\uddff]){2}", os = "[\\ud800-\\udbff][\\udc00-\\udfff]", fC = "\\u200d", rs = hC + "?", as = "[" + uC + "]?", gC = "(?:" + fC + "(?:" + [ts, ns, os].join("|") + ")" + as + rs + ")*", vC = as + rs + gC, mC = "(?:" + [ts + ko + "?", ko, ns, os, pC].join("|") + ")", bC = RegExp(Do + "(?=" + Do + ")|" + mC + vC, "g");
function _C(e) {
  return e.match(bC) || [];
}
var yC = _C, CC = iC, wC = Ji, $C = yC;
function SC(e) {
  return wC(e) ? $C(e) : CC(e);
}
var NC = SC, AC = X2, TC = Ji, OC = NC, IC = cn;
function EC(e) {
  return function(t) {
    t = IC(t);
    var n = TC(t) ? OC(t) : void 0, o = n ? n[0] : t.charAt(0), a = n ? AC(n, 1).join("") : t.slice(1);
    return o[e]() + a;
  };
}
var xC = EC, kC = xC, DC = kC("toUpperCase"), MC = DC, PC = cn, LC = MC;
function RC(e) {
  return LC(PC(e).toLowerCase());
}
var is = RC;
const BC = /* @__PURE__ */ Xe(is);
function jC(e, t, n, o) {
  var a = -1, r = e == null ? 0 : e.length;
  for (o && r && (n = e[++a]); ++a < r; )
    n = t(n, e[a], a, e);
  return n;
}
var UC = jC;
function HC(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var VC = HC, FC = VC, zC = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, WC = FC(zC), GC = WC, YC = GC, ZC = cn, XC = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, KC = "\\u0300-\\u036f", qC = "\\ufe20-\\ufe2f", QC = "\\u20d0-\\u20ff", JC = KC + qC + QC, ew = "[" + JC + "]", tw = RegExp(ew, "g");
function nw(e) {
  return e = ZC(e), e && e.replace(XC, YC).replace(tw, "");
}
var ow = nw, rw = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function aw(e) {
  return e.match(rw) || [];
}
var iw = aw, sw = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function lw(e) {
  return sw.test(e);
}
var cw = lw, ss = "\\ud800-\\udfff", dw = "\\u0300-\\u036f", uw = "\\ufe20-\\ufe2f", pw = "\\u20d0-\\u20ff", hw = dw + uw + pw, ls = "\\u2700-\\u27bf", cs = "a-z\\xdf-\\xf6\\xf8-\\xff", fw = "\\xac\\xb1\\xd7\\xf7", gw = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", vw = "\\u2000-\\u206f", mw = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ds = "A-Z\\xc0-\\xd6\\xd8-\\xde", bw = "\\ufe0e\\ufe0f", us = fw + gw + vw + mw, ps = "['’]", _a = "[" + us + "]", _w = "[" + hw + "]", hs = "\\d+", yw = "[" + ls + "]", fs = "[" + cs + "]", gs = "[^" + ss + us + hs + ls + cs + ds + "]", Cw = "\\ud83c[\\udffb-\\udfff]", ww = "(?:" + _w + "|" + Cw + ")", $w = "[^" + ss + "]", vs = "(?:\\ud83c[\\udde6-\\uddff]){2}", ms = "[\\ud800-\\udbff][\\udc00-\\udfff]", wt = "[" + ds + "]", Sw = "\\u200d", ya = "(?:" + fs + "|" + gs + ")", Nw = "(?:" + wt + "|" + gs + ")", Ca = "(?:" + ps + "(?:d|ll|m|re|s|t|ve))?", wa = "(?:" + ps + "(?:D|LL|M|RE|S|T|VE))?", bs = ww + "?", _s = "[" + bw + "]?", Aw = "(?:" + Sw + "(?:" + [$w, vs, ms].join("|") + ")" + _s + bs + ")*", Tw = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ow = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Iw = _s + bs + Aw, Ew = "(?:" + [yw, vs, ms].join("|") + ")" + Iw, xw = RegExp([
  wt + "?" + fs + "+" + Ca + "(?=" + [_a, wt, "$"].join("|") + ")",
  Nw + "+" + wa + "(?=" + [_a, wt + ya, "$"].join("|") + ")",
  wt + "?" + ya + "+" + Ca,
  wt + "+" + wa,
  Ow,
  Tw,
  hs,
  Ew
].join("|"), "g");
function kw(e) {
  return e.match(xw) || [];
}
var Dw = kw, Mw = iw, Pw = cw, Lw = cn, Rw = Dw;
function Bw(e, t, n) {
  return e = Lw(e), t = n ? void 0 : t, t === void 0 ? Pw(e) ? Rw(e) : Mw(e) : e.match(t) || [];
}
var jw = Bw, Uw = UC, Hw = ow, Vw = jw, Fw = "['’]", zw = RegExp(Fw, "g");
function Ww(e) {
  return function(t) {
    return Uw(Vw(Hw(t).replace(zw, "")), e, "");
  };
}
var Gw = Ww, Yw = is, Zw = Gw, Xw = Zw(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? Yw(t) : t);
}), Kw = Xw;
const qw = /* @__PURE__ */ Xe(Kw), Qw = { class: "node-name" }, Jw = {
  __name: "DefaultNodeIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    groupType: {
      type: String,
      default: "",
      validator: (e) => ["layout", "content"].includes(e)
    }
  },
  setup(e) {
    const t = e, n = /* @__PURE__ */ Object.assign({
      "/src/assets/icons/nodes/AccordionIcon.vue": M_,
      "/src/assets/icons/nodes/ButtonIcon.vue": B_,
      "/src/assets/icons/nodes/CardIcon.vue": V_,
      "/src/assets/icons/nodes/EmbedIcon.vue": G_,
      "/src/assets/icons/nodes/FormIcon.vue": ty,
      "/src/assets/icons/nodes/FourColumnsIcon.vue": ly,
      "/src/assets/icons/nodes/FullWidthIcon.vue": py,
      "/src/assets/icons/nodes/GalleryIcon.vue": vy,
      "/src/assets/icons/nodes/HeadingIcon.vue": yy,
      "/src/assets/icons/nodes/ImageIcon.vue": t_,
      "/src/assets/icons/nodes/LeftSidebarIcon.vue": Ny,
      "/src/assets/icons/nodes/NavigationIcon.vue": Ry,
      "/src/assets/icons/nodes/OneColumnIcon.vue": Hy,
      "/src/assets/icons/nodes/QuoteIcon.vue": Wy,
      "/src/assets/icons/nodes/RightSidebarIcon.vue": Ky,
      "/src/assets/icons/nodes/SeparatorIcon.vue": e2,
      "/src/assets/icons/nodes/SliderIcon.vue": r2,
      "/src/assets/icons/nodes/SpacerIcon.vue": l2,
      "/src/assets/icons/nodes/TableIcon.vue": p2,
      "/src/assets/icons/nodes/TextIcon.vue": v2,
      "/src/assets/icons/nodes/ThreeColumnsIcon.vue": w2,
      "/src/assets/icons/nodes/TwoColumnsIcon.vue": T2,
      "/src/assets/icons/nodes/VideoIcon.vue": x2
    }), o = b(() => {
      var l;
      const s = `/src/assets/icons/nodes/${t.node.icon}.vue`;
      return ((l = n[s]) == null ? void 0 : l.default) || null;
    }), a = b(
      () => `builder.${t.groupType}.${qw(t.node.name)}.title`
    ), r = U(!1), i = (s) => r.value = s;
    return (s, l) => Zt((_(), M("div", {
      class: be(["block", e.groupType]),
      onDblclick: l[0] || (l[0] = (c) => s.$emit("add-node"))
    }, [
      (_(), W(yn(o.value), {
        class: "icon",
        "is-hovering": r.value
      }, null, 8, ["is-hovering"])),
      $("p", Qw, K(s.$t(a.value)), 1)
    ], 34)), [
      [H(xo), i]
    ]);
  }
}, e$ = /* @__PURE__ */ X(Jw, [["__scopeId", "data-v-00b6ed94"]]);
function dn(e) {
  return ka() ? (Da(e), !0) : !1;
}
function ys(e) {
  let t = 0, n, o;
  const a = () => {
    t -= 1, o && t <= 0 && (o.stop(), n = void 0, o = void 0);
  };
  return (...r) => (t += 1, o || (o = Vs(!0), n = o.run(() => e(...r))), dn(a), n);
}
function Ie(e) {
  return typeof e == "function" ? e() : H(e);
}
const ir = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const t$ = (e) => e != null, n$ = Object.prototype.toString, o$ = (e) => n$.call(e) === "[object Object]", r$ = () => +Date.now(), En = () => {
};
function a$(e, t) {
  function n(...o) {
    return new Promise((a, r) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(a).catch(r);
    });
  }
  return n;
}
const Cs = (e) => e();
function i$(e, t = {}) {
  let n, o, a = En;
  const r = (s) => {
    clearTimeout(s), a(), a = En;
  };
  return (s) => {
    const l = Ie(e), c = Ie(t.maxWait);
    return n && r(n), l <= 0 || c !== void 0 && c <= 0 ? (o && (r(o), o = null), Promise.resolve(s())) : new Promise((u, d) => {
      a = t.rejectOnCancel ? d : u, c && !o && (o = setTimeout(() => {
        n && r(n), o = null, u(s());
      }, c)), n = setTimeout(() => {
        o && r(o), o = null, u(s());
      }, l);
    });
  };
}
function s$(e = Cs) {
  const t = U(!0);
  function n() {
    t.value = !1;
  }
  function o() {
    t.value = !0;
  }
  const a = (...r) => {
    t.value && e(...r);
  };
  return { isActive: kn(t), pause: n, resume: o, eventFilter: a };
}
function l$(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const o = t;
    t = void 0, o && await o;
  }, n;
}
function c$(e) {
  return Po();
}
function d$(e, t = !0, n) {
  c$() ? He(e, n) : t ? e() : Pe(e);
}
function u$(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, a = U(!1);
  let r = null;
  function i() {
    r && (clearTimeout(r), r = null);
  }
  function s() {
    a.value = !1, i();
  }
  function l(...c) {
    i(), a.value = !0, r = setTimeout(() => {
      a.value = !1, r = null, e(...c);
    }, Ie(t));
  }
  return o && (a.value = !0, ir && l()), dn(s), {
    isPending: kn(a),
    start: l,
    stop: s
  };
}
function p$(e, t, n = {}) {
  const {
    eventFilter: o = Cs,
    ...a
  } = n, r = a$(
    o,
    t
  );
  let i, s, l;
  if (a.flush === "sync") {
    const c = U(!1);
    s = () => {
    }, i = (u) => {
      c.value = !0, u(), c.value = !1;
    }, l = le(
      e,
      (...u) => {
        c.value || r(...u);
      },
      a
    );
  } else {
    const c = [], u = U(0), d = U(0);
    s = () => {
      u.value = d.value;
    }, c.push(
      le(
        e,
        () => {
          d.value++;
        },
        { ...a, flush: "sync" }
      )
    ), i = (p) => {
      const f = d.value;
      p(), u.value += d.value - f;
    }, c.push(
      le(
        e,
        (...p) => {
          const f = u.value > 0 && u.value === d.value;
          u.value = 0, d.value = 0, !f && r(...p);
        },
        a
      )
    ), l = () => {
      c.forEach((p) => p());
    };
  }
  return { stop: l, ignoreUpdates: i, ignorePrevAsyncUpdates: s };
}
function ze(e, t, n) {
  return le(
    e,
    (a, r, i) => {
      a && t(a, r, i);
    },
    {
      ...n,
      once: !1
    }
  );
}
const jt = ir ? window : void 0, ws = ir ? window.navigator : void 0;
function xt(e) {
  var t;
  const n = Ie(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function we(...e) {
  let t, n, o, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, a] = e, t = jt) : [t, n, o, a] = e, !t)
    return En;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const r = [], i = () => {
    r.forEach((u) => u()), r.length = 0;
  }, s = (u, d, p, f) => (u.addEventListener(d, p, f), () => u.removeEventListener(d, p, f)), l = le(
    () => [xt(t), Ie(a)],
    ([u, d]) => {
      if (i(), !u)
        return;
      const p = o$(d) ? { ...d } : d;
      r.push(
        ...n.flatMap((f) => o.map((C) => s(u, f, C, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), i();
  };
  return dn(c), c;
}
function h$() {
  const e = U(!1), t = Po();
  return t && He(() => {
    e.value = !0;
  }, t), e;
}
function Xn(e) {
  const t = h$();
  return b(() => (t.value, !!e()));
}
function $s(e, t, n = {}) {
  const { window: o = jt, ...a } = n;
  let r;
  const i = Xn(() => o && "MutationObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = b(() => {
    const p = Ie(e), f = (Array.isArray(p) ? p : [p]).map(xt).filter(t$);
    return new Set(f);
  }), c = le(
    () => l.value,
    (p) => {
      s(), i.value && p.size && (r = new MutationObserver(t), p.forEach((f) => r.observe(f, a)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => r == null ? void 0 : r.takeRecords(), d = () => {
    c(), s();
  };
  return dn(d), {
    isSupported: i,
    stop: d,
    takeRecords: u
  };
}
function $a(e = {}) {
  var t;
  const {
    window: n = jt,
    deep: o = !0,
    triggerOnRemoval: a = !1
  } = e, r = (t = e.document) != null ? t : n == null ? void 0 : n.document, i = () => {
    var c;
    let u = r == null ? void 0 : r.activeElement;
    if (o)
      for (; u != null && u.shadowRoot; )
        u = (c = u == null ? void 0 : u.shadowRoot) == null ? void 0 : c.activeElement;
    return u;
  }, s = U(), l = () => {
    s.value = i();
  };
  return n && (we(n, "blur", (c) => {
    c.relatedTarget === null && l();
  }, !0), we(n, "focus", l, !0)), a && $s(r, (c) => {
    c.filter((u) => u.removedNodes.length).map((u) => Array.from(u.removedNodes)).flat().forEach((u) => {
      u === s.value && l();
    });
  }, {
    childList: !0,
    subtree: !0
  }), l(), s;
}
function Sa(e, t = {}) {
  const {
    controls: n = !1,
    navigator: o = ws
  } = t, a = Xn(() => o && "permissions" in o), r = pr(), i = typeof e == "string" ? { name: e } : e, s = pr(), l = () => {
    var u, d;
    s.value = (d = (u = r.value) == null ? void 0 : u.state) != null ? d : "prompt";
  };
  we(r, "change", l);
  const c = l$(async () => {
    if (a.value) {
      if (!r.value)
        try {
          r.value = await o.permissions.query(i);
        } catch {
          r.value = void 0;
        } finally {
          l();
        }
      if (n)
        return Fs(r.value);
    }
  });
  return c(), n ? {
    state: s,
    isSupported: a,
    query: c
  } : s;
}
function f$(e = {}) {
  const {
    navigator: t = ws,
    read: n = !1,
    source: o,
    copiedDuring: a = 1500,
    legacy: r = !1
  } = e, i = Xn(() => t && "clipboard" in t), s = Sa("clipboard-read"), l = Sa("clipboard-write"), c = b(() => i.value || r), u = U(""), d = U(!1), p = u$(() => d.value = !1, a);
  function f() {
    i.value && y(s.value) ? t.clipboard.readText().then((N) => {
      u.value = N;
    }) : u.value = g();
  }
  c.value && n && we(["copy", "cut"], f);
  async function C(N = Ie(o)) {
    c.value && N != null && (i.value && y(l.value) ? await t.clipboard.writeText(N) : h(N), u.value = N, d.value = !0, p.start());
  }
  function h(N) {
    const m = document.createElement("textarea");
    m.value = N ?? "", m.style.position = "absolute", m.style.opacity = "0", document.body.appendChild(m), m.select(), document.execCommand("copy"), m.remove();
  }
  function g() {
    var N, m, O;
    return (O = (m = (N = document == null ? void 0 : document.getSelection) == null ? void 0 : N.call(document)) == null ? void 0 : m.toString()) != null ? O : "";
  }
  function y(N) {
    return N === "granted" || N === "prompt";
  }
  return {
    isSupported: c,
    text: u,
    copied: d,
    copy: C
  };
}
function Ss(e) {
  return JSON.parse(JSON.stringify(e));
}
function Ns(e) {
  return e;
}
function g$(e, t) {
  return e.value = t;
}
function v$(e) {
  return e ? typeof e == "function" ? e : Ss : Ns;
}
function m$(e) {
  return e ? typeof e == "function" ? e : Ss : Ns;
}
function b$(e, t = {}) {
  const {
    clone: n = !1,
    dump: o = v$(n),
    parse: a = m$(n),
    setSource: r = g$
  } = t;
  function i() {
    return zs({
      snapshot: o(e.value),
      timestamp: r$()
    });
  }
  const s = U(i()), l = U([]), c = U([]), u = (m) => {
    r(e, a(m.snapshot)), s.value = m;
  }, d = () => {
    l.value.unshift(s.value), s.value = i(), t.capacity && l.value.length > t.capacity && l.value.splice(t.capacity, Number.POSITIVE_INFINITY), c.value.length && c.value.splice(0, c.value.length);
  }, p = () => {
    l.value.splice(0, l.value.length), c.value.splice(0, c.value.length);
  }, f = () => {
    const m = l.value.shift();
    m && (c.value.unshift(s.value), u(m));
  }, C = () => {
    const m = c.value.shift();
    m && (l.value.unshift(s.value), u(m));
  }, h = () => {
    u(s.value);
  }, g = b(() => [s.value, ...l.value]), y = b(() => l.value.length > 0), N = b(() => c.value.length > 0);
  return {
    source: e,
    undoStack: l,
    redoStack: c,
    last: s,
    history: g,
    canUndo: y,
    canRedo: N,
    clear: p,
    commit: d,
    reset: h,
    undo: f,
    redo: C
  };
}
function _$(e, t = {}) {
  const {
    deep: n = !1,
    flush: o = "pre",
    eventFilter: a
  } = t, {
    eventFilter: r,
    pause: i,
    resume: s,
    isActive: l
  } = s$(a), {
    ignoreUpdates: c,
    ignorePrevAsyncUpdates: u,
    stop: d
  } = p$(
    e,
    g,
    { deep: n, flush: o, eventFilter: r }
  );
  function p(O, I) {
    u(), c(() => {
      O.value = I;
    });
  }
  const f = b$(e, { ...t, clone: t.clone || n, setSource: p }), { clear: C, commit: h } = f;
  function g() {
    u(), h();
  }
  function y(O) {
    s(), O && g();
  }
  function N(O) {
    let I = !1;
    const v = () => I = !0;
    c(() => {
      O(v);
    }), I || g();
  }
  function m() {
    d(), C();
  }
  return {
    ...f,
    isTracking: l,
    pause: i,
    resume: y,
    commit: g,
    batch: N,
    dispose: m
  };
}
function As(e, t = {}) {
  const n = t.debounce ? i$(t.debounce) : void 0;
  return {
    ..._$(e, { ...t, eventFilter: n })
  };
}
function sr(e, t, n = {}) {
  const { window: o = jt, ...a } = n;
  let r;
  const i = Xn(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = b(() => {
    const d = Ie(e);
    return Array.isArray(d) ? d.map((p) => xt(p)) : [xt(d)];
  }), c = le(
    l,
    (d) => {
      if (s(), i.value && o) {
        r = new ResizeObserver(t);
        for (const p of d)
          p && r.observe(p, a);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), c();
  };
  return dn(u), {
    isSupported: i,
    stop: u
  };
}
function Ts(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: a = !0,
    immediate: r = !0,
    updateTiming: i = "sync"
  } = t, s = U(0), l = U(0), c = U(0), u = U(0), d = U(0), p = U(0), f = U(0), C = U(0);
  function h() {
    const y = xt(e);
    if (!y) {
      n && (s.value = 0, l.value = 0, c.value = 0, u.value = 0, d.value = 0, p.value = 0, f.value = 0, C.value = 0);
      return;
    }
    const N = y.getBoundingClientRect();
    s.value = N.height, l.value = N.bottom, c.value = N.left, u.value = N.right, d.value = N.top, p.value = N.width, f.value = N.x, C.value = N.y;
  }
  function g() {
    i === "sync" ? h() : i === "next-frame" && requestAnimationFrame(() => h());
  }
  return sr(e, g), le(() => xt(e), (y) => !y && g()), $s(e, g, {
    attributeFilter: ["style", "class"]
  }), a && we("scroll", g, { capture: !0, passive: !0 }), o && we("resize", g, { passive: !0 }), d$(() => {
    r && g();
  }), {
    height: s,
    bottom: l,
    left: c,
    right: u,
    top: d,
    width: p,
    x: f,
    y: C,
    update: g
  };
}
const y$ = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function C$(e = {}) {
  const {
    reactive: t = !1,
    target: n = jt,
    aliasMap: o = y$,
    passive: a = !0,
    onEventFired: r = En
  } = e, i = _n(/* @__PURE__ */ new Set()), s = {
    toJSON() {
      return {};
    },
    current: i
  }, l = t ? _n(s) : s, c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
  function d(h, g) {
    h in l && (t ? l[h] = g : l[h].value = g);
  }
  function p() {
    i.clear();
    for (const h of u)
      d(h, !1);
  }
  function f(h, g) {
    var y, N;
    const m = (y = h.key) == null ? void 0 : y.toLowerCase(), I = [(N = h.code) == null ? void 0 : N.toLowerCase(), m].filter(Boolean);
    m && (g ? i.add(m) : i.delete(m));
    for (const v of I)
      u.add(v), d(v, g);
    m === "meta" && !g ? (c.forEach((v) => {
      i.delete(v), d(v, !1);
    }), c.clear()) : typeof h.getModifierState == "function" && h.getModifierState("Meta") && g && [...i, ...I].forEach((v) => c.add(v));
  }
  we(n, "keydown", (h) => (f(h, !0), r(h)), { passive: a }), we(n, "keyup", (h) => (f(h, !1), r(h)), { passive: a }), we("blur", p, { passive: !0 }), we("focus", p, { passive: !0 });
  const C = new Proxy(
    l,
    {
      get(h, g, y) {
        if (typeof g != "string")
          return Reflect.get(h, g, y);
        if (g = g.toLowerCase(), g in o && (g = o[g]), !(g in l))
          if (/[+_-]/.test(g)) {
            const m = g.split(/[+_-]/g).map((O) => O.trim());
            l[g] = b(() => m.every((O) => Ie(C[O])));
          } else
            l[g] = U(!1);
        const N = Reflect.get(h, g, y);
        return t ? Ie(N) : N;
      }
    }
  );
  return C;
}
function w$(e) {
  var t;
  const n = (t = e.rangeCount) != null ? t : 0;
  return Array.from({ length: n }, (o, a) => e.getRangeAt(a));
}
function $$(e = {}) {
  const {
    window: t = jt
  } = e, n = U(null), o = b(() => {
    var s, l;
    return (l = (s = n.value) == null ? void 0 : s.toString()) != null ? l : "";
  }), a = b(() => n.value ? w$(n.value) : []), r = b(() => a.value.map((s) => s.getBoundingClientRect()));
  function i() {
    n.value = null, t && (n.value = t.getSelection());
  }
  return t && we(t.document, "selectionchange", i), {
    text: o,
    rects: r,
    ranges: a,
    selection: n
  };
}
function ZS(e) {
  var t;
  const n = U(e == null ? void 0 : e.element), o = U(e == null ? void 0 : e.input), a = (t = e == null ? void 0 : e.styleProp) != null ? t : "height", r = U(1), i = U(0);
  function s() {
    var l;
    if (!n.value)
      return;
    let c = "";
    n.value.style[a] = "1px", r.value = (l = n.value) == null ? void 0 : l.scrollHeight;
    const u = Ie(e == null ? void 0 : e.styleTarget);
    u ? u.style[a] = `${r.value}px` : c = `${r.value}px`, n.value.style[a] = c;
  }
  return le([o, n], () => Pe(s), { immediate: !0 }), le(r, () => {
    var l;
    return (l = e == null ? void 0 : e.onResize) == null ? void 0 : l.call(e);
  }), sr(n, ([{ contentRect: l }]) => {
    i.value !== l.width && (i.value = l.width, s());
  }), e != null && e.watch && le(e.watch, s, { immediate: !0, deep: !0 }), {
    textarea: n,
    input: o,
    triggerResize: s
  };
}
const S$ = {}, N$ = { class: "pb-overlay" };
function A$(e, t) {
  return _(), M("div", N$);
}
const T$ = /* @__PURE__ */ X(S$, [["render", A$], ["__scopeId", "data-v-f6f53f85"]]), O$ = {
  __name: "ContentNode",
  props: {
    modelValue: { type: Object, default: () => ({}) },
    level: { type: Number, default: 0 },
    inAccordion: Boolean,
    isEditable: Boolean,
    isActiveNode: Boolean
  },
  setup(e) {
    const t = e, n = pe("state"), o = Ma(t, "modelValue"), a = {
      EditableAccordionNode: G(
        () => import("./EditableAccordionNode-DzDYKze7.js")
      ),
      EditableAccordionPanelNode: G(
        () => import("./EditableAccordionPanelNode-DX_Jo6y-.js")
      ),
      EditableButtonNode: G(
        () => import("./EditableButtonNode-ie__eFvH.js")
      ),
      EditableCardNode: G(
        () => import("./EditableCardNode-B-XqLkbB.js")
      ),
      EditableCodeNode: G(
        () => import("./EditableCodeNode-Bu3gIc2S.js")
      ),
      EditableFormNode: G(
        () => import("./EditableFormNode-BqDSzvPd.js")
      ),
      EditableGalleryNode: G(
        () => import("./EditableGalleryNode-CT0v9B78.js")
      ),
      EditableHeadingNode: G(
        () => import("./EditableHeadingNode-BaSXkE_k.js")
      ),
      EditableImageNode: G(
        () => import("./EditableImageNode-C9xWlUSn.js")
      ),
      EditableListNode: G(
        () => import("./EditableListNode-gef4TKLV.js")
      ),
      EditableQuoteNode: G(
        () => import("./EditableQuoteNode-CsCCKe9Q.js")
      ),
      EditableSeparatorNode: G(
        () => import("./EditableSeparatorNode-CeVXa1E0.js")
      ),
      EditableSpacerNode: G(
        () => import("./EditableSpacerNode-DNMVPFPN.js")
      ),
      EditableTableNode: G(
        () => import("./EditableTableNode-DwhNGOe9.js")
      ),
      EditableTextNode: G(
        () => import("./EditableTextNode-CRNmgcEg.js")
      ),
      EditableVideoNode: G(
        () => import("./EditableVideoNode-RtUMMBWt.js")
      ),
      EditableSliderNode: G(
        () => import("./EditableSliderNode-Blv56yQv.js")
      ),
      EditableNavigationNode: G(
        () => import("./EditableNavigationNode-EBkPEdIm.js")
      ),
      EditableSharedContentErrorNode: G(
        () => import("./EditableSharedContentErrorNode-Kl1-GwVj.js")
      ),
      AccordionNode: G(
        () => import("./AccordionNode-B95TlHzW.js")
      ),
      AccordionPanelNode: G(
        () => import("./AccordionPanelNode-DdyTl8fG.js")
      ),
      ButtonNode: G(() => import("./ButtonNode-BoQMpgJU.js").then((h) => h.b)),
      CardNode: G(() => import("./CardNode-CYaA76DO.js")),
      CodeNode: G(() => import("./CodeNode-CBjfRga-.js")),
      FormNode: G(() => import("./FormNode-BKHJJo-K.js").then((h) => h.a)),
      GalleryNode: G(() => import("./GalleryNode-BTswiu9W.js").then((h) => h.b)),
      HeadingNode: G(() => import("./HeadingNode-Dag_M8Cd.js")),
      ImageNode: G(() => import("./ImageNode-D_N43OVO.js").then((h) => h.a)),
      ListNode: G(() => import("./ListNode-BzmMEUQS.js")),
      NavigationNode: G(
        () => import("./NavigationNode-DRdx9vD2.js")
      ),
      QuoteNode: G(() => import("./QuoteNode-BiQps9AT.js")),
      SeparatorNode: G(
        () => import("./SeparatorNode-B3fYxCOe.js")
      ),
      SliderNode: G(() => import("./SliderNode-BE8Sv8cL.js")),
      SpacerNode: G(() => import("./SpacerNode-niUkFKLX.js")),
      TableNode: G(() => import("./TableNode-CcNEfQGy.js")),
      TextNode: G(() => import("./TextNode-eCO36JTf.js")),
      VideoNode: G(() => import("./VideoNode-UFEJnv4u.js").then((h) => h.a)),
      SharedContentErrorNode: G(
        () => import("./SharedContentErrorNode-DoiPMBrA.js")
      )
    }, r = pe("insideSharedContentLayout"), i = b(
      () => t.isEditable && r.value
    ), s = b(
      () => t.isEditable && !r.value
    ), l = b(() => {
      const g = [...Mn, ...Va].find(
        (N) => N.type === o.value.type
      );
      return (s.value ? `Editable${g.component}` : g.component) || "div";
    }), c = b(() => [
      `content-level-${t.level}`,
      { "in-accordion": t.inAccordion },
      { "is-active": t.isActiveNode && s.value },
      { "is-editable": s.value }
    ]), u = b(
      () => {
        var h, g, y, N, m;
        return ((g = (h = n == null ? void 0 : n.value) == null ? void 0 : h.nodeDragging) == null ? void 0 : g.type) === Ze && ((N = (y = n == null ? void 0 : n.value) == null ? void 0 : y.nodeDragging) == null ? void 0 : N.id) !== ((m = o.value) == null ? void 0 : m.id);
      }
    ), d = b(
      () => {
        var h, g, y;
        return ((y = (g = (h = n == null ? void 0 : n.value) == null ? void 0 : h.builder) == null ? void 0 : g.customProperties) == null ? void 0 : y[o.value.type]) || {};
      }
    );
    function p() {
      var h;
      (h = n == null ? void 0 : n.value) == null || h.setActiveNode(o.value);
    }
    function f(h, g) {
      var y;
      g && ((y = n == null ? void 0 : n.value) == null || y.setActiveNode(o.value)), n.value.editor = h;
    }
    const C = b(() => {
      var h, g, y, N, m, O, I, v;
      return {
        "--root-elements-width": ((N = (y = (g = (h = n == null ? void 0 : n.value) == null ? void 0 : h.builder) == null ? void 0 : g.customProperties) == null ? void 0 : y.global) == null ? void 0 : N.rootElementsWidth) || "100%",
        "--root-elements-max-width": ((v = (I = (O = (m = n == null ? void 0 : n.value) == null ? void 0 : m.builder) == null ? void 0 : O.customProperties) == null ? void 0 : I.global) == null ? void 0 : v.rootElementsMaxWidth) || "100%"
      };
    });
    return (h, g) => (_(), W(Ws, null, {
      default: P(() => [
        (_(), W(yn(a[l.value]), {
          modelValue: o.value,
          "onUpdate:modelValue": [
            g[0] || (g[0] = (y) => o.value = y),
            g[1] || (g[1] = (y) => o.value = y)
          ],
          class: be(["content-node", c.value]),
          "is-editable": s.value,
          assets: H(n).builder.assets,
          "is-active-node": e.isActiveNode && s.value,
          "is-accordion-dragging": u.value,
          level: e.level,
          "in-accordion": e.inAccordion,
          "custom-properties": d.value,
          style: je(C.value),
          "is-editable-shared-content-layout": i.value,
          onSetActive: p,
          onFocusEditor: f,
          onAssetEntry: g[2] || (g[2] = (y) => H(n).addAsset(y)),
          onCloseSidebar: g[3] || (g[3] = (y) => H(n).clearActiveNode())
        }, null, 40, ["modelValue", "class", "is-editable", "assets", "is-active-node", "is-accordion-dragging", "level", "in-accordion", "custom-properties", "style", "is-editable-shared-content-layout"]))
      ]),
      _: 1
    }));
  }
}, I$ = /* @__PURE__ */ X(O$, [["__scopeId", "data-v-f7d24f00"]]), E$ = (e) => {
  var t, n, o, a;
  return (n = (t = e == null ? void 0 : e.properties) == null ? void 0 : t.backgroundColor) != null && n.toggle ? (a = (o = e == null ? void 0 : e.properties) == null ? void 0 : o.backgroundColor) == null ? void 0 : a.value : null;
}, x$ = (e, t) => {
  var a, r;
  const n = Math.min(t.width, t.height) / 2;
  return `${((r = (a = e == null ? void 0 : e.properties) == null ? void 0 : a.borderRadius) == null ? void 0 : r.value) / 100 * n}px`;
}, k$ = (e, t) => {
  var o, a, r, i, s, l, c, u, d, p, f;
  return !((a = (o = e == null ? void 0 : e.properties) == null ? void 0 : o.backgroundImage) != null && a.toggle) || !((l = (s = (i = (r = e == null ? void 0 : e.properties) == null ? void 0 : r.backgroundImage) == null ? void 0 : i.image) == null ? void 0 : s.content) != null && l.assetId) ? null : `url(${((f = t[(p = (d = (u = (c = e == null ? void 0 : e.properties) == null ? void 0 : c.backgroundImage) == null ? void 0 : u.image) == null ? void 0 : d.content) == null ? void 0 : p.assetId]) == null ? void 0 : f.url) || ""})`;
}, D$ = (e) => {
  var n, o, a, r, i;
  const t = ((a = (o = (n = e == null ? void 0 : e.properties) == null ? void 0 : n.backgroundImage) == null ? void 0 : o.image) == null ? void 0 : a.properties) || {};
  switch (t == null ? void 0 : t.backgroundPosition) {
    case "center":
      return {
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "contain",
        transform: `rotate(${(t == null ? void 0 : t.rotation) || 0}deg)`
      };
    case "fill":
      return {
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-position": `${((r = t == null ? void 0 : t.focalPointPosition) == null ? void 0 : r.x) || 50}% ${((i = t == null ? void 0 : t.focalPointPosition) == null ? void 0 : i.y) || 50}%`,
        transform: `rotate(${(t == null ? void 0 : t.rotation) || 0}deg)`
      };
    case "tile":
      return {
        "background-position": "center",
        "background-repeat": "repeat",
        "background-size": `${(t == null ? void 0 : t.tilePercentage) || 100}%`,
        transform: `rotate(${(t == null ? void 0 : t.rotation) || 0}deg)`
      };
    default:
      return {};
  }
}, Na = (e, t, n) => ["top", "bottom", "left", "right"].reduce((o, a) => {
  var r, i, s;
  return {
    ...o,
    [`${t}${BC(a)}`]: ((r = e == null ? void 0 : e.properties[t]) != null && r.linked ? (i = e == null ? void 0 : e.properties[t]) == null ? void 0 : i.value : ((s = e == null ? void 0 : e.properties[t]) == null ? void 0 : s[a]) || 0) / n + "px"
  };
}, {}), M$ = (e, t, n, o) => {
  var g, y, N, m, O;
  const { customProperties: a, assets: r } = e, i = t.id === "root";
  if (Ni(t) && !i)
    return {};
  const s = 1, l = i ? !!((g = a == null ? void 0 : a.global) != null && g.backgroundColorAllowed) : !!((y = a == null ? void 0 : a[t.type]) != null && y.backgroundColorAllowed), c = i ? !!((N = a == null ? void 0 : a.global) != null && N.backgroundImageAllowed) : !!((m = a == null ? void 0 : a[t.type]) != null && m.backgroundImageAllowed), u = l && E$(t), d = c && k$(t, r), p = !!((O = a == null ? void 0 : a.experimentalFeatures) != null && O.roundedLayouts) && x$(t, o), f = D$(t), C = Na(t, "margin", s), h = Na(t, "padding", s);
  return {
    backgroundImage: d,
    backgroundColor: u,
    borderRadius: p,
    ...f,
    ...C,
    ...h
  };
}, P$ = { class: "node-action-icon" }, L$ = {
  __name: "ActiveNodeAction",
  props: {
    tooltipText: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top"
    },
    icon: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = () => {
      o("click");
    };
    return (r, i) => {
      const s = L("a-icon"), l = L("a-button"), c = L("a-tooltip");
      return _(), W(c, {
        label: n.tooltipText,
        position: n.position
      }, {
        default: P(() => [
          E(l, {
            class: "node-action",
            variant: "none",
            onClick: a
          }, {
            default: P(() => [
              Ne(r.$slots, "default", {}, () => [
                $("p", P$, [
                  E(s, {
                    icon: n.icon
                  }, null, 8, ["icon"])
                ])
              ], !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["label", "position"]);
    };
  }
}, gn = /* @__PURE__ */ X(L$, [["__scopeId", "data-v-2aeb3fd3"]]), R$ = {}, B$ = {
  width: "12",
  height: "24",
  viewBox: "0 0 12 24",
  fill: "none"
};
function j$(e, t) {
  return _(), M("svg", B$, t[0] || (t[0] = [
    xa('<circle cx="4" cy="6" r="1" fill="white"></circle><circle cx="4" cy="10" r="1" fill="white"></circle><circle cx="4" cy="14" r="1" fill="white"></circle><circle cx="8" cy="6" r="1" fill="white"></circle><circle cx="8" cy="10" r="1" fill="white"></circle><circle cx="8" cy="14" r="1" fill="white"></circle><circle cx="4" cy="18" r="1" fill="white"></circle><circle cx="8" cy="18" r="1" fill="white"></circle>', 8)
  ]));
}
const Os = /* @__PURE__ */ X(R$, [["render", j$]]), XS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Os
}, Symbol.toStringTag, { value: "Module" }));
var U$ = pi, H$ = Wn, V$ = Wo, F$ = it, z$ = an, W$ = Fn, G$ = Vn, Y$ = Zo, Z$ = "[object Map]", X$ = "[object Set]", K$ = Object.prototype, q$ = K$.hasOwnProperty;
function Q$(e) {
  if (e == null)
    return !0;
  if (z$(e) && (F$(e) || typeof e == "string" || typeof e.splice == "function" || W$(e) || Y$(e) || V$(e)))
    return !e.length;
  var t = H$(e);
  if (t == Z$ || t == X$)
    return !e.size;
  if (G$(e))
    return !U$(e).length;
  for (var n in e)
    if (q$.call(e, n))
      return !1;
  return !0;
}
var J$ = Q$;
const e3 = /* @__PURE__ */ Xe(J$);
var t3 = "__lodash_hash_undefined__";
function n3(e) {
  return this.__data__.set(e, t3), this;
}
var o3 = n3;
function r3(e) {
  return this.__data__.has(e);
}
var a3 = r3, i3 = Ho, s3 = o3, l3 = a3;
function xn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new i3(); ++t < n; )
    this.add(e[t]);
}
xn.prototype.add = xn.prototype.push = s3;
xn.prototype.has = l3;
var c3 = xn;
function d3(e, t, n, o) {
  for (var a = e.length, r = n + (o ? 1 : -1); o ? r-- : ++r < a; )
    if (t(e[r], r, e))
      return r;
  return -1;
}
var u3 = d3;
function p3(e) {
  return e !== e;
}
var h3 = p3;
function f3(e, t, n) {
  for (var o = n - 1, a = e.length; ++o < a; )
    if (e[o] === t)
      return o;
  return -1;
}
var g3 = f3, v3 = u3, m3 = h3, b3 = g3;
function _3(e, t, n) {
  return t === t ? b3(e, t, n) : v3(e, m3, n);
}
var y3 = _3, C3 = y3;
function w3(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && C3(e, t, 0) > -1;
}
var $3 = w3;
function S3(e, t, n) {
  for (var o = -1, a = e == null ? 0 : e.length; ++o < a; )
    if (n(t, e[o]))
      return !0;
  return !1;
}
var N3 = S3;
function A3(e, t) {
  return e.has(t);
}
var T3 = A3;
function O3() {
}
var I3 = O3;
function E3(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var Is = E3, no = mi, x3 = I3, k3 = Is, D3 = 1 / 0, M3 = no && 1 / k3(new no([, -0]))[1] == D3 ? function(e) {
  return new no(e);
} : x3, P3 = M3, L3 = c3, R3 = $3, B3 = N3, j3 = T3, U3 = P3, H3 = Is, V3 = 200;
function F3(e, t, n) {
  var o = -1, a = R3, r = e.length, i = !0, s = [], l = s;
  if (n)
    i = !1, a = B3;
  else if (r >= V3) {
    var c = t ? null : U3(e);
    if (c)
      return H3(c);
    i = !1, a = j3, l = new L3();
  } else
    l = t ? [] : s;
  e:
    for (; ++o < r; ) {
      var u = e[o], d = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, i && d === d) {
        for (var p = l.length; p--; )
          if (l[p] === d)
            continue e;
        t && l.push(d), s.push(u);
      } else
        a(l, d, n) || (l !== s && l.push(d), s.push(u));
    }
  return s;
}
var z3 = F3, W3 = z3;
function G3(e) {
  return e && e.length ? W3(e) : [];
}
var Y3 = G3;
const Z3 = /* @__PURE__ */ Xe(Y3);
function De({ state: e = {} }) {
  var ee;
  const t = ((ee = e == null ? void 0 : e.value) == null ? void 0 : ee.builder) || {}, n = t.sharedContent || {}, o = n.onContentCreated, a = n.onOpenSettings, r = n.onSaveContentEdited, i = n.onCancelContentEdited, s = n.onContentDetached, l = n.onSharedContentDeleted, c = b(
    () => {
      var w, k, V, Z;
      return !!((Z = (V = (k = (w = e == null ? void 0 : e.value) == null ? void 0 : w.builder) == null ? void 0 : k.customProperties) == null ? void 0 : V.global) != null && Z.sharedContentAllowed);
    }
  ), u = b(
    () => {
      var w, k, V;
      return !!c.value && !!((V = (k = (w = e == null ? void 0 : e.value) == null ? void 0 : w.builder) == null ? void 0 : k.sharedContent) != null && V.createSharedContentAllowed);
    }
  ), d = b(
    () => {
      var w, k, V;
      return !!c.value && !!((V = (k = (w = e == null ? void 0 : e.value) == null ? void 0 : w.builder) == null ? void 0 : k.sharedContent) != null && V.editSharedContentAllowed);
    }
  ), p = b(
    () => {
      var w, k, V;
      return !!c.value && !!((V = (k = (w = e == null ? void 0 : e.value) == null ? void 0 : w.builder) == null ? void 0 : k.sharedContent) != null && V.detachSharedContentAllowed);
    }
  ), f = b(
    () => {
      var w, k, V;
      return !e3(((V = (k = (w = e == null ? void 0 : e.value) == null ? void 0 : w.builder) == null ? void 0 : k.sharedContent) == null ? void 0 : V.content) || {});
    }
  ), C = b(
    () => Object.keys(n.content || {}).length
  ), h = (w) => (w == null ? void 0 : w.type) === Se, g = b(
    () => {
      var w, k;
      return u.value && !h((w = e == null ? void 0 : e.value) == null ? void 0 : w.activeNode) && !j((k = e == null ? void 0 : e.value) == null ? void 0 : k.activeNode);
    }
  ), y = b(
    () => {
      var w;
      return d.value && h((w = e == null ? void 0 : e.value) == null ? void 0 : w.activeNode);
    }
  ), N = b(
    () => {
      var w;
      return p.value && h((w = e == null ? void 0 : e.value) == null ? void 0 : w.activeNode);
    }
  ), m = async ({
    node: w = null,
    name: k = "New shared content",
    icon: V = "16:paper-plane",
    accordionId: Z = null,
    preventNodeTypes: te = []
  } = {}) => {
    var me, bt, cr, dr;
    if (!w && !((me = e == null ? void 0 : e.value) != null && me.activeNode))
      return;
    Z && (w = Ge(t.structure, Z)), ((cr = (bt = e == null ? void 0 : e.value) == null ? void 0 : bt.activeNode) == null ? void 0 : cr.type) === Re && (w = Ge(t.structure, e.value.activeNode.parentAccordionId));
    let de = ne();
    const Ee = w || ((dr = e == null ? void 0 : e.value) == null ? void 0 : dr.activeNode);
    let Fe = nn(Ee);
    if (Fe = qe(Fe), !(te.length > 0 && te.some(
      (Bs) => !!Oi(Ee, Bs)
    ))) {
      if (typeof o == "function") {
        const un = await o([Fe]);
        if (!un)
          return;
        de = un.id || de, k = un.name || k;
      }
      z({
        id: de,
        name: k,
        icon: V,
        content: Fe
      }), J({
        sharedContentId: de,
        idToReplace: Ee.id
      });
    }
  }, O = async (w) => {
    typeof a == "function" && a(w);
  }, I = (w, k, V, Z) => {
    var te, de;
    e.value && (e.value.editingSharedContent.node = (te = e == null ? void 0 : e.value) == null ? void 0 : te.activeNode, e.value.editingSharedContent.boundingRect = {
      top: w,
      left: k,
      width: V,
      height: Z
    }, e.value.editingSharedContent.originalContent = gt(
      n.content[(de = e == null ? void 0 : e.value) == null ? void 0 : de.activeNode.sharedContentId].content
    ));
  }, v = (w) => {
    var k;
    n.content[(k = e == null ? void 0 : e.value) == null ? void 0 : k.editingSharedContent.node.sharedContentId].content.push(w);
  }, A = b(
    () => {
      var w, k;
      return ((k = (w = e == null ? void 0 : e.value) == null ? void 0 : w.editingSharedContent) == null ? void 0 : k.node) || null;
    }
  ), D = b({
    get: () => {
      var w, k;
      return ((k = n == null ? void 0 : n.content) == null ? void 0 : k[(w = A.value) == null ? void 0 : w.sharedContentId]) || {};
    },
    set: (w) => {
      var k;
      return n.content[(k = A.value) == null ? void 0 : k.sharedContentId] = w;
    }
  }), j = (w) => !!Ge(A.value, w.id), F = (w) => {
    var k;
    return ((k = A.value) == null ? void 0 : k.id) === w.id;
  }, T = b(() => A.value ? {
    isBlocked: !1,
    message: ""
  } : {
    isBlocked: !0,
    message: "builder.cannotNestSharedContent"
  }), S = b(() => (w) => F(w)), x = async () => {
    var k;
    const w = (k = e == null ? void 0 : e.value) == null ? void 0 : k.editingSharedContent.node.sharedContentId;
    if (w) {
      if (typeof r == "function") {
        const V = n.content[w].content || [];
        if (!await r(
          w,
          V
        ))
          return;
      }
      Me();
    }
  }, B = async () => {
    var k, V, Z;
    const w = (k = e == null ? void 0 : e.value) == null ? void 0 : k.editingSharedContent.node.sharedContentId;
    w && (typeof i == "function" && !await i(w) || (n.content[(V = e == null ? void 0 : e.value) == null ? void 0 : V.editingSharedContent.node.sharedContentId].content = (Z = e == null ? void 0 : e.value) == null ? void 0 : Z.editingSharedContent.originalContent, Me()));
  }, R = (w) => {
    var V, Z;
    const k = (Z = n == null ? void 0 : n.content[(V = w == null ? void 0 : w.value) == null ? void 0 : V.sharedContentId]) == null ? void 0 : Z.content;
    return k ? w.value.nodes[0].nodes = k : (n.content[w.value.sharedContentId] = {
      content: [
        {
          id: w.value.sharedContentId,
          name: "Shared Component Error",
          type: tn
        }
      ]
    }, w.value.nodes[0].nodes = n.content[w.value.sharedContentId].content);
  };
  function z({ id: w, name: k, icon: V, content: Z }) {
    n.content[w] = { name: k, icon: V, content: [Z] };
  }
  function J({ sharedContentId: w, idToReplace: k }) {
    var de;
    const V = ye({
      sharedContentId: w,
      type: Se
    }), { parent: Z, index: te } = We(
      t.structure,
      k
    );
    Z.nodes.splice(te, 1, V), (de = e == null ? void 0 : e.value) == null || de.setActiveNode(V);
  }
  const re = async () => {
    var te, de, Ee, Fe;
    const w = (de = (te = e == null ? void 0 : e.value) == null ? void 0 : te.activeNode) == null ? void 0 : de.sharedContentId;
    if (!p.value || !w || typeof s == "function" && !await s(w))
      return;
    const k = nn({
      ...n.content[w].content[0]
    }), { parent: V, index: Z } = We(
      t.structure,
      (Fe = (Ee = e == null ? void 0 : e.value) == null ? void 0 : Ee.activeNode) == null ? void 0 : Fe.id
    );
    V.nodes.splice(Z, 1, k);
  }, ce = b(() => Object.entries(n.content || {}).map(([w, k]) => ({
    name: k.name,
    icon: k.icon,
    sharedContentId: w,
    type: Se
  }))), Ae = (w) => {
    const { sharedContentId: k, name: V, type: Z } = w;
    return ye({ sharedContentId: k, name: V, type: Z });
  }, $e = (w) => {
    var Z;
    const k = ye({
      type: Xt
    }), V = {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    return k.properties = {
      ...k.properties,
      margin: { ...V },
      padding: { ...V }
    }, k.nodes[0].nodes = ((Z = n.content[w]) == null ? void 0 : Z.content) || [], k;
  }, Te = (w) => n.content[w] || {};
  function Me() {
    var w;
    (w = e == null ? void 0 : e.value) == null || w.clearActiveNode(), e.value.editingSharedContent.node = null, e.value.editingSharedContent.boundingRect = null, e.value.editingSharedContent.originalContent = null;
  }
  function qe(w) {
    var k, V;
    switch (w.type) {
      case Dn: {
        w.content.assetUrl = ((k = e == null ? void 0 : e.value) == null ? void 0 : k.builder.assets[w.content.assetId].url) || "";
        break;
      }
      case Cn:
      case wn: {
        w.content.images = w.content.images.map((Z) => {
          var te;
          return Z.content.assetUrl = ((te = e == null ? void 0 : e.value) == null ? void 0 : te.builder.assets[Z.content.assetId].url) || "", Z;
        });
        break;
      }
      case $n: {
        w.content.image.content.assetUrl = ((V = e == null ? void 0 : e.value) == null ? void 0 : V.builder.assets[w.content.image.content.assetId].url) || "";
        break;
      }
    }
    return w;
  }
  const Ut = ({ allowDuplicates: w = !1 } = {}) => {
    var k, V;
    return (V = (k = e == null ? void 0 : e.value) == null ? void 0 : k.builder) != null && V.structure ? Kn(e.value.builder.structure, w) : [];
  };
  function Kn(w, k = !1) {
    const V = [], Z = (te) => {
      (te == null ? void 0 : te.type) === Se && V.push(te == null ? void 0 : te.sharedContentId);
      let de = (te == null ? void 0 : te.nodes) || {};
      Gn(de, (Ee) => {
        jn(Ee) && Z(Ee);
      });
    };
    return Z(w), k ? V : Z3(V);
  }
  return {
    amountOfSharedContent: C,
    isSharedContentAllowed: c,
    canCreateSharedContent: u,
    canEditSharedContent: d,
    canDetachSharedContent: p,
    showCreateSharedContentButton: g,
    showEditSharedContentButton: y,
    showDetachSharedContentButton: N,
    hasSharedContent: f,
    isSharedContentLayout: h,
    createSharedContent: m,
    openSharedContentSettings: O,
    isolateSharedContent: I,
    applyContentToSharedContentLayout: R,
    getSharedContentSidebarNodes: ce,
    onSidebarCloneSharedContent: Ae,
    generateDialogPreview: $e,
    getSharedContentById: Te,
    editingSharedContent: A,
    editingSharedContentNodes: D,
    isNodeInsideEditingSharedContentLayout: j,
    isCurrentSharedContentBeingEdited: F,
    showEditingSharedContentActions: S,
    blockSharedContentLayout: T,
    detachSharedContent: re,
    saveEditingSharedContent: x,
    cancelEditingSharedContent: B,
    addNodeToEditingSharedContent: v,
    extractSharedContentIds: Ut,
    deleteSharedContent: async (w) => {
      typeof l != "function" || !await l(w) || delete n.content[w];
    }
  };
}
let Et = null;
const X3 = ys((e) => (Et || (Et = As(e, {
  deep: !0,
  debounce: 500,
  flush: "post",
  clone: gt
})), Et)), K3 = () => {
  Et && (Et.clear(), Et = null);
};
function lr(e) {
  return {
    ...X3(e),
    clearSharedHistory: K3
  };
}
const q3 = {
  __name: "VerticalScrollText",
  props: {
    text: {
      type: String,
      default: ""
    },
    colorOnHover: {
      type: String,
      default: null
    },
    isHovering: Boolean,
    strikethrough: Boolean,
    activateScroll: Boolean
  },
  setup(e) {
    const t = e, n = U(null), o = U(null), a = U(3), r = U(0), i = () => {
      !n.value || !o.value || Pe(() => {
        const s = n.value, l = o.value, c = s.scrollWidth, u = l.clientWidth;
        r.value = Math.max(0, c - u), a.value = c > u ? Math.ceil(r.value / 50) : 0;
      });
    };
    return He(() => {
      i();
    }), (s, l) => (_(), M("div", {
      ref_key: "containerRef",
      ref: o,
      class: "text-container"
    }, [
      $("p", {
        ref_key: "textRef",
        ref: n,
        class: be(["scrollable-text", { "scroll-active": !!t.activateScroll }]),
        style: je({
          color: t.colorOnHover && t.isHovering ? t.colorOnHover : "inherit",
          textDecoration: t.strikethrough ? "line-through" : "none",
          "--scroll-duration": `${a.value}s`,
          "--scroll-distance": `${r.value}px`
        })
      }, [
        Ne(s.$slots, "default", {}, () => [
          ge(K(t.text), 1)
        ], !0)
      ], 6)
    ], 512));
  }
}, Es = /* @__PURE__ */ X(q3, [["__scopeId", "data-v-98180b20"]]), Q3 = { class: "elements-container" }, J3 = { class: "elements" }, e5 = {
  key: 1,
  class: "actions-group"
}, t5 = {
  key: 2,
  class: "actions-group"
}, n5 = { class: "action-icon" }, o5 = { class: "dropdown-item" }, r5 = { class: "dropdown-item-label" }, a5 = { class: "dropdown-item-shortkey" }, i5 = {
  __name: "ActiveNodeToolbar",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    activeAccordionId: {
      type: String,
      default: null
    }
  },
  emits: ["delete", "edit-shared-content"],
  setup(e, { emit: t }) {
    Pa((Y) => ({
      "2e7acba2": g.value
    }));
    const n = e, o = t, a = pe("state"), r = U(!1), i = b(() => {
      var Y, ee, w, k, V, Z, te, de;
      return ((k = (w = (ee = (Y = a == null ? void 0 : a.value) == null ? void 0 : Y.builder) == null ? void 0 : ee.customProperties) == null ? void 0 : w.global) == null ? void 0 : k.confirmOnDeleteDialogAllowed) && ((de = (te = (Z = (V = a == null ? void 0 : a.value) == null ? void 0 : V.builder) == null ? void 0 : Z.customProperties) == null ? void 0 : te.global) == null ? void 0 : de.showConfirmOnDeleteDialog);
    }), s = b(() => {
      var Y;
      return S(n.node) && ((Y = B(n.node.sharedContentId)) == null ? void 0 : Y.name) || n.node.name;
    }), l = b(() => `${n.node.name.toLowerCase().replace(" ", "-")}-toolbar`), c = b(() => {
      var ee, w, k, V, Z, te;
      const Y = ((V = (k = (w = (ee = n.node) == null ? void 0 : ee.nodes) == null ? void 0 : w[0]) == null ? void 0 : k.nodes) == null ? void 0 : V[0]) || {};
      return !!Ge(Y, (te = (Z = a == null ? void 0 : a.value) == null ? void 0 : Z.activeNode) == null ? void 0 : te.id);
    }), u = b(() => {
      var ee, w, k;
      const Y = !!((ee = a == null ? void 0 : a.value) != null && ee.activeNode) && J(n.node) && !J((w = a == null ? void 0 : a.value) == null ? void 0 : w.activeNode) && Ae((k = a == null ? void 0 : a.value) == null ? void 0 : k.activeNode);
      return !!R.value && Y;
    }), d = b(() => n.node.type.includes(Ze)), p = b(() => n.node.type === Re), f = b(() => d.value ? c.value : !1), C = b(() => {
      var ee, w;
      const Y = Ge(
        (ee = a == null ? void 0 : a.value) == null ? void 0 : ee.builder.structure,
        n.node.parentAccordionId
      );
      return p.value && ((w = Y == null ? void 0 : Y.nodes[0]) == null ? void 0 : w.nodes.length) === 1;
    }), h = b(() => C.value ? "builder.content.accordion.accordionMustHavePanels" : "builder.toolbar.deleteElement"), g = b(() => {
      var w, k;
      let ee = rt(n.node) ? 10 : 0;
      return (k = (w = n.node) == null ? void 0 : w.properties) != null && k.margin && (ee = n.node.properties.margin.linked ? n.node.properties.margin.value : n.node.properties.margin.top), `${-15 + ee}px`;
    }), y = b(() => {
      var Y;
      return ((Y = a == null ? void 0 : a.value) == null ? void 0 : Y.userAgent) === "mac" ? "⌘" : "Ctrl";
    }), N = (Y) => {
      if (Y === "add-custom-code") {
        A();
        return;
      }
      o(Y);
    }, m = b(() => [
      {
        id: "copy-node",
        label: "Copy element",
        shortkey: `${y.value} + C`,
        icon: "CopyIcon"
      },
      {
        id: "cut-node",
        label: "Cut element",
        shortkey: `${y.value} + X`,
        icon: "CutIcon"
      },
      {
        id: "paste-node",
        label: "Paste element",
        shortkey: `${y.value} + V`,
        icon: "PasteIcon"
      },
      {
        id: "add-custom-code",
        label: "Add custom attributes",
        shortkey: "",
        icon: "AddCustomCodeIcon"
      }
    ]), O = b(() => {
      var Y, ee, w, k;
      return !!((k = (w = (ee = (Y = a == null ? void 0 : a.value) == null ? void 0 : Y.builder) == null ? void 0 : ee.customProperties) == null ? void 0 : w.global) != null && k.customAttributesAllowed) && !S(n.node);
    }), I = () => {
      C.value || (i.value ? r.value = !0 : o("delete-node"));
    }, v = () => {
      var Y;
      (Y = a == null ? void 0 : a.value) == null || Y.setActiveNode(n.node);
    }, A = () => {
      a.value.showCustomAttributesSidebar = !0;
    }, {
      showCreateSharedContentButton: D,
      showDetachSharedContentButton: j,
      createSharedContent: F,
      detachSharedContent: T,
      isSharedContentLayout: S,
      showEditSharedContentButton: x,
      getSharedContentById: B,
      editingSharedContent: R,
      showEditingSharedContentActions: z,
      isCurrentSharedContentBeingEdited: J,
      saveEditingSharedContent: re,
      cancelEditingSharedContent: ce,
      isNodeInsideEditingSharedContentLayout: Ae
    } = De({
      state: a
    }), { resume: $e } = lr(a.value.builder), Te = () => {
      $e(), re();
    }, Me = () => {
      $e(), ce();
    }, qe = [
      {
        id: "create-shared-content",
        showAction: D.value && !p.value,
        tooltipText: "builder.toolbar.createSharedContent",
        icon: G(
          () => import("./CreateSharedContentIcon-JaPxqyHa.js")
        ),
        onClick: () => {
          F({
            accordionId: n.activeAccordionId
          });
        }
      },
      {
        id: "edit-shared-content",
        showAction: x.value && !p.value,
        tooltipText: "builder.toolbar.editSharedContent",
        icon: G(
          () => import("./EditSharedContentIcon-BahXB2XG.js")
        ),
        onClick: () => o("edit-shared-content")
      },
      {
        id: "detach-shared-content",
        showAction: j.value && !p.value,
        tooltipText: "builder.toolbar.detachSharedContent",
        icon: G(
          () => import("./DetachSharedContentIcon-CssuDhPF.js")
        ),
        onClick: T
      },
      {
        id: "add-custom-code",
        showAction: O.value,
        tooltipText: "builder.toolbar.addCustomAttributes",
        icon: G(
          () => import("./AddCustomCodeIcon-B7QiGh8P.js")
        ),
        onClick: A
      },
      {
        id: "duplicate-node",
        showAction: !0,
        tooltipText: "builder.toolbar.duplicateElement",
        icon: G(
          () => import("./DuplicateIcon-DmC4lau6.js")
        ),
        onClick: () => o("duplicate-node")
      },
      {
        id: "delete-node",
        showAction: !0,
        tooltipText: h.value,
        icon: G(
          () => import("./DeleteIcon-DNJN3HY4.js")
        ),
        onClick: I
      }
    ], Ut = [
      "create-shared-content",
      "edit-shared-content",
      "detach-shared-content",
      "duplicate-node",
      "delete-node"
    ], Kn = b(
      () => qe.filter(({ id: Y }) => Ut.includes(Y))
    );
    return (Y, ee) => {
      const w = L("a-text"), k = L("a-button"), V = L("a-dropdown"), Z = L("a-alert-header"), te = L("a-alert-content"), de = L("a-alert-footer"), Ee = L("a-dialog"), Fe = L("portal");
      return _(), M("div", {
        class: be([
          "toolbar",
          l.value,
          {
            "is-first-accordion-panel-active": f.value,
            "is-editing-shared-content": !!H(R),
            "shared-content-first-child-active": u.value
          }
        ]),
        onClick: ee[4] || (ee[4] = oo(() => {
        }, ["stop"]))
      }, [
        $("div", Q3, [
          $("div", J3, [
            H(z)(n.node) ? q("", !0) : (_(), W(Os, {
              key: 0,
              class: "handler"
            })),
            E(k, {
              class: "node-name",
              variant: "link",
              onClick: oo(v, ["stop"]),
              disabled: !d.value
            }, {
              default: P(() => [
                E(Es, { style: { maxWidth: "200px" } }, {
                  default: P(() => [
                    E(w, { variant: "h4" }, {
                      default: P(() => [
                        ge(K(s.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            H(z)(n.node) ? (_(), M("div", e5, [
              E(gn, {
                "tooltip-text": Y.$t("builder.toolbar.saveEditingSharedContent"),
                icon: "16:checkmark",
                onClick: Te
              }, null, 8, ["tooltip-text"]),
              E(gn, {
                "tooltip-text": Y.$t("builder.toolbar.cancelEditingSharedContent"),
                icon: "16:close",
                onClick: Me
              }, null, 8, ["tooltip-text"])
            ])) : (_(), M("div", t5, [
              (_(!0), M(ke, null, ot(Kn.value, (me) => (_(), M("div", n5, [
                me.showAction ? (_(), W(gn, {
                  key: me.id,
                  "tooltip-text": Y.$t(me.tooltipText),
                  onClick: me.onClick
                }, {
                  default: P(() => [
                    (_(), W(yn(me.icon)))
                  ]),
                  _: 2
                }, 1032, ["tooltip-text", "onClick"])) : q("", !0)
              ]))), 256)),
              E(V, {
                align: "right",
                class: "moreOptions",
                items: m.value,
                onItemClick: N
              }, Mo({
                dropdownTrigger: P(() => [
                  E(gn, {
                    "tooltip-text": Y.$t("builder.toolbar.moreOptions"),
                    icon: "16:shishkebab",
                    onClick: ee[0] || (ee[0] = (me) => Y.showSettings = !0)
                  }, null, 8, ["tooltip-text"])
                ]),
                _: 2
              }, [
                ot(m.value, (me) => ({
                  name: `dropdown_item_${me.id}`,
                  fn: P(({ item: bt }) => [
                    $("div", o5, [
                      (_(), W(yn(bt.icon))),
                      $("p", r5, K(bt.label), 1),
                      $("p", a5, K(bt.shortkey), 1)
                    ])
                  ])
                }))
              ]), 1032, ["items"])
            ]))
          ])
        ]),
        r.value ? (_(), W(Fe, {
          key: 0,
          to: "root-dialog-container"
        }, {
          default: P(() => [
            E(Ee, {
              show: r.value,
              "no-close-on-overlay": "",
              size: "l",
              onClose: ee[3] || (ee[3] = (me) => r.value = !1)
            }, {
              default: P(() => [
                E(Z, { alertMode: "warning" }, {
                  default: P(() => [
                    ge(K(Y.$t("builder.deleteNodeConfirmation")), 1)
                  ]),
                  _: 1
                }),
                E(te, null, {
                  default: P(() => ee[5] || (ee[5] = [
                    $("span", null, null, -1)
                  ])),
                  _: 1
                }),
                E(de, null, {
                  default: P(() => [
                    E(k, {
                      autofocus: "",
                      variant: "primary",
                      mode: "error",
                      onClick: ee[1] || (ee[1] = (me) => Y.$emit("delete-node"))
                    }, {
                      default: P(() => [
                        ge(K(Y.$t("builder.delete")), 1)
                      ]),
                      _: 1
                    }),
                    E(k, {
                      variant: "default",
                      mode: "error",
                      onClick: ee[2] || (ee[2] = (me) => r.value = !1)
                    }, {
                      default: P(() => [
                        ge(K(Y.$t("builder.cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })) : q("", !0)
      ], 2);
    };
  }
}, s5 = /* @__PURE__ */ X(i5, [["__scopeId", "data-v-26f6c522"]]), Ct = U(/* @__PURE__ */ new Map()), xs = ys(() => {
  function e(o, a) {
    if (!a)
      return null;
    if (Ct.value.has(o))
      return Ct.value.get(o);
    const r = As(a, {
      deep: !0,
      debounce: 500,
      clone: gt
    });
    return Ct.value.set(o, r), r;
  }
  function t(o) {
    return Ct.value.get(o);
  }
  function n(o) {
    Ct.value.has(o) && Ct.value.delete(o);
  }
  return {
    createHistory: e,
    getHistory: t,
    deleteHistory: n
  };
}), l5 = {
  __name: "ActiveNodeWrapper",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    isEditable: Boolean
  },
  setup(e) {
    const t = pe("state"), n = e, { node: o, isEditable: a } = Lo(n), r = b(() => S1(o.value)), i = pe("insideSharedContentLayout"), s = b(() => {
      var I, v, A, D;
      if (!a.value)
        return !1;
      if (C.value) {
        if (!f(o.value) && i.value)
          return !1;
        const j = ((v = (I = t == null ? void 0 : t.value) == null ? void 0 : I.activeNode) == null ? void 0 : v.id) === o.value.id && g(o.value);
        return f(o.value) || j;
      }
      return ((D = (A = t == null ? void 0 : t.value) == null ? void 0 : A.activeNode) == null ? void 0 : D.id) === o.value.id || c.value;
    }), l = (I) => {
      var v;
      return (v = I.nodes) != null && v.length ? I.nodes.some(
        (A) => {
          var D, j;
          return A.id === ((j = (D = t == null ? void 0 : t.value) == null ? void 0 : D.activeNode) == null ? void 0 : j.id) || l(A);
        }
      ) : !1;
    }, c = b(() => {
      var v, A;
      return [
        Ze,
        Re
      ].includes(o.value.type) && ((A = (v = t == null ? void 0 : t.value) == null ? void 0 : v.activeNode) == null ? void 0 : A.id) && l(o.value);
    }), u = U(null), {
      isSharedContentLayout: d,
      isolateSharedContent: p,
      isCurrentSharedContentBeingEdited: f,
      editingSharedContent: C,
      editingSharedContentNodes: h,
      isNodeInsideEditingSharedContentLayout: g
    } = De({
      state: t
    }), { pause: y } = lr(t.value.builder), { createHistory: N } = xs(t), m = () => {
      y();
      const { top: I, left: v, width: A, height: D } = Ts(u);
      p(I, v, A, D), N(
        C.value.sharedContentId,
        h
      );
    }, O = b(() => {
      let I = "var(--pb-black)", v = "var(--primary-white)";
      switch (r.value) {
        case dt:
          I = "var(--color-layout)";
          break;
        case ut:
          I = "var(--color-content)";
          break;
        case Ro:
          I = "var(--color-sub-content)", v = "var(--purple)";
          break;
      }
      return d(o.value) && (I = "var(--color-shared-content)"), {
        "--node-group-toolbar-bg-color": I,
        "--node-group-toolbar-color": v
      };
    });
    return (I, v) => {
      var A;
      return _(), M("div", {
        ref_key: "activeNodeRef",
        ref: u,
        class: be([
          `${r.value}-active-wrapper`,
          { "is-editing-shared-content": H(f)(H(o)) }
        ]),
        style: je(O.value)
      }, [
        s.value ? (_(), W(s5, {
          key: 0,
          node: H(o),
          "active-accordion-id": c.value && ((A = H(o)) == null ? void 0 : A.id),
          onAddCustomAttributes: v[0] || (v[0] = (D) => I.$emit("add-custom-attributes")),
          onCopyNode: v[1] || (v[1] = (D) => I.$emit("copy-node")),
          onCutNode: v[2] || (v[2] = (D) => I.$emit("cut-node")),
          onPasteNode: v[3] || (v[3] = (D) => I.$emit("paste-node")),
          onDuplicateNode: v[4] || (v[4] = (D) => I.$emit("duplicate-node")),
          onFavorite: v[5] || (v[5] = (D) => I.$emit("favorite")),
          onDeleteNode: v[6] || (v[6] = (D) => I.$emit("delete-node")),
          onEditSharedContent: m
        }, null, 8, ["node", "active-accordion-id"])) : q("", !0),
        Ne(I.$slots, "default", {}, void 0, !0)
      ], 6);
    };
  }
}, c5 = /* @__PURE__ */ X(l5, [["__scopeId", "data-v-cd4af42f"]]);
function ks({ node: e, state: t, maxNestingLevelsAllowed: n, isDraggableEditable: o, parentNodeId: a, isInsideSharedContentLayout: r = !1 }) {
  const i = ({ draggedContext: d, to: p }) => {
    const f = Number(p.getAttribute("data-level")) + 1;
    if (rt(d.element) && f >= n.value)
      return !1;
    const h = p.getAttribute("data-in-accordion") === "true";
    if (d.element.type === Ze && h)
      return !1;
  }, s = (d) => {
    t.nodeDragging = d.item._underlying_vm_;
  }, l = () => {
    t.nodeDragging = null;
  }, c = (d) => {
    var f;
    const p = (f = d.added) == null ? void 0 : f.element;
    if (d.added && p.type === Re) {
      const C = p.parentAccordionId, { parentAccordionId: h } = e.nodes.find(
        (g) => g.parentAccordionId !== C
      );
      h && (p.parentAccordionId = h);
    }
  }, u = b(() => {
    var p;
    const d = (p = t == null ? void 0 : t.editingSharedContent) == null ? void 0 : p.node;
    return r ? !!d : d && a ? d.id === a || !!Ge(d, a) : o.value;
  });
  return {
    handleDraggableNodeMoved: i,
    handleNodeDraggingStarted: s,
    handleNodeDraggingEnded: l,
    handleDraggableNodeChanged: c,
    isDraggableEnabled: u
  };
}
function Ds({
  state: e = {}
}) {
  const { copy: t, isSupported: n } = f$(), o = (u, d, p) => {
    if (e.isLinkModalOpen)
      return;
    const f = nn(u);
    Qr(u) && (f.parentAccordionId = u.parentAccordionId), d.nodes.splice(p + 1, 0, f), e == null || e.emitToConsumingApp("amplitude-event", {
      type: f.name,
      action: "added",
      attributes: {
        method: "duplicate",
        component: f.type
      }
    });
  }, a = (u, d, p = !1) => {
    if (e.isLinkModalOpen)
      return;
    const f = u.nodes[d];
    u.nodes.splice(d, 1), e == null || e.emitToConsumingApp("amplitude-event", {
      type: f.name,
      action: "removed",
      attributes: {
        method: p ? "cut" : "delete",
        component: f.type
      }
    });
  }, r = () => {
    var p, f;
    if (!e.activeNode || !n || e.isLinkModalOpen)
      return;
    i();
    const { parent: u, index: d } = We((p = e.builder) == null ? void 0 : p.structure, (f = e.activeNode) == null ? void 0 : f.id);
    a(u, d, !0), e.clearActiveNode(), e.clearEditor();
  }, i = () => {
    !e.activeNode || !n || e.isLinkModalOpen || t(JSON.stringify(e.activeNode));
  }, s = async () => {
    const u = await navigator.clipboard.readText();
    let d = !1;
    try {
      const p = JSON.parse(u), f = Array.isArray(p) ? [...p] : [p];
      return d = f.some((C) => (C.component || "").includes("ts-")), {
        clipboardData: f,
        isValidNode: !0,
        isLegacyNode: d
      };
    } catch {
      return {
        clipboardData: [u],
        isValidNode: !1,
        isLegacyNode: d
      };
    }
  }, l = async (u = null) => {
    if (!u) {
      const { clipboardData: g = [], isLegacyNode: y } = await s();
      u = g, y && (u = c(u));
    }
    const d = !(e != null && e.activeNode), p = !!(e != null && e.activeNode) && rt(e == null ? void 0 : e.activeNode), f = !!(e != null && e.activeNode) && Si(e == null ? void 0 : e.activeNode), C = !!(e != null && e.activeNode) && Qr(e == null ? void 0 : e.activeNode);
    (Array.isArray(u) ? u : [u]).forEach((g, y) => {
      var O, I, v, A, D;
      const N = nn(g), m = y;
      if (e == null || e.emitToConsumingApp("amplitude-event", {
        type: N.name,
        action: "added",
        attributes: {
          method: "paste",
          component: N.type
        }
      }), d) {
        (v = (I = (O = e == null ? void 0 : e.builder) == null ? void 0 : O.structure) == null ? void 0 : I.nodes) == null || v.push(N);
        return;
      }
      if (p) {
        e.activeNode.nodes[0].nodes.push(N);
        return;
      }
      if (f) {
        const { parent: j, index: F } = We((A = e.builder) == null ? void 0 : A.structure, (D = e.activeNode) == null ? void 0 : D.id), T = F + m + 1;
        j.nodes.splice(T, 0, N);
        return;
      }
      if (C) {
        if (Ti(N))
          return;
        e.activeNode.nodes[0].nodes.push(N);
        return;
      }
    });
  }, c = (u = [{}]) => {
    var p, f;
    if (!e)
      return;
    let d = null;
    if (typeof ((f = (p = e == null ? void 0 : e.builder) == null ? void 0 : p.legacyAdapters) == null ? void 0 : f.pageToBuilder) == "function") {
      const { structure: C, assets: h } = e.builder.legacyAdapters.pageToBuilder(u);
      h && e.addAsset(h), C.id && C.id === "root" ? d = C.nodes || [{}] : d = C || [{}];
    }
    return d;
  };
  return {
    duplicateNode: o,
    deleteNode: a,
    cutSelectedNode: r,
    copySelectedNode: i,
    isClipboardSupported: n,
    dataInClipboard: s,
    pasteNode: l,
    convertLegacyStructureToBuilderStructure: c
  };
}
const d5 = {
  key: 0,
  class: "draggable-node-list-container"
}, u5 = {
  key: 1,
  style: { "pointer-events": "auto" },
  class: "accordion-panel-placeholder"
}, p5 = {
  __name: "DraggableNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    parentNodeId: {
      type: String,
      default: ""
    },
    inAccordion: Boolean,
    isEditable: Boolean
  },
  setup(e) {
    const t = G(() => Promise.resolve().then(() => Ps)), n = pe("state"), o = pe("maxNestingLevelsAllowed"), a = e, r = b(() => a.modelValue), i = b(() => a.isEditable);
    function s() {
      var A, D, j, F, T, S;
      (A = n == null ? void 0 : n.value) != null && A.nodeDragging && ((S = n == null ? void 0 : n.value) == null || S.emitToConsumingApp("amplitude-event", {
        type: (j = (D = n == null ? void 0 : n.value) == null ? void 0 : D.nodeDragging) == null ? void 0 : j.name,
        action: "added",
        attributes: {
          method: "drag-and-drop",
          component: (T = (F = n == null ? void 0 : n.value) == null ? void 0 : F.nodeDragging) == null ? void 0 : T.type
        }
      }), n.value.nodeDragging = null);
    }
    function l(A) {
      var D, j;
      (D = n == null ? void 0 : n.value) == null || D.clearEditor(), (j = n == null ? void 0 : n.value) == null || j.clearActiveNode(), m(r.value, A);
    }
    const c = pe("insideSharedContentLayout");
    function u(A, D) {
      var j, F;
      if (v.value) {
        I(D) && (A.stopPropagation(), (j = n == null ? void 0 : n.value) == null || j.setActiveNode(D));
        return;
      }
      c.value || i.value && (A.stopPropagation(), (F = n == null ? void 0 : n.value) == null || F.setActiveNode(D));
    }
    const {
      handleDraggableNodeMoved: d,
      handleNodeDraggingStarted: p,
      handleNodeDraggingEnded: f,
      handleDraggableNodeChanged: C,
      isDraggableEnabled: h
    } = ks({
      node: r,
      state: n.value,
      maxNestingLevelsAllowed: o,
      isDraggableEditable: i,
      parentNodeId: a.parentNodeId,
      isInsideSharedContentLayout: c.value
    }), {
      copySelectedNode: g,
      cutSelectedNode: y,
      pasteNode: N,
      deleteNode: m,
      duplicateNode: O
    } = Ds({ state: n.value }), { isNodeInsideEditingSharedContentLayout: I, editingSharedContent: v } = De({
      state: n
    });
    return (A, D) => r.value.nodes ? (_(), M("div", d5, [
      E(H(Ba), {
        ref: "builder-draggable",
        list: r.value.nodes,
        "ghost-class": "ghost-class",
        handle: ".handler",
        class: be([
          "draggable-node-list",
          { "empty-node": !r.value.nodes.length },
          `draggable-level-${e.level}`
        ]),
        group: e.draggableGroup,
        "swap-threshold": 0.5,
        "data-level": e.level,
        disabled: !H(h),
        "item-key": "id",
        "data-in-accordion": e.inAccordion,
        move: H(d),
        onStart: H(p),
        onEnd: H(f),
        onChange: H(C),
        onDrop: s
      }, {
        item: P(({ element: j, index: F }) => [
          r.value.nodes.length ? (_(), W(c5, {
            class: be({ "accordion-panel-active-wrapper": e.inAccordion }),
            key: j.id,
            node: j,
            "is-editable": i.value,
            "in-accordion": e.inAccordion,
            onCopyNode: H(g),
            onCutNode: H(y),
            onPasteNode: H(N),
            onDuplicateNode: (T) => H(O)(j, r.value, F),
            onDeleteNode: (T) => l(F)
          }, {
            default: P(() => [
              E(H(t), {
                modelValue: r.value.nodes[F],
                "onUpdate:modelValue": (T) => r.value.nodes[F] = T,
                level: e.level + 1,
                "in-accordion": e.inAccordion,
                "is-editable": i.value,
                onClick: (T) => u(T, j)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "level", "in-accordion", "is-editable", "onClick"])
            ]),
            _: 2
          }, 1032, ["class", "node", "is-editable", "in-accordion", "onCopyNode", "onCutNode", "onPasteNode", "onDuplicateNode", "onDeleteNode"])) : e.inAccordion ? (_(), M("div", u5, K(A.$t("builder.content.accordion.emptyAccordionMessage")), 1)) : q("", !0)
        ]),
        _: 1
      }, 8, ["list", "class", "group", "data-level", "disabled", "data-in-accordion", "move", "onStart", "onEnd", "onChange"])
    ])) : q("", !0);
  }
}, h5 = /* @__PURE__ */ X(p5, [["__scopeId", "data-v-add59926"]]), f5 = {
  name: "DraggableBlocker",
  props: {
    message: {
      type: String,
      required: !0
    }
  }
}, g5 = ["blocked-layout-message"];
function v5(e, t, n, o, a, r) {
  return _(), M("div", {
    class: "blockage-mask",
    "blocked-layout-message": n.message
  }, null, 8, g5);
}
const m5 = /* @__PURE__ */ X(f5, [["render", v5], ["__scopeId", "data-v-a3ecc03c"]]), b5 = {
  __name: "BorderRadiusControl",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = b({
      get: () => {
        var r, i, s;
        return ((s = (i = (r = n.node) == null ? void 0 : r.properties) == null ? void 0 : i.borderRadius) == null ? void 0 : s.value) || 0;
      },
      set: (r) => {
        o("update", r);
      }
    });
    return (r, i) => {
      const s = L("a-form-input");
      return _(), W(ft, null, {
        title: P(() => [
          $("h4", null, K(r.$t("builder.borderStyles.borderRadius")), 1)
        ]),
        control: P(() => [
          E(s, {
            modelValue: a.value,
            "onUpdate:modelValue": i[0] || (i[0] = (l) => a.value = l),
            width: "70px",
            type: "number",
            min: 0,
            max: 100
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}, _5 = /* @__PURE__ */ X(b5, [["__scopeId", "data-v-36b970f3"]]), y5 = {
  name: "MarginControl",
  components: {
    NodeControl: ft
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    },
    property: {
      type: String,
      default: "margin"
    }
  },
  computed: {
    toggleLinked: {
      get() {
        var e, t, n;
        return (n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t[this.property]) == null ? void 0 : n.linked;
      },
      set(e) {
        this.$emit("toggle", e);
      }
    }
  },
  methods: {
    updateLinkedValue(e) {
      var t, n;
      this.$emit("update", {
        ...((n = (t = this.node) == null ? void 0 : t.properties) == null ? void 0 : n[this.property]) || {},
        value: Number(e)
      });
    },
    updateMarginPadding(e, t) {
      var n, o;
      this.$emit("update", {
        ...((o = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : o[this.property]) || {},
        [e]: Number(t)
      });
    }
  }
}, C5 = { class: "inline-control" }, w5 = { class: "more-options-toggle" }, $5 = {
  key: 0,
  class: "more-options-row"
};
function S5(e, t, n, o, a, r) {
  const i = L("a-form-input"), s = L("a-text"), l = L("a-tooltip"), c = L("a-toggle"), u = L("NodeControl");
  return _(), W(u, null, {
    title: P(() => [
      $("h4", null, K(e.$t(`builder.borderStyles.${n.property}`)), 1)
    ]),
    content: P(() => {
      var d, p, f, C, h, g, y, N, m;
      return [
        $("div", C5, [
          E(i, {
            type: "number",
            width: "70px",
            label: "",
            min: 0,
            step: 2,
            disabled: !((f = (p = (d = n.node) == null ? void 0 : d.properties) == null ? void 0 : p[n.property]) != null && f.linked),
            "model-value": ((g = (h = (C = n.node) == null ? void 0 : C.properties) == null ? void 0 : h[n.property]) == null ? void 0 : g.value) || 0,
            "onUpdate:modelValue": r.updateLinkedValue
          }, null, 8, ["disabled", "model-value", "onUpdate:modelValue"]),
          $("div", w5, [
            E(l, {
              label: e.$t("builder.linkedTooltip"),
              position: "left",
              size: "small"
            }, {
              default: P(() => [
                E(s, null, {
                  default: P(() => [
                    ge(K(e.$t("builder.linked")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            E(c, {
              modelValue: r.toggleLinked,
              "onUpdate:modelValue": t[0] || (t[0] = (O) => r.toggleLinked = O)
            }, null, 8, ["modelValue"])
          ])
        ]),
        (m = (N = (y = n.node) == null ? void 0 : y.properties) == null ? void 0 : N[n.property]) != null && m.linked ? q("", !0) : (_(), M("div", $5, [
          (_(), M(ke, null, ot(["top", "right", "bottom", "left"], (O) => {
            var I, v, A;
            return $("div", {
              key: O,
              class: "more-options-input-wrapper"
            }, [
              E(i, {
                class: "more-options-input",
                type: "number",
                width: "70px",
                label: O,
                min: 0,
                step: 2,
                modelValue: ((A = (v = (I = n.node) == null ? void 0 : I.properties) == null ? void 0 : v[n.property]) == null ? void 0 : A[O]) || 0,
                "onUpdate:modelValue": (D) => r.updateMarginPadding(O, D)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]);
          }), 64))
        ]))
      ];
    }),
    _: 1
  });
}
const N5 = /* @__PURE__ */ X(y5, [["render", S5], ["__scopeId", "data-v-88077f9b"]]), A5 = {
  name: "LayoutNodeControl",
  components: {
    BackgroundColorControl: di,
    BackgroundImageControl: Xi,
    BorderRadiusControl: _5,
    MarginPaddingControl: N5,
    SidebarHeader: ar
  },
  inject: ["state"],
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    layoutCustomProperties() {
      var e, t, n;
      return ((n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n[this.node.type]) || {};
    },
    node() {
      return this.modelValue;
    },
    experimentalFeatures() {
      var e, t, n;
      return ((n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n.experimentalFeatures) || {};
    }
  }
};
function T5(e, t, n, o, a, r) {
  const i = L("SidebarHeader"), s = L("BackgroundColorControl"), l = L("BackgroundImageControl"), c = L("BorderRadiusControl"), u = L("MarginPaddingControl"), d = L("portal");
  return _(), W(d, {
    to: r.node.id
  }, {
    default: P(() => [
      E(i, {
        title: r.node.name,
        onCloseSidebar: t[0] || (t[0] = (p) => e.$emit("close-sidebar"))
      }, null, 8, ["title"]),
      $("div", null, [
        r.layoutCustomProperties.backgroundColorAllowed ? (_(), W(s, {
          key: 0,
          node: r.node,
          onUpdate: t[1] || (t[1] = (p, f) => r.node.properties.backgroundColor[p] = f)
        }, null, 8, ["node"])) : q("", !0),
        r.layoutCustomProperties.backgroundImageAllowed ? (_(), W(l, {
          key: 1,
          node: r.node,
          assets: r.state.builder.assets,
          "upload-api": r.state.builder.api.images,
          onUpdate: t[2] || (t[2] = (p, f) => r.node.properties.backgroundImage[p] = f),
          onAssetEntry: t[3] || (t[3] = (p) => r.state.addAsset(p))
        }, null, 8, ["node", "assets", "upload-api"])) : q("", !0),
        r.experimentalFeatures.roundedLayouts ? (_(), W(c, {
          key: 2,
          node: r.node,
          onUpdate: t[4] || (t[4] = (p) => r.node.properties.borderRadius.value = p)
        }, null, 8, ["node"])) : q("", !0),
        r.layoutCustomProperties.marginAllowed ? (_(), W(u, {
          key: 3,
          node: r.node,
          property: "margin",
          onUpdate: t[5] || (t[5] = (p) => r.node.properties.margin = p),
          onToggle: t[6] || (t[6] = (p) => r.node.properties.margin.linked = p)
        }, null, 8, ["node"])) : q("", !0),
        r.layoutCustomProperties.paddingAllowed ? (_(), W(u, {
          key: 4,
          node: r.node,
          property: "padding",
          onUpdate: t[7] || (t[7] = (p) => r.node.properties.padding = p),
          onToggle: t[8] || (t[8] = (p) => r.node.properties.padding.linked = p)
        }, null, 8, ["node"])) : q("", !0)
      ])
    ]),
    _: 1
  }, 8, ["to"]);
}
const O5 = /* @__PURE__ */ X(A5, [["render", T5]]);
function I5(e) {
  const t = b(() => {
    var a;
    return ((a = e.value) == null ? void 0 : a.properties) || {};
  }), n = b(() => t.value.customClasses || []), o = b(() => t.value.anchorTag || "");
  return {
    nodeProperties: t,
    customClasses: n,
    anchorTag: o
  };
}
const E5 = ["data-builder-label", "data-anchor-tag"], x5 = {
  __name: "LayoutNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    inAccordion: Boolean,
    isActiveNode: Boolean,
    isEditable: Boolean,
    isEmptyBuilder: Boolean
  },
  setup(e) {
    Pa((x) => ({
      "3ef0f526": y.value
    }));
    const t = pe("state"), n = pe("maxNestingLevelsAllowed"), o = e, {
      modelValue: a,
      level: r,
      draggableGroup: i,
      inAccordion: s,
      isActiveNode: l,
      isEditable: c,
      isEmptyBuilder: u
    } = Lo(o), d = U({ width: 700, height: 70 }), p = U(null);
    He(() => {
      p.value && (d.value.width = p.value.clientWidth || 0, d.value.height = p.value.clientHeight || 0);
    }), sr(p, (x) => {
      var J;
      const B = x[0], { inlineSize: R, blockSize: z } = ((J = B.borderBoxSize) == null ? void 0 : J[0]) || {};
      d.value.width = R || p.value.clientWidth, d.value.height = z || p.value.clientHeight;
    });
    const f = b(() => {
      var x;
      return {
        ...M$(
          (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder,
          a.value,
          !1,
          d.value
        ),
        "--root-level-width": `calc(${N.value} - ${A.value})`,
        "--root-level-max-width": `calc(${m.value} - ${A.value})`
      };
    }), C = b(() => a.value.type.replace(/_/g, "-").toLowerCase().replace("layout-node-", "")), h = b(() => {
      var J, re, ce, Ae, $e, Te;
      const x = ((re = (J = t == null ? void 0 : t.value) == null ? void 0 : J.nodeDragging) == null ? void 0 : re.id) === ((ce = a.value) == null ? void 0 : ce.id);
      if (!((Ae = t == null ? void 0 : t.value) != null && Ae.nodeDragging) || x)
        return {
          isBlocked: !1,
          message: ""
        };
      if (j(a.value))
        return F.value;
      const B = r.value + 1 >= n.value, R = rt(($e = t == null ? void 0 : t.value) == null ? void 0 : $e.nodeDragging), z = !!Ge(
        (Te = t == null ? void 0 : t.value) == null ? void 0 : Te.nodeDragging,
        a.value.id
      );
      return {
        isBlocked: B && R && !z,
        message: "builder.cannotNestMoreLayouts"
      };
    }), g = (x) => rt(a.value) || j(a.value) ? a.value.nodes[x] : a.value, y = b(() => {
      switch (a.value.type) {
        case ve:
        case Xt:
        case Nt:
        case Se:
          return 1;
        case Kt:
        case Jt:
        case en:
          return 2;
        case qt:
          return 3;
        case Qt:
          return 4;
        default:
          return 0;
      }
    }), N = b(() => {
      var x, B, R, z;
      return a.value.type === Nt || s.value ? "100%" : ((z = (R = (B = (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder) == null ? void 0 : B.customProperties) == null ? void 0 : R.global) == null ? void 0 : z.rootElementsWidth) || "100%";
    }), m = b(() => {
      var x, B, R, z;
      return a.value.type === Nt || s.value ? "100%" : ((z = (R = (B = (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder) == null ? void 0 : B.customProperties) == null ? void 0 : R.global) == null ? void 0 : z.rootElementsMaxWidth) || "100%";
    }), { nodeProperties: O, customClasses: I, anchorTag: v } = I5(a), A = b(() => {
      var J, re, ce, Ae, $e, Te, Me, qe;
      const x = !!((re = (J = O.value) == null ? void 0 : J.margin) != null && re.linked), B = ((Ae = (ce = O.value) == null ? void 0 : ce.margin) == null ? void 0 : Ae.left) || 0, R = ((Te = ($e = O.value) == null ? void 0 : $e.margin) == null ? void 0 : Te.right) || 0, z = ((qe = (Me = O.value) == null ? void 0 : Me.margin) == null ? void 0 : qe.value) || 0;
      return x ? `${z * 2}px` : `${B + R}px`;
    }), D = b(() => {
      var x, B, R;
      return !!l.value && O1(
        (R = (B = (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder) == null ? void 0 : B.customProperties) == null ? void 0 : R[a.value.type]
      );
    }), {
      isSharedContentLayout: j,
      blockSharedContentLayout: F,
      editingSharedContent: T
    } = De({
      state: t
    }), S = b(() => {
      var x, B;
      return !!((x = T.value) != null && x.id) && ((B = T.value) == null ? void 0 : B.id) === a.value.id;
    });
    return (x, B) => (_(), M("div", {
      class: be(["pb-layout-container", [
        `row-level-${H(r)}`,
        { "in-accordion": H(s) },
        { "is-empty-builder": H(u) }
      ]])
    }, [
      $("div", {
        ref_key: "layoutNodeContainer",
        ref: p,
        class: be(["layout-node-container", [
          { "is-active": H(l) || S.value },
          C.value + "-row",
          H(I)
        ]]),
        style: je(f.value),
        "data-builder-label": x.$t("builder.emptyBuilderLabel"),
        "data-anchor-tag": H(v)
      }, [
        h.value.isBlocked ? (_(), W(m5, {
          key: 0,
          message: x.$t(h.value.message)
        }, null, 8, ["message"])) : q("", !0),
        (_(!0), M(ke, null, ot(y.value, (R, z) => (_(), M("div", {
          key: z,
          class: be(["column", [C.value, { "is-editable": H(c) }]])
        }, [
          E(h5, {
            "model-value": g(z),
            level: H(r),
            "draggable-group": H(i),
            "is-editable": H(c),
            "in-accordion": H(s),
            "parent-node-id": H(a).id || ""
          }, null, 8, ["model-value", "level", "draggable-group", "is-editable", "in-accordion", "parent-node-id"])
        ], 2))), 128))
      ], 14, E5),
      D.value ? (_(), W(O5, {
        key: 0,
        modelValue: H(a),
        "onUpdate:modelValue": B[0] || (B[0] = (R) => Gs(a) ? a.value = R : null),
        onCloseSidebar: B[1] || (B[1] = (R) => H(t).clearActiveNode())
      }, null, 8, ["modelValue"])) : q("", !0)
    ], 2));
  }
}, k5 = /* @__PURE__ */ X(x5, [["__scopeId", "data-v-225f5e84"]]), D5 = {
  __name: "NodeManager",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    isEditable: Boolean,
    inAccordion: Boolean
  },
  setup(e) {
    const t = pe("state"), n = e, { modelValue: o, isEditable: a, inAccordion: r, level: i } = Lo(n), s = b(() => (l(o.value) && c(o), o.value)), {
      isSharedContentLayout: l,
      applyContentToSharedContentLayout: c,
      isCurrentSharedContentBeingEdited: u
    } = De({ state: t }), d = pe("insideSharedContentLayout"), p = b(
      () => !u(s.value) && (!!(d != null && d.value) || l(s.value))
    );
    vn("insideSharedContentLayout", p);
    const f = b(
      () => rt(s.value) || Ni(s.value) || l(s.value)
    ), C = b(
      () => s.value.id === "root" && i.value === 0
    ), h = b(() => {
      var A;
      return a.value ? C.value && ((A = s.value.nodes) == null ? void 0 : A.length) === 0 || $1(s.value, r.value) : !1;
    }), g = b(() => {
      var A, D;
      return a.value && ((A = t == null ? void 0 : t.value) == null ? void 0 : A.activeNode) && ((D = t == null ? void 0 : t.value) == null ? void 0 : D.activeNode.id) === s.value.id;
    }), y = b(() => ({
      "empty-builder": h.value,
      "is-editable": a.value,
      root: C.value
    })), N = b(() => {
      var A, D;
      return C.value && !!((D = (A = t == null ? void 0 : t.value) == null ? void 0 : A.editingSharedContent) != null && D.node);
    }), m = U(null), { top: O, left: I } = Ts(m), v = b(() => {
      var R, z, J;
      if (!((z = (R = t == null ? void 0 : t.value) == null ? void 0 : R.editingSharedContent) != null && z.node))
        return {};
      const {
        top: A,
        left: D,
        width: j,
        height: F
      } = (J = t == null ? void 0 : t.value) == null ? void 0 : J.editingSharedContent.boundingRect, T = A - O.value - 40, S = D - I.value, x = j, B = F;
      return {
        clipPath: `polygon(0% 0%, 0% 100%, ${S}px 100%, ${S}px ${T}px, ${S + x}px ${T}px, ${S + x}px ${T + B}px, ${S}px ${T + B}px, ${S}px 100%, 100% 100%, 100% 0%)`
      };
    });
    return (A, D) => (_(), M("div", {
      ref_key: "nodeManagerContainer",
      ref: m,
      class: be(["node-manager-container", y.value])
    }, [
      f.value ? (_(), W(k5, {
        key: 0,
        modelValue: s.value,
        "onUpdate:modelValue": D[0] || (D[0] = (j) => s.value = j),
        level: H(i),
        "is-editable": H(a),
        "in-accordion": H(r),
        "draggable-group": e.draggableGroup,
        "is-active-node": g.value,
        "is-empty-builder": h.value
      }, null, 8, ["modelValue", "level", "is-editable", "in-accordion", "draggable-group", "is-active-node", "is-empty-builder"])) : (_(), W(I$, {
        key: 1,
        modelValue: s.value,
        "onUpdate:modelValue": D[1] || (D[1] = (j) => s.value = j),
        "is-editable": H(a),
        "in-accordion": H(r),
        level: H(i),
        isActiveNode: g.value
      }, null, 8, ["modelValue", "is-editable", "in-accordion", "level", "isActiveNode"])),
      N.value ? (_(), W(T$, {
        key: 2,
        style: je(v.value)
      }, null, 8, ["style"])) : q("", !0)
    ], 2));
  }
}, Ms = /* @__PURE__ */ X(D5, [["__scopeId", "data-v-eff29325"]]), Ps = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ms
}, Symbol.toStringTag, { value: "Module" })), M5 = { class: "shared-content-dialog no-drag" }, P5 = { class: "preview-section" }, L5 = { class: "info-section" }, R5 = { class: "node-name" }, B5 = { class: "info-actions" }, j5 = {
  __name: "SharedContentDialog",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    contentPreview: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e;
    return (n, o) => {
      const a = L("a-icon"), r = L("a-button");
      return _(), M("div", M5, [
        $("div", P5, [
          E(Ms, {
            "model-value": e.contentPreview,
            "is-editable": !1
          }, null, 8, ["model-value"])
        ]),
        $("div", L5, [
          $("p", R5, K(t.node.name), 1),
          $("div", B5, [
            E(r, {
              class: "settings-button",
              variant: "none",
              onClick: o[0] || (o[0] = (i) => n.$emit("open-settings"))
            }, {
              default: P(() => [
                E(a, { icon: "24:settings-1" })
              ]),
              _: 1
            }),
            q("", !0)
          ])
        ])
      ]);
    };
  }
}, U5 = /* @__PURE__ */ X(j5, [["__scopeId", "data-v-27da9484"]]), H5 = { class: "shared-content-block" }, V5 = { class: "node-name" }, F5 = { class: "triangle" }, z5 = {
  __name: "SharedContentIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = pe("state"), n = e, o = U(!1), a = U(!1), r = (d) => a.value = d, i = (d) => o.value = d, {
      generateDialogPreview: s,
      openSharedContentSettings: l,
      deleteSharedContent: c
    } = De({
      state: t
    }), u = b(
      () => s(n.node.sharedContentId)
    );
    return (d, p) => {
      const f = L("a-icon");
      return _(), M("div", H5, [
        Zt((_(), M("div", {
          class: "block",
          onDblclick: p[0] || (p[0] = (C) => d.$emit("add-node"))
        }, [
          E(f, {
            class: "icon",
            icon: "32:paper-plane"
          }),
          E(Es, {
            style: { width: "75px" },
            "color-on-hover": "white",
            "is-hovering": o.value,
            "activate-scroll": o.value
          }, {
            default: P(() => [
              $("span", V5, K(n.node.name), 1)
            ]),
            _: 1
          }, 8, ["is-hovering", "activate-scroll"])
        ], 32)), [
          [H(xo), [i]]
        ]),
        Zt((_(), M("div", null, [
          $("div", F5, [
            E(f, {
              class: "eye-icon",
              icon: "24:eye-open",
              color: "white"
            })
          ]),
          a.value && !o.value ? (_(), W(U5, {
            key: 0,
            node: n.node,
            "content-preview": u.value,
            onOpenSettings: p[1] || (p[1] = (C) => H(l)(n.node.sharedContentId)),
            onDelete: p[2] || (p[2] = (C) => H(c)(n.node.sharedContentId))
          }, null, 8, ["node", "content-preview"])) : q("", !0)
        ])), [
          [H(xo), [r, { delayLeave: 150 }]]
        ])
      ]);
    };
  }
}, W5 = /* @__PURE__ */ X(z5, [["__scopeId", "data-v-4036c559"]]), G5 = { class: "sidebar-nodes" }, Y5 = { class: "group-title" }, Z5 = {
  __name: "SidebarNodes",
  props: {
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    },
    isSharedContentSidebar: Boolean
  },
  setup(e) {
    const t = e, n = pe("state"), o = _n({
      nodes: [
        ...Bo,
        ...Mn.filter(
          (T) => ![...tl, ...nl].includes(T.type)
        )
      ]
    }), a = b(
      () => {
        var T, S;
        return ((S = (T = n == null ? void 0 : n.value) == null ? void 0 : T.builder) == null ? void 0 : S.customProperties) || {};
      }
    ), {
      isSharedContentLayout: r,
      getSharedContentSidebarNodes: i,
      onSidebarCloneSharedContent: s,
      amountOfSharedContent: l,
      editingSharedContent: c,
      addNodeToEditingSharedContent: u
    } = De({ state: n }), d = U(""), p = b(
      () => t.isSharedContentSidebar ? [Se] : [dt, ut]
    ), f = b(() => {
      let T = t.nodesIncluded.length ? o.nodes.filter((S) => t.nodesIncluded.includes(S.type)) : o.nodes;
      return T = T.filter((S) => {
        var R, z, J;
        const x = !!((J = (z = (R = a.value) == null ? void 0 : R.CONTENT_NODE_NAVIGATION) == null ? void 0 : z.siteMenu) != null && J.length);
        return !(S.type === Nn && !x);
      }), T.filter(
        (S) => !t.nodesExcluded.includes(S.type)
      );
    }), C = b(() => {
      var T;
      return ((T = a.value) == null ? void 0 : T.experimentalFeatures) || {};
    }), h = b(() => {
      var T, S;
      return (S = (T = a.value) == null ? void 0 : T.global) == null ? void 0 : S.focusNewNodeOnCreate;
    }), g = (T) => {
      var x, B, R;
      const S = O(T);
      if (c.value) {
        u(S);
        return;
      }
      (B = (x = n == null ? void 0 : n.value) == null ? void 0 : x.builder) == null || B.structure.nodes.push(S), (R = n == null ? void 0 : n.value) == null || R.emitToConsumingApp("amplitude-event", {
        type: S.name,
        action: "added",
        attributes: {
          method: "double-click",
          component: S.type
        }
      });
    }, y = (T) => {
      switch (T) {
        case dt:
          return "Layouts";
        case ut:
          return "Contents";
        case Se:
          return "Shared Content";
      }
    }, N = (T) => ({
      "blocks-container": !0,
      "shared-blocks-container": T === Se,
      "layout-blocks-container": T === dt,
      "content-blocks-container": T === ut
    }), m = (T) => T === Se ? i.value.filter(
      ({ name: x, sharedContentId: B }) => {
        var R;
        return x.toLowerCase().includes(d.value.toLowerCase().trim()) && B !== ((R = c == null ? void 0 : c.value) == null ? void 0 : R.sharedContentId);
      }
    ) : f.value.filter((S) => S.group === T), O = (T) => r(T) ? v(T) : I(T), I = (T) => {
      var x, B;
      let S = null;
      switch (T.group) {
        case dt:
          S = ye(T, C.value);
          break;
        case ut:
          S = pt(T, (x = n == null ? void 0 : n.value) == null ? void 0 : x.builder.theme);
          break;
      }
      return h.value && ((B = n == null ? void 0 : n.value) == null || B.setActiveNode(S)), S;
    }, v = (T) => {
      var x;
      const S = s(T);
      return h.value && ((x = n == null ? void 0 : n.value) == null || x.setActiveNode(S)), S;
    }, A = pe("maxNestingLevelsAllowed"), {
      handleDraggableNodeMoved: D,
      handleNodeDraggingStarted: j,
      handleNodeDraggingEnded: F
    } = ks({
      state: n.value,
      maxNestingLevelsAllowed: A
    });
    return (T, S) => {
      const x = L("a-form-input");
      return _(), M("div", G5, [
        (_(!0), M(ke, null, ot(p.value, (B) => (_(), M("div", {
          key: B,
          class: "group-block"
        }, [
          $("h4", Y5, K(y(B)), 1),
          B === H(Se) && H(l) > 6 ? (_(), W(x, {
            key: 0,
            type: "search",
            placeholder: T.$t("builder.builderTabs.searchSharedContentPlaceholder"),
            modelValue: d.value,
            "onUpdate:modelValue": S[0] || (S[0] = (R) => d.value = R)
          }, null, 8, ["placeholder", "modelValue"])) : q("", !0),
          E(H(Ba), {
            ref_for: !0,
            ref: "sidebar-draggable",
            list: m(B),
            class: be(N(B)),
            filter: ".no-drag",
            group: { name: "structure", pull: "clone", put: !1 },
            clone: O,
            sort: !1,
            "item-key": "id",
            move: H(D),
            onStart: H(j),
            onEnd: H(F)
          }, {
            item: P(({ element: R, index: z }) => [
              B !== H(Se) ? (_(), W(e$, {
                node: R,
                "group-type": B,
                key: `${R.type}-${z}`,
                onAddNode: (J) => g(R)
              }, null, 8, ["node", "group-type", "onAddNode"])) : (_(), W(W5, {
                node: R,
                key: `sc-${R.type}-${z}`,
                onAddNode: (J) => g(R)
              }, null, 8, ["node", "onAddNode"]))
            ]),
            _: 2
          }, 1032, ["list", "class", "move", "onStart", "onEnd"])
        ]))), 128))
      ]);
    };
  }
}, Aa = /* @__PURE__ */ X(Z5, [["__scopeId", "data-v-e2aa8f9a"]]), X5 = { key: 1 }, K5 = { class: "tabs-section" }, q5 = {
  key: 1,
  class: "sidebar-title"
}, Q5 = { key: 0 }, J5 = { key: 1 }, eS = {
  __name: "ContentToolbar",
  props: {
    builder: {
      type: Object,
      default: () => ({})
    },
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    }
  },
  emits: ["switch-tab"],
  setup(e, { emit: t }) {
    const n = pe("state"), o = U("content"), a = U(!1), { isSharedContentAllowed: r, hasSharedContent: i } = De({
      state: n
    }), s = b(
      () => r.value && i.value
    );
    le(s, (d) => {
      d || (o.value = "content", c("switch-tab", o.value));
    });
    const l = U([
      {
        value: "content",
        label: "Content",
        ariaControls: "Content"
      },
      {
        value: "shared",
        label: "Shared",
        ariaControls: "Shared"
      }
    ]), c = t, u = (d) => {
      o.value = d.target.value, c("switch-tab", o.value);
    };
    return (d, p) => {
      const f = L("a-tabs"), C = L("a-icon"), h = L("a-button");
      return a.value ? (_(), W(N_, {
        key: 0,
        builder: e.builder,
        onCloseSidebar: p[0] || (p[0] = (g) => a.value = !1)
      }, null, 8, ["builder"])) : (_(), M("div", X5, [
        $("div", K5, [
          s.value ? (_(), W(f, {
            key: 0,
            selected: o.value,
            tabs: l.value,
            class: "sidebar-tabs",
            onSwitchTabs: u
          }, null, 8, ["selected", "tabs"])) : (_(), M("h3", q5, K(d.$t("builder.builderTabs.dragAndDropElements")), 1)),
          E(h, {
            class: "settings-button",
            variant: "none",
            onClick: p[1] || (p[1] = (g) => a.value = !0)
          }, {
            default: P(() => [
              E(C, { icon: "24:settings-2" })
            ]),
            _: 1
          })
        ]),
        o.value === "content" ? (_(), M("div", Q5, [
          E(Aa, {
            "nodes-included": e.nodesIncluded,
            "nodes-excluded": e.nodesExcluded
          }, null, 8, ["nodes-included", "nodes-excluded"])
        ])) : q("", !0),
        o.value === "shared" ? (_(), M("div", J5, [
          E(Aa, { "is-shared-content-sidebar": "" })
        ])) : q("", !0)
      ]));
    };
  }
}, tS = /* @__PURE__ */ X(eS, [["__scopeId", "data-v-a1077ba7"]]), nS = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
}, oS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rS = ["opacity"];
function aS(e, t, n, o, a, r) {
  return _(), M("svg", oS, [
    $("g", { opacity: r.isDisabled }, t[0] || (t[0] = [
      $("path", {
        d: "M4 11.5823H14.92C17.7256 11.5823 20 13.8567 20 16.6623V18.3333M4 11.5823L9.65217 5M4 11.5823L9.65217 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]), 8, rS)
  ]);
}
const Ls = /* @__PURE__ */ X(nS, [["render", aS]]), KS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ls
}, Symbol.toStringTag, { value: "Module" })), iS = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
}, sS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lS = ["opacity"];
function cS(e, t, n, o, a, r) {
  return _(), M("svg", sS, [
    $("g", { opacity: r.isDisabled }, t[0] || (t[0] = [
      $("path", {
        d: "M20 11.5823H9.08C6.27439 11.5823 4 13.8567 4 16.6623V18.3333M20 11.5823L14.3478 5M20 11.5823L14.3478 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]), 8, lS)
  ]);
}
const Rs = /* @__PURE__ */ X(iS, [["render", cS]]), qS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rs
}, Symbol.toStringTag, { value: "Module" })), dS = {
  name: "BuilderToolbar",
  components: {
    // BreakpointPreview,
    UndoIcon: Ls,
    RedoIcon: Rs
  },
  inject: ["state"],
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    },
    redoDisabled: Boolean,
    undoDisabled: Boolean
  },
  computed: {
    editor() {
      var e;
      return ((e = this.state) == null ? void 0 : e.editor) || {
        editor: {},
        editorKey: "",
        enabledOptions: [],
        removeOptions: [],
        colorPalette: {}
      };
    },
    linkModalOptions() {
      return this.customRTEProperties.linkModalOptions || {};
    },
    colorPalette() {
      var t, n, o;
      return {
        enabled: T1(
          ((t = this.state) == null ? void 0 : t.builder) || {}
        ),
        colors: ((o = (n = this.editor) == null ? void 0 : n.colorPalette) == null ? void 0 : o.colors) || ["*"]
      };
    },
    customRTEProperties() {
      var e, t, n;
      return ((n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n.RTEBar) || {};
    },
    aiEnabled() {
      var e, t, n, o, a;
      return ((a = (o = (n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n.global) == null ? void 0 : o.aiOptions) == null ? void 0 : a.enabled) || !1;
    },
    getRemoveOptions() {
      const e = this.customRTEProperties.removeOptions || [], t = this.editor.removeOptions || [];
      return [...e, ...t];
    }
  },
  methods: {
    toggleModal(e) {
      this.state.isLinkModalOpen = e, this.$emit("toggle-modal", e);
    }
  }
}, uS = { class: "sticky-header" }, pS = { class: "history-buttons" };
function hS(e, t, n, o, a, r) {
  const i = L("UndoIcon"), s = L("a-button"), l = L("a-tooltip"), c = L("RedoIcon"), u = L("a-static-rte");
  return _(), M("div", uS, [
    (_(), W(u, {
      key: r.editor.editorKey,
      class: "editor",
      disabled: !!r.customRTEProperties.disabled,
      "remove-default-actions": r.customRTEProperties.removeDefaultActions,
      "remove-options": r.getRemoveOptions,
      "editor-instance": r.editor.editor,
      "enabled-options": r.editor.enabledOptions,
      "link-modal-options": r.linkModalOptions,
      "color-palette": r.colorPalette,
      "font-sizes": r.customRTEProperties.fontSizes,
      "ai-enabled": r.aiEnabled,
      onToggleModal: r.toggleModal,
      onClick: t[2] || (t[2] = oo(() => {
      }, ["prevent", "stop"]))
    }, {
      "custom-actions": P(() => [
        $("div", pS, [
          E(l, {
            label: e.$t("builder.toolbar.undo"),
            position: "bottom"
          }, {
            default: P(() => [
              E(s, {
                variant: "none",
                disabled: n.undoDisabled,
                onClick: t[0] || (t[0] = (d) => e.$emit("undo"))
              }, {
                default: P(() => [
                  E(i, { disabled: n.undoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          E(l, {
            label: e.$t("builder.toolbar.redo"),
            position: "bottom"
          }, {
            default: P(() => [
              E(s, {
                variant: "none",
                disabled: n.redoDisabled,
                onClick: t[1] || (t[1] = (d) => e.$emit("redo"))
              }, {
                default: P(() => [
                  E(c, { disabled: n.redoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["disabled", "remove-default-actions", "remove-options", "editor-instance", "enabled-options", "link-modal-options", "color-palette", "font-sizes", "ai-enabled", "onToggleModal"]))
  ]);
}
const fS = /* @__PURE__ */ X(dS, [["render", hS], ["__scopeId", "data-v-114cea93"]]);
function Ta(...e) {
  return b(() => e.some((t) => Ie(t)));
}
function gS({
  state: e = null,
  undo: t = null,
  redo: n = null,
  duplicateNode: o = null,
  deleteNode: a = null,
  allowArrowNavigation: r = !1,
  copySelectedNode: i = null,
  cutSelectedNode: s = null,
  dataInClipboard: l = null,
  pasteNode: c = null
}) {
  const { text: u } = $$(), { editingSharedContent: d } = De({ state: e }), p = $a(), f = b(() => {
    var m, O, I, v;
    return ((m = p.value) == null ? void 0 : m.tagName) === "INPUT" || ((O = p.value) == null ? void 0 : O.tagName) === "TEXTAREA" || ((v = (I = e == null ? void 0 : e.editor) == null ? void 0 : I.editor) == null ? void 0 : v.isFocused);
  }), C = b(() => !!u.value), h = b(() => {
    var m, O;
    return (O = (m = e == null ? void 0 : e.editor) == null ? void 0 : m.editor) == null ? void 0 : O.isFocused;
  });
  He(() => {
    s && we(document, "cut", (m) => {
      if (h.value || e.isCodeModalOpen)
        return !0;
      if (!e || C.value)
        return !1;
      s();
    }), i && we(document, "copy", (m) => {
      !e || C.value || e.isCodeModalOpen || i();
    }), c && we(document, "paste", (m) => {
      y(m);
    });
  });
  const g = C$({
    passive: !1,
    async onEventFired(m) {
      const O = m.type === "keydown", I = {
        ctrlZ: !!t && (m.ctrlKey || m.metaKey) && m.key.toLowerCase() === "z",
        shiftCtrlZ: !!n && m.shiftKey && (m.ctrlKey || m.metaKey) && m.key.toLowerCase() === "z",
        ctrlD: !!o && m.ctrlKey && m.key.toLowerCase() === "d",
        ctrlBackspace: !!a && m.ctrlKey && m.key === "Backspace",
        arrowUp: !f.value && !!r && m.key === "ArrowUp",
        arrowDown: !f.value && !!r && m.key === "ArrowDown",
        arrowLeft: !f.value && !!r && m.key === "ArrowLeft",
        arrowRight: !f.value && !!r && m.key === "ArrowRight",
        escape: m.key === "Escape"
      };
      O && Object.values(I).some((v) => !!v) && m.preventDefault();
    }
  });
  t && ze(Ta(g.ctrl_z, g.meta_z), () => {
    e.isCodeModalOpen || t();
  }), n && ze(Ta(g.shift_ctrl_z, g.meta_shift_z), () => {
    e.isCodeModalOpen || n();
  }), o && ze(g.ctrl_d, () => {
    var I, v;
    if (!(e != null && e.activeNode) || e.isCodeModalOpen)
      return;
    const { parent: m, index: O } = We(
      (I = e.builder) == null ? void 0 : I.structure,
      (v = e.activeNode) == null ? void 0 : v.id
    );
    return o(e.activeNode, m, O);
  }), a && ze(g.ctrl_backspace, () => {
    var I, v;
    if (!(e != null && e.activeNode) || e.isCodeModalOpen)
      return;
    const { parent: m, index: O } = We(
      (I = e.builder) == null ? void 0 : I.structure,
      (v = e.activeNode) == null ? void 0 : v.id
    );
    e.clearActiveNode(), e.clearEditor(), a(m, O);
  }), r && e && ze(g.arrowUp, () => {
    var O, I, v, A, D, j, F;
    if (!r || f.value || e.isCodeModalOpen || d.value)
      return;
    if (!(e != null && e.activeNode)) {
      e.setActiveNode(((v = (I = (O = e.builder) == null ? void 0 : O.structure) == null ? void 0 : I.nodes) == null ? void 0 : v[0]) || null);
      return;
    }
    const m = We(
      (A = e.builder) == null ? void 0 : A.structure,
      (D = e.activeNode) == null ? void 0 : D.id
    );
    m.index - 1 >= 0 && e.setActiveNode(((F = (j = m.parent) == null ? void 0 : j.nodes) == null ? void 0 : F[(m == null ? void 0 : m.index) - 1]) || null);
  }), r && e && ze(g.arrowDown, () => {
    var O, I, v, A, D, j, F, T;
    if (!r || f.value || e.isCodeModalOpen || d.value)
      return;
    if (!(e != null && e.activeNode)) {
      e.setActiveNode(((v = (I = (O = e.builder) == null ? void 0 : O.structure) == null ? void 0 : I.nodes) == null ? void 0 : v[0]) || null);
      return;
    }
    const m = We(
      (A = e.builder) == null ? void 0 : A.structure,
      (D = e.activeNode) == null ? void 0 : D.id
    );
    (((j = m.parent) == null ? void 0 : j.nodes) || []).length - 1 >= m.index + 1 && e.setActiveNode(((T = (F = m.parent) == null ? void 0 : F.nodes) == null ? void 0 : T[m.index + 1]) || null);
  }), r && e && ze(g.arrowLeft, () => {
    var O, I;
    if (!r || f.value || !e.activeNode || e.isCodeModalOpen || d.value)
      return;
    const m = Ai(
      (O = e.builder) == null ? void 0 : O.structure,
      (I = e.activeNode) == null ? void 0 : I.id
    );
    m.grandparent && e.setActiveNode(m.grandparent);
  }), r && e && ze(g.arrowRight, () => {
    var O, I, v, A, D, j, F, T, S, x;
    if (!r || f.value || !e.activeNode || e.isCodeModalOpen || d.value)
      return;
    const m = ((I = (O = e.activeNode) == null ? void 0 : O.nodes) == null ? void 0 : I.length) > 0 && ((j = (D = (A = (v = e.activeNode) == null ? void 0 : v.nodes) == null ? void 0 : A[0]) == null ? void 0 : D.nodes) == null ? void 0 : j.length) > 0;
    rt(e.activeNode) && m && e.setActiveNode(((x = (S = (T = (F = e.activeNode) == null ? void 0 : F.nodes) == null ? void 0 : T[0]) == null ? void 0 : S.nodes) == null ? void 0 : x[0]) || null);
  }), e && ze(g.escape, async () => {
    e.clearActiveNode(), e.clearEditor();
  });
  async function y(m) {
    var T, S;
    if (e.isCodeModalOpen)
      return;
    const { value: O = {} } = $a(), I = !!O.editor, v = O.type;
    if (I || f.value && v !== "text")
      return;
    m.preventDefault();
    const { clipboardData: A, isValidNode: D, isLegacyNode: j } = await l();
    let F = A;
    if (j && typeof ((S = (T = e == null ? void 0 : e.builder) == null ? void 0 : T.legacyAdapters) == null ? void 0 : S.pageToBuilder) == "function") {
      const { structure: x, assets: B } = e.builder.legacyAdapters.pageToBuilder(F);
      B && e.addAsset(B), x.id && x.id === "root" ? F = x.nodes || [{}] : F = x || [{}];
    }
    if (!D) {
      f.value && N(A[0], O);
      return;
    }
    c && c(F);
  }
  function N(m, O) {
    const I = O.selectionStart, v = O.selectionEnd, A = O.value, D = A.slice(0, I) + m + A.slice(v);
    O.value = D, O.selectionStart = O.selectionEnd = I + m.length, O.dispatchEvent(new Event("input"));
  }
}
const vS = { class: "builder-manager-container" }, mS = { class: "builder-toolbar-section" }, bS = {
  __name: "BuilderManager",
  props: {
    isEditable: Boolean
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, o = pe("state"), a = G(() => Promise.resolve().then(() => Ps)), r = b({
      get() {
        var T;
        return (T = o == null ? void 0 : o.value) == null ? void 0 : T.builder;
      },
      set(T) {
        o.value.builder = T, n("update:modelValue", T);
      }
    });
    le(r, (T) => n("update:modelValue", T), {
      deep: !0
    });
    const { undo: i, redo: s, canUndo: l, canRedo: c, pause: u, resume: d, clearSharedHistory: p } = lr(r), { editingSharedContent: f } = De({
      state: o
    }), { getHistory: C } = xs(o);
    La(() => {
      p();
    });
    const h = b(() => {
      if (f.value) {
        const { canUndo: T } = C(
          f.value.sharedContentId
        );
        return !T;
      }
      return !l.value;
    }), g = () => {
      if (u(), f.value) {
        const { undo: T } = C(
          f.value.sharedContentId
        );
        T();
        return;
      }
      i(), Pe(() => {
        d();
      });
    }, y = b(() => {
      if (f.value) {
        const { canRedo: T } = C(
          f.value.sharedContentId
        );
        return !T;
      }
      return !c.value;
    }), N = () => {
      if (u(), f.value) {
        const { redo: T } = C(
          f.value.sharedContentId
        );
        T();
        return;
      }
      s(), Pe(() => {
        d();
      });
    }, {
      duplicateNode: m,
      deleteNode: O,
      copySelectedNode: I,
      cutSelectedNode: v,
      dataInClipboard: A,
      pasteNode: D
    } = Ds({
      state: o.value
    });
    gS({
      state: o.value,
      duplicateNode: m,
      deleteNode: O,
      copySelectedNode: I,
      cutSelectedNode: v,
      dataInClipboard: A,
      pasteNode: D,
      allowArrowNavigation: !0,
      undo: g,
      redo: N
    }), Ra();
    function j(T = "header") {
      var S;
      (S = o == null ? void 0 : o.value) == null || S.setActiveNode({ id: T });
    }
    function F() {
      var T;
      (T = o == null ? void 0 : o.value) == null || T.clearActiveNode();
    }
    return (T, S) => {
      var x, B, R, z, J, re;
      return _(), M("div", vS, [
        $("section", mS, [
          e.isEditable ? (_(), W(fS, {
            key: 0,
            builder: r.value,
            "redo-disabled": y.value,
            "undo-disabled": h.value,
            onRedo: N,
            onUndo: g,
            onToggleModal: S[0] || (S[0] = (ce) => T.$emit("toggle-modal", ce))
          }, {
            "header-preview": P(() => [
              Ne(T.$slots, "header-preview", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["builder", "redo-disabled", "undo-disabled"])) : q("", !0)
        ]),
        $("section", {
          class: be(["builder-draggable-section", { "is-editable": e.isEditable }])
        }, [
          (R = (B = (x = r.value) == null ? void 0 : x.customProperties) == null ? void 0 : B.global) != null && R.showHeaderSlot ? Ne(T.$slots, "header", {
            key: 0,
            openSidebar: j,
            closeSidebar: F
          }, void 0, !0) : q("", !0),
          E(H(a), {
            modelValue: r.value.structure,
            "onUpdate:modelValue": S[1] || (S[1] = (ce) => r.value.structure = ce),
            "is-editable": e.isEditable
          }, null, 8, ["modelValue", "is-editable"]),
          (re = (J = (z = r.value) == null ? void 0 : z.customProperties) == null ? void 0 : J.global) != null && re.showFooterSlot ? Ne(T.$slots, "footer", { key: 1 }, void 0, !0) : q("", !0)
        ], 2)
      ]);
    };
  }
}, _S = /* @__PURE__ */ X(bS, [["__scopeId", "data-v-19275ca3"]]), yS = {
  key: 1,
  class: "non-editable-entry"
}, CS = { class: "icons-container" }, wS = {
  key: 1,
  class: "non-editable-entry"
}, $S = { class: "icons-container" }, SS = { class: "button-container" }, NS = {
  __name: "CustomAttributesSidebar",
  setup(e) {
    const t = pe("state"), n = U(-1), o = U(null), a = U(null), r = U(null), i = U(!0), s = U(!0), l = b({
      get: () => {
        var S, x;
        return ((x = (S = t == null ? void 0 : t.value) == null ? void 0 : S.activeNode.properties) == null ? void 0 : x.anchorTag) || "";
      },
      set: (S) => {
        t.value.activeNode.properties.anchorTag = S;
      }
    }), c = b({
      get: () => {
        var S, x;
        return ((x = (S = t == null ? void 0 : t.value) == null ? void 0 : S.activeNode.properties) == null ? void 0 : x.customClasses) || [];
      },
      set: (S) => t.value.activeNode.properties.customClasses = S
    }), u = b(
      () => c.value[n.value]
    ), d = b(() => D(l.value)), p = b(
      () => D(u.value)
    ), f = b(
      () => p.value || d.value
    );
    He(() => {
      var S;
      o.value = (S = t == null ? void 0 : t.value) == null ? void 0 : S.activeNode.id, !(c.value.length > 0) && (n.value = 0, c.value.push(""));
    }), La(() => {
      C(o.value);
    });
    const C = (S) => {
      var B, R;
      const x = Ge((B = t == null ? void 0 : t.value) == null ? void 0 : B.builder.structure, S);
      !x || !((R = x == null ? void 0 : x.properties) != null && R.customClasses) || (x.properties.customClasses = x.properties.customClasses.filter(
        (z) => !!(z != null && z.trim())
      ));
    }, h = (S) => {
      var R, z;
      if (!S.value)
        return;
      const x = ((R = S.value) == null ? void 0 : R.$el) || ((z = S.value[0]) == null ? void 0 : z.$el);
      if (!x)
        return;
      const B = x.querySelector("input");
      B && B.focus();
    }, g = () => {
      s.value = !0, Pe(() => h(r));
    }, y = (S) => {
      p.value || (i.value = !0, n.value = S, Pe(() => h(a)));
    }, N = b(() => {
      const S = c.value[c.value.length - 1];
      return !p.value && S !== "";
    }), m = () => {
      var S, x;
      (S = t == null ? void 0 : t.value) == null || S.activeNode.properties.customClasses.push(""), i.value = !0, n.value = ((x = t == null ? void 0 : t.value) == null ? void 0 : x.activeNode.properties.customClasses.length) - 1, Pe(() => h(a));
    }, O = () => {
      t.value.activeNode.properties.anchorTag = "", s.value = !0, Pe(() => h(r));
    }, I = b(() => c.value.length > 1), v = (S) => {
      var x;
      (x = t == null ? void 0 : t.value) == null || x.activeNode.properties.customClasses.splice(S, 1), S <= n.value && (n.value -= 1), a.value && Pe(() => h(a));
    }, A = /^(?!-\d)[a-zA-Z_-](?:[a-zA-Z0-9_-]|\\[^\n\r])*$/, D = (S) => S !== "" && !A.test(S), j = () => {
      !l.value || d.value || (s.value = !1);
    }, F = () => {
      !u.value || p.value || (i.value = !1);
    }, T = () => {
      f.value || (t.value.showCustomAttributesSidebar = !1);
    };
    return (S, x) => {
      const B = L("a-form-input"), R = L("a-icon"), z = L("a-button");
      return _(), M(ke, null, [
        E(ar, {
          title: S.$t("builder.controls.customAttributes.title"),
          onCloseSidebar: T
        }, null, 8, ["title"]),
        E(ft, null, {
          title: P(() => [
            $("h4", null, K(S.$t("builder.controls.customAttributes.anchorTagLabel")), 1)
          ]),
          content: P(() => [
            s.value ? (_(), W(B, {
              key: 0,
              modelValue: l.value,
              "onUpdate:modelValue": x[0] || (x[0] = (J) => l.value = J),
              id: "anchor-tag-input",
              ref_key: "anchorInput",
              ref: r,
              placeholder: S.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              label: S.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              "sr-only": "",
              "label-for": "anchor-tag-input",
              "show-error": d.value,
              "error-message": S.$t("builder.controls.customAttributes.invalidAttributeError", {
                attribute: S.$t("builder.controls.customAttributes.anchorTagLabel")
              }),
              onKeydown: hr(j, ["enter"]),
              onBlur: j
            }, null, 8, ["modelValue", "placeholder", "label", "show-error", "error-message"])) : (_(), M("div", yS, [
              $("p", null, K(l.value), 1),
              $("div", CS, [
                E(z, {
                  variant: "default",
                  size: "small",
                  onClick: g
                }, {
                  default: P(() => [
                    E(R, { icon: "16:edit" })
                  ]),
                  _: 1
                }),
                E(z, {
                  variant: "default",
                  size: "small",
                  onClick: O
                }, {
                  default: P(() => [
                    E(R, { icon: "16:trashcan" })
                  ]),
                  _: 1
                })
              ])
            ]))
          ]),
          _: 1
        }),
        E(ft, null, {
          title: P(() => [
            $("h4", null, K(S.$t("builder.controls.customAttributes.customClassLabel")), 1)
          ]),
          content: P(() => [
            (_(!0), M(ke, null, ot(c.value, (J, re) => (_(), M("div", {
              key: re,
              class: "custom-class-container"
            }, [
              i.value && re === n.value ? (_(), W(B, {
                key: 0,
                modelValue: c.value[re],
                "onUpdate:modelValue": (ce) => c.value[re] = ce,
                id: `custom-class-input-${re}`,
                ref_for: !0,
                ref_key: "classInput",
                ref: a,
                placeholder: S.$t("builder.controls.customAttributes.customClassPlaceholder"),
                label: S.$t("builder.controls.customAttributes.customClassPlaceholder"),
                "sr-only": "",
                "label-for": `custom-class-input-${re}`,
                "show-error": p.value,
                "error-message": S.$t("builder.controls.customAttributes.invalidAttributeError", {
                  attribute: S.$t(
                    "builder.controls.customAttributes.customClassLabel"
                  )
                }),
                onKeydown: hr(F, ["enter"]),
                onBlur: F
              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "placeholder", "label", "label-for", "show-error", "error-message"])) : (_(), M("div", wS, [
                $("p", null, K(J), 1),
                $("div", $S, [
                  E(z, {
                    variant: "default",
                    size: "small",
                    onClick: (ce) => y(re)
                  }, {
                    default: P(() => [
                      E(R, { icon: "16:edit" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  I.value ? (_(), W(z, {
                    key: 0,
                    variant: "default",
                    size: "small",
                    onClick: (ce) => v(re)
                  }, {
                    default: P(() => [
                      E(R, { icon: "16:trashcan" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : q("", !0)
                ])
              ]))
            ]))), 128)),
            $("div", SS, [
              E(z, {
                variant: "link",
                disabled: !N.value,
                onClick: m
              }, {
                default: P(() => [
                  E(R, { icon: "16:plus" }),
                  ge(" " + K(S.$t("builder.controls.customAttributes.addAnotherClass")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ], 64);
    };
  }
};
function AS(e, t, n = { childList: !0, subtree: !0 }, o = 50) {
  const a = U(null), r = U(!1);
  let i = null, s = null;
  const l = () => {
    s && clearTimeout(s), s = setTimeout(() => {
      r.value = !!document.querySelector(t);
    }, o);
  }, c = () => {
    i = new MutationObserver(() => {
      l();
    }), a.value && i.observe(a.value, n);
  };
  return He(() => {
    if (document) {
      if (a.value = document.querySelector(e), !a.value) {
        console.error(
          `Target element with selector "${e}" not found`
        );
        return;
      }
      r.value = !!document.querySelector(t), c();
    }
  }), Ia(() => {
    i && i.disconnect(), s && clearTimeout(s);
  }), { elementExists: r };
}
const TS = { class: "sidebar-container" }, OS = { class: "builder-section" }, IS = { class: "root-dialog-container" }, ES = {
  __name: "PageBuilder",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    isRenderMode: Boolean
  },
  emits: [
    "toggle-modal",
    "update:modelValue",
    "ai-on-success",
    "ai-on-loading",
    "ai-on-error",
    "amplitude-event"
  ],
  setup(e, { emit: t }) {
    const n = t, { elementExists: o } = AS(
      ".root-dialog-container",
      ".a-dialog"
    );
    le(o, (y) => {
      n("toggle-modal", y);
    });
    const a = e, r = U(If(n));
    vn("state", r), vn("isRenderMode", a.isRenderMode), He(() => {
      var y;
      (y = navigator == null ? void 0 : navigator.userAgentData) != null && y.platform && (r.value.userAgent = navigator.userAgentData.platform.toLowerCase().includes("mac") ? "mac" : "windows");
    });
    const i = b(() => {
      var y;
      return (y = r == null ? void 0 : r.value) == null ? void 0 : y.builder.customProperties;
    }), s = b(
      () => i.value.global.maxNestingLevelsAllowed
    );
    vn("maxNestingLevelsAllowed", s);
    const l = b(() => a.modelValue);
    r.value.builder = l.value instanceof Mr ? l.value : new Mr(l.value);
    const c = b(
      () => {
        var y;
        return Ef((y = r == null ? void 0 : r.value) == null ? void 0 : y.builder);
      }
    ), { extractSharedContentIds: u } = De({
      state: r
    });
    l.value.extractSharedContentIds = u;
    const d = b(
      () => {
        var y, N, m;
        return (y = r == null ? void 0 : r.value) != null && y.showCustomAttributesSidebar ? "" : ((m = (N = r == null ? void 0 : r.value) == null ? void 0 : N.activeNode) == null ? void 0 : m.id) || "";
      }
    ), p = b(() => i.value.nodesIncluded), f = b(() => i.value.nodesExcluded), C = U("content"), h = (y) => {
      C.value = y;
    }, g = b(() => C.value === "content" ? { "overflow-y": "auto", "overflow-x": "hidden" } : {});
    return (y, N) => {
      var m;
      return _(), M("div", {
        style: je(c.value),
        class: "pb-main"
      }, [
        a.isRenderMode ? q("", !0) : (_(), M("section", {
          key: 0,
          class: "sidebar-section",
          style: je(g.value)
        }, [
          $("div", TS, [
            r.value.showCustomAttributesSidebar ? (_(), W(NS, {
              key: (m = r.value.activeNode) == null ? void 0 : m.id
            })) : (_(), W(H(ro), {
              key: 1,
              name: d.value
            }, {
              default: P(() => [
                E(tS, {
                  builder: r.value.builder,
                  "nodes-included": p.value,
                  "nodes-excluded": f.value,
                  onSwitchTab: h
                }, null, 8, ["builder", "nodes-included", "nodes-excluded"])
              ]),
              _: 1
            }, 8, ["name"]))
          ])
        ], 4)),
        $("section", OS, [
          E(_S, {
            "is-editable": !a.isRenderMode,
            "onUpdate:modelValue": N[0] || (N[0] = (O) => y.$emit("update:modelValue", O)),
            onToggleModal: N[1] || (N[1] = (O) => y.$emit("toggle-modal", O))
          }, {
            header: P(({ openSidebar: O, closeSidebar: I }) => [
              Ne(y.$slots, "header", {
                openSidebar: O,
                closeSidebar: I
              }, void 0, !0)
            ]),
            "header-preview": P(() => [
              Ne(y.$slots, "header-preview", {}, void 0, !0)
            ]),
            footer: P(() => [
              Ne(y.$slots, "footer", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["is-editable"])
        ]),
        $("div", IS, [
          E(H(ro), { name: "root-dialog-container" })
        ])
      ], 4);
    };
  }
}, xS = /* @__PURE__ */ X(ES, [["__scopeId", "data-v-5cbc1498"]]), QS = {
  install(e) {
    e.use(el), e.component("ABuilder", xS);
  }
};
export {
  QS as $,
  it as A,
  Ye as B,
  Re as C,
  m5 as D,
  fi as E,
  hf as F,
  Xe as G,
  Gt as H,
  u_ as I,
  Vu as J,
  I5 as K,
  LS as L,
  Q0 as M,
  ft as N,
  ii as O,
  ni as P,
  n1 as Q,
  Ds as R,
  ar as S,
  pn as T,
  GS as U,
  Es as V,
  YS as W,
  Ve as X,
  Ke as Y,
  qo as Z,
  X as _,
  HS as a,
  ve as a0,
  Xt as a1,
  Kt as a2,
  qt as a3,
  Qt as a4,
  Nt as a5,
  Jt as a6,
  en as a7,
  Se as a8,
  At as a9,
  KS as aA,
  qS as aB,
  mn as aa,
  Dn as ab,
  ao as ac,
  io as ad,
  Cn as ae,
  so as af,
  lo as ag,
  co as ah,
  uo as ai,
  po as aj,
  wn as ak,
  $n as al,
  ho as am,
  Ze as an,
  Sn as ao,
  Nn as ap,
  Mr as aq,
  ye as ar,
  rt as as,
  jS as at,
  VS as au,
  FS as av,
  zS as aw,
  WS as ax,
  XS as ay,
  Ps as az,
  N1 as b,
  gt as c,
  Yi as d,
  US as e,
  Ge as f,
  pt as g,
  A1 as h,
  BS as i,
  Mf as j,
  gr as k,
  RS as l,
  ci as m,
  Ff as n,
  E2 as o,
  e3 as p,
  ui as q,
  c3 as r,
  j0 as s,
  $3 as t,
  ZS as u,
  N3 as v,
  T3 as w,
  Go as x,
  Bn as y,
  Wo as z
};
